import { Button, InputNumber, Switch, message, Tooltip, Modal, Spin, Dropdown, Space, AutoComplete, Segmented } from "antd";
import Alert from '@iso/components/Feedback/Alert';
import axios from 'axios';
import Input from './ApplicationBasicDetails.styles';
import { Label } from "../UsersCRUD/UsersCRUD.styles";
import Select from './Deployment.styles';
import {
    SelectOption as Option,
} from '@iso/components/uielements/select';
import { Link, Navigate, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
// import { Checkbox } from 'antd';
// import { Checkbox } from 'antd';
import { useContext, useEffect, useState, useRef, lazy, Suspense, memo } from "react";
import { DeploymentContext } from "../../context/deploymentContext";
// import { Scrollbars } from 'react-custom-scrollbars-2';
// import { Scrollbars } from 'react-custom-scrollbars-2';
import { ACM_CREATE_NEW, acmZoneMismatch, customFilterOption, customSortOptions, deepClonePreservingUndefined, formatErrors, handleYAMLError, normalizeDomain, validateYaml, yamlErrorList } from "../../context/helper";
import api from "../../api";
import Box from "@iso/components/utility/box";
import downIcon from '../../assets/images/downArrow.svg';
// import EnvironmentVariablesDep from './EnvironmentVariablesDep';
import deleteIcon from '../../assets/images/deleteIcon.svg';
import ContentHolder from '@iso/components/utility/contentHolder';
import upIcon from '../../assets/images/upArrow.svg';
import { CloseOutlined, DownOutlined, PlusOutlined, RightOutlined, UpOutlined, WarningFilled } from '@ant-design/icons';
// import { setNestedObjectValues } from "formik";
import { AlertContext } from "../../context/alertContext";
import { validateName, validateSpaces } from "../../context/helper";
// import { InfoCircleFilled } from '@ant-design/icons';
// import { InfoCircleFilled } from '@ant-design/icons';
import { FormWrapper as Form } from './ApplicationBasicDetails.styles.js';
import { BreadcrumbContext } from "../../context/breadcrumbContext";
import { RefreshLoader } from "../Dashboard/CustomComponents/RefreshLoader.style";
import refreshIcon from '../../assets/images/retriggerIcon.svg';
import { AppContext } from "../../context/ContextProvider";
import CustomInfoTooltip from "../Dashboard/CustomComponents/CustomInfoTooltip";
import { deploymentHelpChecks } from "./deploymentHelpChecks";
import { LoadingOutlined } from '@ant-design/icons';
import Card from "../UIElements/Card/Card.styles.js";
// import { CustomModal } from "../Dashboard/CustomComponents/PageLoader.style.js";
import { CustomAlert } from "../Dashboard/CustomComponents/CustomAlert";
import { useMemo } from "react";
import fileIcon from '@iso/assets/images/yamlDropdown.svg';
import fileIconSelected from '@iso/assets/images/yamlDropdownSelected.svg';
import awsSecretManagerLogo from '@iso/assets/images/aws_secret_manager.svg';
import gcpSecretManagerLogo from '@iso/assets/images/gcp_secret_manager.png';
// import { yamlContent } from "../../context/yamlContent.js";
import useDebounce from "../Dashboard/CustomHooks/useDebounce.js";
// import { set } from "date-fns";
import { useApiFormError } from "../Dashboard/CustomHooks/useApiFormError.js";
import SecretManagerModal from "../Projects/SecretManagerModal.js";
// import { CustomAlert } from "../Dashboard/CustomComponents/CustomAlert.js";
const CodeViewGeneral = lazy(() => import("../Clusters/Task/CodeViewGeneral.js"));
const EnvironmentVariablesDep = lazy(() => import("./EnvironmentVariablesDep.js"));



// const { confirm } = Modal;

const { TextArea } = Input;

// let hzLineStyle = {
//     width: "180px",
//     borderInline: "0",
//     borderBottom: "0",
//     borderTop: "2px #DAEEFF dotted",
// };

// let plusImgStyle = {
//     width: "15px",
//     height: "15px",
//     position: "absolute",
//     left: "50%",
//     zIndex: "1",
//     background: "white",
// };

// let pipelineImgStyle = {
//     width: "80px",
//     height: "80px",
// };

const marginsBot = {
    position: 'fixed',
    opacity: '100%',
    transition: 'all 1s ease',
    top: "7vw",
    right: "0",
    zIndex: '1000',
    width: "25%",
    padding: '15px'
};

const fadeMarginBot = {
    position: 'fixed',
    opacity: '0',
    transition: 'all 1s ease',
    top: "7vw",
    right: "0",
    zIndex: '-1',
    width: "25%",
    padding: '15px'
};


let innerTitleStyle = {
    color: "#132f44",
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "16px"
};

const headLabelStyle = {
    fontFamily: "Poppins",
    fontSize: "16px",
    color: "#1f1f1f",
    fontWeight: "500",
};
const labelStyle = {
    fontFamily: "Poppins",
    fontSize: "14px",
    color: "#1f1f1f",
    fontWeight: "500",
};

const subLabelStyle = {
    fontFamily: "Poppins",
    fontSize: "14px",
    color: "#292929",
};

const subDivStyle = {
    paddingLeft: "10px",
    display: "flex",
    flexDirection: "column"
}

const inputStyle = {
    height: "44px"
}

const fieldStyles = {
    width: "47%",
    display: "flex",
    flexDirection: "column",
}

const detailSubTextStyle = {
    fontFamily: "Nunito Sans",
    fontSize: "14px",
    fontWeight: "400",
    marginLeft: "25px"
}

let secretTitleStyle = {
    color: "#1f1f1f",
    fontFamily: "Poppins",
    fontSize: "12px",
    marginTop: "4px"
};

const compareProps = (prevProps, nextProps) => {
    console.log("Prev and next: ", prevProps, nextProps, prevProps.serviceSelected.isActive, nextProps.serviceSelected.isActive);
    if (prevProps.serviceSelected.isActive !== nextProps.serviceSelected.isActive) {
        return false;
    }
    else if (prevProps.containerRegs.length !== nextProps.containerRegs.length) {
        return false;
    }
    else if (prevProps.nodeGroupList.join() !== nextProps.nodeGroupList.join()) {
        return false;
    }
    else if (prevProps.refreshNodegroups !== nextProps.refreshNodegroups) {
        return false;
    }
    else if ((prevProps.serviceHighlighted?.id !== nextProps.serviceHighlighted?.id) || (prevProps.serviceHighlighted?.service_id !== nextProps.serviceHighlighted?.service_id)) {
        return false;
    }
    else if (prevProps.lastEnabledService !== nextProps.lastEnabledService) {
        return false;
    }
    else if (prevProps.cloneFetched !== nextProps.cloneFetched) {
        return false;
    }
    else if (prevProps.updateFetched !== nextProps.updateFetched) {
        return false;
    }
    else if (prevProps.toggleChanged !== nextProps.toggleChanged) {
        return false;
    }
    else if (prevProps.generateImpField !== nextProps.generateImpField) {
        return false;
    }
    else if (prevProps.dnsList.join() !== nextProps.dnsList.join()) {
        return false;
    }
    return true;
}

export default memo(({ serviceIdx, generateImpField, setGenerateImpField,
    serviceHighlighted, toggleChanged,
    updateFetched, handleSaveAndNextImp,
    cloneFetched, nodeGroupList,
    lastEnabledService, handleSaveAndNext,
    serviceSelected, setServiceSelected,
    percentCompleted, setPercentCompleted,
    keySelected,
    redirectToNext, refreshNodegroups,
    setRefreshNodegroups,
    handlePrevBtn, containerRegs, setContainerRegs,
    dnsList, setDnsList
}) => {
    console.log("Service selected: ", serviceSelected);

    const { addDep, addUpdatedData, setAddUpdatedData, sampleEnvData, updateDep, setUpdateDep, updatedData, setUpdatedData, handleImportantFields, impFieldConvert, setNextBtn, importantFields, importantEnabled, formErrors, setFormErrors, submitAll, setSubmitAll, deploymentData, applicationData, setApplicationData, selectedProject, containerRegistries, cloneDeploymentData, cloneApplicationData, setCloneApplicationData, cloneContainerRegistries, cloneDep, initialApplicationData, dataSourcesData, mongoDataSourcesData, postgresDataSourcesData, redisData, cloneDataSourcesData, cloneMongoDataSourcesData, clonePostgresDataSourcesData, cloneRedisData, handleSubmit, selectedEnv, serviceCategories, cloneServiceCategories, deploymentForms, setDeploymentForms, nextBtn, prevBtn, setPrevBtn, prerequisite, setPrerequisite, setIsSubmitted, setPrevImportantField, setCurrentImportantField, setNextImportantField, warnings, setSampleEnvData, editServiceDataChanged, setEditServiceDataChanged, currentProjectDep, setCurrentProjectDep } = useContext(DeploymentContext);
    const [appData, setAppData] = useState({ ...initialApplicationData });
    const { pageHeading } = useContext(BreadcrumbContext);
    console.log("Initial Application Data", applicationData, initialApplicationData, cloneApplicationData, addUpdatedData);
    const [repoList, setRepoList] = useState([]);
    const [valueFromDropdown, setValueFromDropdown] = useState();
    const [agentList, setAgentList] = useState([]);

    // Memoize account details from the current service task
    const currentTaskAccountDetails = useMemo(() => {
        return currentProjectDep?.tasks?.[serviceIdx]?.accountDetails;
    }, [currentProjectDep?.tasks, serviceIdx]);

    // console.log("currentTaskAccountDetails :", currentTaskAccountDetails);

    const [containerRegistryList, setContainerRegistryList] = useState([]);
    const depData = updateDep ? { ...updatedData.deploymentData } : addDep ? { ...addUpdatedData.deploymentData } : (!cloneDep ? { ...deploymentData } : { ...cloneDeploymentData });

    const isImportedNoCloud = (depData?.provisioner === 'imported' && (!depData?.clusterAccount || depData?.clusterAccount === ''));

    const [switchState, setSwitchState] = useState({
        customDomain: "false",
        configure: "false",
        createStorage: "false",
        secretsEnabled: "false",
        autoScaling: "false"
    });
    const [volumeClasses, setVolumeClasses] = useState([]);
    const [removeIcon, setRemoveIcon] = useState(true);
    const [collapsedShowYamlAlert, setCollapsedShowYamlAlert] = useState(false);
    const [removeVolumeIcon, setRemoveVolumeIcon] = useState(true);
    const [depColor, setDepColor] = useState({
        services: true,
        resources: false,
        taskSchedulers: false,
        tags: false,
        volumes: false,
    });
    const buttonRef1 = useRef(null);
    // const [optionsSelected, setOptionsSelected] = useState({
    //     basicDetails: false,
    //     envVars: false,
    //     volumes: false,
    //     deployments: false
    // });

    const [deploymentTypes, setDeploymentTypes] = useState([]);
    const [serviceTypes, setServiceTypes] = useState([]);
    const [selectedServiceTypes, setSelectedServiceTypes] = useState([]);
    const [servicePreferences, setServicePreferences] = useState([]);
    const [volumeTypes, setVolumeTypes] = useState([]);
    const [error, setError] = useState("");
    // const [serviceData, setServiceData] = useState([]);
    const [defaultValues, setDefaultValues] = useState(false);
    const [form] = Form.useForm();
    const [initialFormData, setInitialFormData] = useState(null);
    const [initialEnvData, setInitialEnvData] = useState(null);
    const [initialAccountDetails, setInitialAccountDetails] = useState(null);
    const { setApiError, hasApiError, customApiValidator, clearApiError } = useApiFormError(form);

    const { alertOptions, set_alertOptions } = useContext(AlertContext);
    const { setOpenModel, setOpenRightDrawer, setTooltip } = useContext(AppContext);
    const [nodeGroups, setNodeGroups] = useState([]);
    const targetRef = useRef(null);
    const autoCompleteRef = useRef(false);
    const lastProcessedServiceDataRef = useRef(null);
    const [executeEnvs, setExecuteEnvs] = useState(false);
    const [afterRefresh, setAfterRefresh] = useState(false);
    //const [prefixCheck, setPrefixCheck] = useState(false);
    let location = useLocation();
    let navigate = useNavigate();
    const [allOptions, setAllOptions] = useState({
        basicDetails: true,
        envVars: true,
        deployments: true,
        advancedSettings: false
    });
    // const prerequisiteRef = useRef(false);
    const [errorVars, setErrorVars] = useState(0);
    const [newVars, setNewVars] = useState(0);
    const [branchLoad, setBranchLoad] = useState(true);
    const [dnsMsg, setDnsMsg] = useState({
        error: false,
        msg: ""
    });
    const [validateDomainStatus, setValidateDomainStatus] = useState("");
    const [acmCerts, setAcmCerts] = useState([]);
    const [imageTagList, setImageTagList] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [showBuildTimeNotification, setShowBuildTimeNotification] = useState(true);
    const [yamlData, setYamlData] = useState("");
    const [yamlLabelWarning, setYamlLabelWarning] = useState(false);
    const [imageTagLoading, setImageTagLoading] = useState(true);
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [validatingRepo, setValidatingRepo] = useState(false);
    const [isNodegroupValidationInProgress, setIsNodegroupValidationInProgress] = useState(false);
    const warningsRef = useRef([]);
    const appDataUpdateRef = useRef(false);
    const prevAppDataRef = useRef(null);
    const formSetForAddDepRef = useRef(false);
    const formSetForUpdateDepRef = useRef(null);
    const volList = Form.useWatch('volumeList', form);
    console.log("vol list:::", volList)
    // const [isFormSet, setIsFormSet] = useState(false);

    //let totalFieldsFilled = 0;


    // Normalizes environment variables from object format to array format
    const normalizeEnvVarsToArray = (environmentVariables) => {
        if (!environmentVariables) return [];
        // Already in the expected array form
        if (Array.isArray(environmentVariables)) return environmentVariables;

        // Legacy object form: { KEY: { type, value, is_secret, depend_on, ... } }
        if (typeof environmentVariables === "object") {
            return Object.keys(environmentVariables).map((key) => {
                const v = environmentVariables[key] || {};
                return {
                    value: v.value ?? "",
                    is_secret: !!v.is_secret,
                    key,
                    value_depend_on: v.depend_on ?? null,
                    is_synced: !!v.is_synced,
                    is_for_build_time: !!v.is_for_build_time,
                    is_for_run_time: !!v.is_for_run_time,
                    is_delete_from_atmosly: !!v.is_delete_from_atmosly,
                    is_delete_from_secret_manager: !!v.is_delete_from_secret_manager
                };
            });
        }
        return [];
    };

    // Helper to map env vars from backend format to frontend format
    const mapEnvVarsToFrontend = (envs = []) => {
        if (!Array.isArray(envs)) return [];
        return envs.map((e) => ({
            key: e.key ?? "",
            value: e.value ?? "",
            value_depend_on: e.value_depend_on ?? null,
            value_from: e.value_from ?? "",
            is_secret: !!e.is_secret,
            is_synced: !!e.is_synced,
            is_for_build_time: !!e.is_for_build_time,
            is_for_run_time: !!e.is_for_run_time,
            is_delete_from_atmosly: !!e.is_delete_from_atmosly,
            is_delete_from_secret_manager: !!e.is_delete_from_secret_manager,
            error: false,
            isNew: false,
        }));
    };

    const setAppFromEnv = (envs, secret_name, fromGetApi) => {
        console.log("This sets envs: ", envs, appData);
        appDataUpdateRef.current = true; // Mark that appData should be updated
        // Don't overwrite environments if incoming array is empty and we already have environments
        // Use functional update to access current appData state
        setAppData(currentAppData => {
            const finalEnvs = (Array.isArray(envs) && envs.length > 0) ? envs : 
                             (currentAppData?.environments && currentAppData.environments.length > 0) ? currentAppData.environments : 
                             envs;
            console.log("setAppFromEnv - preserving envs:", { incoming: envs.length, existing: currentAppData?.environments?.length || 0, final: finalEnvs.length });
            return {
                ...currentAppData,
                // secret_name: secret_name,
                environments: finalEnvs
            };
        });

        if (fromGetApi && updateDep) {
            setSampleEnvData(sampleEnvData => ({
                ...sampleEnvData,
                applicationData: {
                    ...sampleEnvData.applicationData,
                    [serviceSelected.name]: {
                        ...sampleEnvData.applicationData[serviceSelected.name],
                        // secret_name: secret_name,
                        environments: envs
                    }
                }
            }));
            const mySampleData = JSON.parse(localStorage.getItem("sampleEnvData")) ? JSON.parse(localStorage.getItem("sampleEnvData")) : {};
            console.log("Setting env data: ", mySampleData);
            localStorage.setItem("sampleEnvData", JSON.stringify({
                ...mySampleData,
                applicationData: {
                    ...mySampleData.applicationData,
                    [serviceSelected.name]: {
                        ...mySampleData.applicationData[serviceSelected.name],
                        // secret_name: secret_name,
                        environments: envs
                    }
                }
            }));
        }
    }


    // const calculateBasicFieldsFilled = (appData) => {
    //     return Object.values(appData.basicDetails).filter((val) => {
    //         if ((typeof val === 'string' && val !== "") || (typeof val === 'object' && Object.keys(val).length > 0)) {
    //             return 1;
    //         }
    //     }).length;
    // }

    //console.log("Filled values basic", calculateBasicFieldsFilled(appData));

    // useEffect(() => {
    //     console.log("Basic details percent: ", (calculateBasicFieldsFilled(appData) / (Object.keys(appData.basicDetails).length)) * 100);
    //     setPercentCompleted({
    //         ...percentCompleted,
    //         application: {
    //             ...percentCompleted.application,
    //             basicDetails: (calculateBasicFieldsFilled(appData) / (Object.keys(appData.basicDetails).length)) * 100
    //         }
    //     });
    // }, [appData]);

    //Progress bar
    // useEffect(() => {
    //     let ctr1, ctr2, ctr3, ctr4 = 0;
    //     Object.values(appData.basicDetails).map((val) => {
    //         if(val){
    //             console.log("Inner basic", ctr1);
    //             ctr1++;
    //         }
    //     });
    //     console.log("Filled values basic", ctr1);
    // }, [appData]);

    //Option selected(Basic Details, Env Vars,...)
    // useEffect(() => {
    //     console.log("My option selected", allOptions.application);
    //     setOptionsSelected({ ...allOptions.application });
    // }, [allOptions]);


    const loadImages = () => {
        if (appData.basicDetails?.imageRepo && appData.basicDetails?.imageRepo !== "" && appData.basicDetails?.appSource !== "PUBLIC") {
            setImageTagLoading(true);
            api.get(`/api/integration/images/${appData.basicDetails?.appSource?.id}/${appData.basicDetails?.imageRepo}/`).then((res) => {
                let data = res.data;
                if (data.status) {
                    let imageTags = [];
                    data.data.forEach((val) => {
                        imageTags.push(
                            <Option key={val} value={val} name="imageTag">{val}</Option>
                        );
                    });
                    setImageTagList(imageTags);
                }
                else {
                    console.log("Error");
                }
            }).catch((err) => {
                console.log("Error");
            }).finally(() => {
                setImageTagLoading(false);
            });
        }
    }

    useEffect(() => {
        if ((!cloneDep && !updateDep && !addDep ? serviceHighlighted.id === serviceSelected.id : serviceHighlighted.service_id === serviceSelected.service_id) && appData?.basicDetails?.sourceType === "Container Registry" && imageTagList.length === 0 && containerRegs.length > 0 && appData.basicDetails?.appSource?.id) {
            loadImages();
        }
    }, [appData?.basicDetails?.imageRepo, appData.basicDetails?.appSource, appData?.basicDetails?.sourceType, serviceHighlighted.id, serviceHighlighted.service_id, containerRegs]);

    useEffect(() => {
        if (appData?.basicDetails?.sourceType === "Container Registry" && appData?.basicDetails?.imageRepo !== "" && imageTagList.length > 0) {
            loadImages();
        }
    }, [appData?.basicDetails?.imageRepo, appData?.basicDetails?.sourceType]);

    useEffect(() => {
        if (updateDep && appData?.basicDetails?.url && serviceSelected?.configuration?.account_id && appData.serviceEnabled) {
            api.post(`${process.env.REACT_APP_API_URI}/api/integration/vcs/check-repos/`, {
                account_id: serviceSelected?.configuration?.account_id,
                repo_name: appData?.basicDetails?.url?.split("/").filter(Boolean).slice(-1)[0].split(".git")[0]
            }).then((res) => {
                let data = res.data;
                if (data.status) {
                    toggleAlert("success", "Success", "Repository validated successfully.", 1000);
                    clearApiError("url");
                }
                else {
                    const err = formatErrors(data.error_details);
                    setApiError("url", err);
                }
            }).catch((err) => toggleAlert("error", "Error", "Something went wrong. Please try again."))
                .finally(() => setValidatingRepo(false));
        }
    }, [updateDep, appData?.basicDetails?.url, appData.serviceEnabled]);

    useEffect(() => {
        if (updateDep && appData?.basicDetails?.url && serviceSelected?.configuration?.account_id && appData.serviceEnabled) {
            api.post(`${process.env.REACT_APP_API_URI}/api/integration/vcs/check-repos/`, {
                account_id: serviceSelected?.configuration?.account_id,
                repo_name: appData?.basicDetails?.url?.split("/").filter(Boolean).slice(-1)[0].split(".git")[0]
            }).then((res) => {
                let data = res.data;
                if (data.status) {
                    toggleAlert("success", "Success", "Repository validated successfully.", 1000);
                    clearApiError("url");
                }
                else {
                    const err = formatErrors(data.error_details);
                    setApiError("url", err);
                }
            }).catch((err) => toggleAlert("error", "Error", "Something went wrong. Please try again."))
                .finally(() => setValidatingRepo(false));
        }
    }, [updateDep, appData?.basicDetails?.url, appData.serviceEnabled]);

    // Debounced check: disable Re-deploy when any labels: key uses the reserved "atmosly_app" prefix
    useEffect(() => {
        if (appData?.deployments?.deploymentOption !== "yaml") {
            setYamlLabelWarning(false);
            return;
        }
        const timer = setTimeout(() => {
            const lines = (yamlData || "").split('\n');
            let inLabels = false;
            let labelsIndent = -1;
            let found = false;
            for (const line of lines) {
                if (found) break;
                const trimmed = line.trimStart();
                const currentIndent = line.length - trimmed.length;
                if (trimmed === '') continue;
                if (trimmed.match(/^labels\s*:/)) {
                    inLabels = true;
                    labelsIndent = currentIndent;
                    continue;
                }
                if (inLabels) {
                    if (currentIndent <= labelsIndent) {
                        inLabels = false;
                        labelsIndent = -1;
                        if (trimmed.match(/^labels\s*:/)) {
                            inLabels = true;
                            labelsIndent = currentIndent;
                        }
                    } else {
                        const keyMatch = trimmed.match(/^([^\s:]+)\s*:/);
                        if (keyMatch && keyMatch[1].startsWith('atmosly_app')) {
                            found = true;
                        }
                    }
                }
            }
            setYamlLabelWarning(found);
        }, 600);
        return () => clearTimeout(timer);
    }, [yamlData, appData?.deployments?.deploymentOption]);

    useEffect(() => {
        console.log("Branch api: ", repoList, serviceHighlighted, appData.basicDetails.sourceType, !cloneDep && !updateDep && !addDep ? serviceHighlighted.id === serviceSelected.id : serviceHighlighted.service_id === serviceSelected.service_id && repoList.length === 0 && repoList.length);
        if ((!cloneDep && !updateDep && !addDep ? serviceHighlighted.id === serviceSelected.id : serviceHighlighted.service_id === serviceSelected.service_id)
            && repoList.length === 0) {
            if (appData.basicDetails.sourceType === "Git Repositories") {
                console.log("scrolled: ", JSON.parse(JSON.stringify(serviceSelected)));
                if (Object.keys(serviceSelected).length > 0) {
                    if (serviceSelected.type === "application" || serviceSelected.service_type === "application") {
                        if (serviceSelected.configuration.account_id === null || serviceSelected.configuration.account_id === "") {
                            console.log("Public service: ", serviceSelected);
                            let rawData = serviceSelected.configuration.repo_url.split("/");
                            let owner = rawData[3];
                            let repoName = rawData[4];
                            if (repoName) {
                                if (repoName.includes('.git')) {
                                    repoName = repoName.split(".git")[0];
                                }
                            }
                            if (serviceSelected.configuration.repo_url.includes("github")) {
                                fetch(`https://api.github.com/repos/${owner}/${repoName}/branches`)
                                    .then(async (res) => await res.json())
                                    .then((data) => {
                                        console.log('branches data :', data);
                                        if (data.type !== "error") {
                                            if (data.message) {
                                                console.log("Please provide correct url");
                                            }
                                            else {
                                                let branches = [];
                                                data.map((temp, ind) => {
                                                    branches.push(
                                                        <Option key={ind} name="branch" value={temp.name}>
                                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "Center" }}>
                                                                <span>{temp.name}</span>
                                                            </div>
                                                        </Option>
                                                    );
                                                });
                                                setRepoList(branches);
                                            }
                                        }
                                        else {
                                            toggleAlert("Error", "Error", data.error?.message);
                                        }
                                        setBranchLoad(false);
                                    })
                                    .catch((error) => {
                                        console.error('Error fetching branches:', error);
                                        setBranchLoad(false);
                                    });
                            }
                            else if (serviceSelected.configuration.repo_id) {
                                // GitLab instance details
                                let gitlabInstance = `https://${rawData[2]}`;
                                let projectPath = `${owner}%2F${repoName}`;

                                fetch(`${gitlabInstance}/api/v4/projects/${projectPath}/repository/branches`)
                                    .then(async (res) => await res.json())
                                    .then((data) => {
                                        console.log('branches data :', data);
                                        if (data.type !== "error") {
                                            if (data.message) {
                                                console.log("Please provide correct url");
                                            }
                                            else {
                                                let branches = [];
                                                data.map((temp, ind) => {
                                                    branches.push(
                                                        <Option key={ind} name="branch" value={temp.name}>
                                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "Center" }}>
                                                                <span>{temp.name}</span>
                                                            </div>
                                                        </Option>
                                                    );
                                                });
                                                setRepoList(branches);
                                            }
                                        }
                                        else {
                                            toggleAlert("Error", "Error", data.error?.message);
                                        }
                                        setBranchLoad(false);
                                    })
                                    .catch((error) => {
                                        console.error('Error fetching branches:', error);
                                        setBranchLoad(false);
                                    });
                            }
                            else if (serviceSelected.configuration.repo_url.includes("bitbucket")) {
                                fetch(`https://api.bitbucket.org/2.0/repositories/${owner}/${repoName}/refs/branches?sort=-target.date`)
                                    .then(async (res) => await res.json())
                                    .then((data) => {
                                        console.log('branches data :', data);
                                        if (data.type !== "error") {
                                            if (data.message) {
                                                console.log("Please provide correct url.");
                                            }
                                            else {
                                                let branches = [];
                                                data.map((temp, ind) => {
                                                    branches.push(
                                                        <Option key={ind} name="branch" value={temp.name}>
                                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "Center" }}>
                                                                <span>{temp.name}</span>
                                                            </div>
                                                        </Option>
                                                    );
                                                });
                                                setRepoList(branches);
                                            }
                                        }
                                        else {
                                            toggleAlert("Error", "Error", data.error?.message);
                                        }
                                    })
                                    .catch((error) => {
                                        console.error('Error fetching branches:', error);
                                    });
                            }
                            else {
                                // GitLab instance details
                                let gitlabInstance = `https://${rawData[2]}`;
                                let projectPath = `${owner}%2F${repoName}`;

                                fetch(`${gitlabInstance}/api/v4/projects/${projectPath}/repository/branches`)
                                    .then(async (res) => {
                                        let data = await res.json();
                                        if (data.type !== "error") {
                                            if (data.message) {
                                                console.log("Please provide correct url");
                                            }
                                            else {
                                                let branches = [];
                                                data.map((temp, ind) => {
                                                    branches.push(
                                                        <Option key={ind} name="branch" value={temp.name}>
                                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "Center" }}>
                                                                <span>{temp.name}</span>
                                                            </div>
                                                        </Option>
                                                    );
                                                });
                                                setRepoList(branches);
                                            }
                                        }
                                        else {
                                            toggleAlert("Error", "Error", data.error?.message);
                                        }
                                        setBranchLoad(false);
                                    }).catch((error) => {
                                        console.error('Error fetching branches:', error);
                                        setBranchLoad(false);
                                    });
                            }
                        }
                        else {
                            console.log("serviceSelected: ", JSON.parse(JSON.stringify(serviceSelected)));
                            api.post(process.env.REACT_APP_API_URI + '/api/integration/vcs/branch/', {
                                account_id: serviceSelected.configuration.account_id,
                                repo_name: serviceSelected.configuration.repo_name
                            }).then((res) => {
                                let data = res.data;
                                if (!data.status) {
                                    let err = formatErrors(data.error_details);
                                    // toggleAlert("error", "Error", err);
                                    setApiError("branch", err);
                                    // alert(`Error: ${err}`);
                                }
                                else if (data.code !== 200) {
                                    // alert(`Error: Please provide correct repo url!`);
                                }
                                else {
                                    let branches = [];
                                    data.data.map((temp, ind) => {
                                        branches.push(
                                            <Option key={ind} name="branch" value={temp}>
                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "Center" }}>
                                                    <span>{temp}</span>
                                                </div>
                                            </Option>
                                        );
                                    });
                                    setRepoList(branches);
                                    clearApiError("branch");
                                }
                                setBranchLoad(false);
                            });
                        }
                    }
                    setError({
                        status: false,
                        msg: ""
                    })
                }
            }
        }
    }, [serviceHighlighted.id, serviceHighlighted.service_id, appData.basicDetails.sourceType, repoList.length, serviceSelected?.configuration?.account_id]);
    // useEffect(() => {
    //     form.validateFields().then((values) => {
    //         console.log("Validated");
    //     }).catch((errorInfo) => {
    //         // Handle form validation errors
    //         console.log(errorInfo);
    //     });    }, []);

    useEffect(() => {
        let containers = [];
        containerRegs.map((child, ind) => {
            const label = !child.account_id ? `${child.alias} - ${child?.integration_type}` : `${child.account_id}${child.alias && `(${child.alias})`} / ${child.region}`;
            containers.push(
                <Option key={child.alias + ind + '!'} name={"containerRegistryId"} data-id={child.id} data-region={child.region} data-label={label} value={child.id}>
                    <div style={{ width: "100%", display: "flex", justifyContent: "start", alignItems: "center", paddingTop: "0px" }}>
                        <img src={child.integration_logo} style={{ width: "15px", height: "15px", marginRight: "10px", alignSelf: "center" }} />
                        <p> {label} </p>
                    </div>
                </Option>
            );
        });
        setContainerRegistryList(containers);
    }, [containerRegs]);

    // When the stored container_registry_id is not present in the active registries list
    // (because the integration was soft-deleted), probe the backend for the deletion
    // reason and surface it as a field-level error.
    useEffect(() => {
        const storedId = serviceSelected?.configuration?.container_registry_id;
        if (!storedId) return;
        const matched = containerRegs.find(r => String(r.id) === String(storedId));
        if (matched) {
            clearApiError("containerRegistryId");
            return;
        }
        api.get(`/api/integration/repositories/${storedId}/`).then((res) => {
            if (!res.data?.status) {
                const err = formatErrors(res.data?.error_details);
                setApiError("containerRegistryId", err);
            }
        }).catch(() => {});
    }, [serviceSelected?.configuration?.container_registry_id, containerRegs]);

    useEffect(() => {
        let types = ["Cluster IP", "Public Load Balancer", /*"Private Load Balancer", "Public Ingress", "Private Ingress"*/];
        let typeOptions = [];
        types.map((child) => {
            typeOptions.push(
                <Option key={child} name={"endpointType"} value={child}>
                    <p>{child}</p>
                </Option>);
        });
        setDeploymentTypes(typeOptions);
    }, []);

    useEffect(() => {
        //let types = [deploymentData.ingressAlbEnabled && "Existing Load Balancer(ALB Ingress)", deploymentData.ingressNginxEnabled && "Existing Load Balancer(Nginx Ingress)", "Dedicated Load Balancer"];
        if (addDep) {
            let types = [];
            if (addUpdatedData.deploymentData.ingressAlbEnabled) {
                types.push("Existing Load Balancer(ALB Ingress)");
            }
            if (addUpdatedData.deploymentData.ingressNginxEnabled) {
                types.push("Existing Load Balancer(Nginx Ingress)");
            }
            types.push("Dedicated Load Balancer");

            let serviceTypeOptions = [];
            types.map((child) => {
                serviceTypeOptions.push(
                    <Option key={child} name={"serviceType"} value={child}>
                        <p>{child}</p>
                    </Option>);
            });
            setServiceTypes(serviceTypeOptions);
            setSelectedServiceTypes(types);
        }
        else if (updateDep) {
            let types = [];
            if (updatedData.deploymentData.ingressAlbEnabled) {
                types.push("Existing Load Balancer(ALB Ingress)");
            }
            if (updatedData.deploymentData.ingressNginxEnabled) {
                types.push("Existing Load Balancer(Nginx Ingress)");
            }
            types.push("Dedicated Load Balancer");

            let serviceTypeOptions = [];
            types.map((child) => {
                serviceTypeOptions.push(
                    <Option key={child} name={"serviceType"} value={child}>
                        <p>{child}</p>
                    </Option>);
            });
            setServiceTypes(serviceTypeOptions);
            setSelectedServiceTypes(types);
        }
        else if (!cloneDep) {
            let types = [];
            if (deploymentData.ingressAlbEnabled) {
                types.push("Existing Load Balancer(ALB Ingress)");
            }
            if (deploymentData.ingressNginxEnabled) {
                types.push("Existing Load Balancer(Nginx Ingress)");
            }
            types.push("Dedicated Load Balancer");

            console.log("MY TYPES: ", types, deploymentData.ingressAlbEnabled, deploymentData.ingressNginxEnabled);
            let serviceTypeOptions = [];
            types.map((child) => {
                serviceTypeOptions.push(
                    <Option key={child} name={"serviceType"} value={child}>
                        <p>{child}</p>
                    </Option>);
            });
            setServiceTypes(serviceTypeOptions);
            setSelectedServiceTypes(types);
        }
        else {
            let types = [];
            if (cloneDeploymentData.ingressAlbEnabled) {
                types.push("Existing Load Balancer(ALB Ingress)");
            }
            if (cloneDeploymentData.ingressNginxEnabled) {
                types.push("Existing Load Balancer(Nginx Ingress)");
            }
            types.push("Dedicated Load Balancer");

            console.log("MY TYPES: ", types, deploymentData.ingressAlbEnabled, deploymentData.ingressNginxEnabled);
            let serviceTypeOptions = [];
            types.map((child) => {
                serviceTypeOptions.push(
                    <Option key={child} name={"serviceType"} value={child}>
                        <p>{child}</p>
                    </Option>);
            });
            setServiceTypes(serviceTypeOptions);
            setSelectedServiceTypes(types);
        }
    }, []);

    useEffect(() => {
        if(appData?.deployments?.serviceType && !selectedServiceTypes.includes(appData?.deployments?.serviceType)) {
            console.log("defined service type does not exist in dropdown/cluster :", appData.deployments.serviceType);
            setAppData(appData => ({
                ...appData,
                deployments: {
                    ...appData.deployments,
                    serviceType: "",
                }
            }));

            form.setFieldsValue({
                'serviceType': "",
            });
        }
    }, [selectedServiceTypes, appData?.deployments?.serviceType]);

    useEffect(() => {
        let preferences = ["Compute", "Memory", "GPU"];
        let preferencesOptions = [];
        preferences.map((child) => {
            preferencesOptions.push(
                <Option key={child} name={"serverPreference"} value={child}>
                    <p> {child} </p>
                </Option>
            );
        });

        let pipelinesAgents = ["Alpine"];
        let pipelineAgentOptions = [];
        pipelinesAgents.map((child) => {
            pipelineAgentOptions.push(
                <Option key={child} name={"agentName"} value={child}>
                    <p> {child} </p>
                </Option>
            );
        });

        setServicePreferences(preferencesOptions);
        setAgentList(pipelineAgentOptions);
    }, []);

    useEffect(() => {
        let types = ["Configmap", "Storage", "Secrets"];
        let volumeOptions = [];
        types.map((child, ind) => {
            volumeOptions.push(
                <Option key={child} name="volumeType" value={child}>
                    <p> {child} </p>
                </Option>
            );
        });
        setVolumeTypes(volumeOptions);
    }, []);

    useEffect(() => {
        if (updateDep && refreshNodegroups) {
            setIsNodegroupValidationInProgress(true);
        }
    }, [updateDep, refreshNodegroups]);

    useEffect(() => {
        let arr = [];

        let arrSort = nodeGroupList ? nodeGroupList.sort((a, b) => (a.name.localeCompare(b.name))) : [];
        console.log("nodeGroupList in ApplicationBasicDetails :", arrSort)
        if (arrSort.length > 0) {
            arrSort.map((val) => {
                if (val.status === "Active" && val.managed_by > 0) {
                    const archLabel = (Array.isArray(val.arch_type) ? val.arch_type : [val.arch_type])
                        .filter(Boolean)
                        .map((a) => typeof a === "string" && a.toLowerCase().includes("arm") ? "ARM" : typeof a === "string" && a.toLowerCase().includes("amd") ? "AMD" : a)
                        .filter((v, i, self) => self.indexOf(v) === i)
                        .join(", ");
                    arr.push(
                        <Option key={val.nodegroup_unique_id} name="nodeGroupName" value={val.name} data-alias={val.nodegroup_type} data-arch={val.arch_type}>
                            <p> {val.name}{archLabel ? ` (${archLabel})` : ""} </p>
                        </Option>
                    );
                }

                // make default check
                if (val.status === "Active" && val.managed_by === 1) {
                    if ((!afterRefresh && !cloneDep && !updateDep) || (cloneDep && cloneDeploymentData.clusterId !== selectedEnv.cluster_unique_id) || (updateDep && updatedData.deploymentData.clusterId !== updatedData.selectedEnv.cluster_unique_id)) {
                        setAppData(appData => ({
                            ...appData,
                            deployments: {
                                ...appData.deployments,
                                nodeGroupName: val.name,
                                nodeGroupType: val.nodegroup_type,
                                multiselectNodeGroupList: [val.name],
                                listOfNodegroups: [{
                                    nodegroup_name: val.name,
                                    nodegroup_type: val.nodegroup_type,
                                    nodegroup_unique_id: val.nodegroup_unique_id,
                                    arch_type: val.arch_type
                                }],
                            }
                        }));
                        form.setFieldValue('nodeGroupName', val.name);
                    }
                }
            });
            //arr = arr.sort((a, b) => a.props.children.localeCompare(b.props.children));
            if (updateDep) {
                const availableNodegroupIds = new Set(
                    arrSort.filter((nodegroup) => nodegroup.status === "Active" && nodegroup.managed_by > 0).map((nodegroup) => nodegroup.nodegroup_unique_id)
                );
                const selectedNodegroups = Array.isArray(appData?.deployments?.listOfNodegroups) ? appData.deployments.listOfNodegroups : [];
                const validSelectedNodegroups = selectedNodegroups.filter((nodegroup) => availableNodegroupIds.has(nodegroup.nodegroup_unique_id));
                const removedNodegroupsCount = selectedNodegroups.length - validSelectedNodegroups.length;

                if (removedNodegroupsCount > 0) {
                    const updatedSelectedNodegroupNames = validSelectedNodegroups.map((nodegroup) => nodegroup.nodegroup_name);

                    setAppData((prev) => ({
                        ...prev,
                        deployments: {
                            ...prev.deployments,
                            nodeGroupName: updatedSelectedNodegroupNames,
                            listOfNodegroups: validSelectedNodegroups,
                        },
                    }));
                    form.setFieldValue("nodeGroupName", updatedSelectedNodegroupNames);
                    toggleAlert(
                        "warning",
                        "Nodegroup selection updated",
                        "One or more pre-selected nodegroups were deleted and removed from selection. Please review selected nodegroups."
                    );
                }
            }
            setNodeGroups(arr);
            if (updateDep) {
                setIsNodegroupValidationInProgress(false);
            }
        } else if (updateDep) {
            setIsNodegroupValidationInProgress(false);
        }
    }, [nodeGroupList]);

    useEffect(() => {
        let classes = [];
        if (depData.clusterIntegrationId === 1) {
            classes = [];
            if (depData.ebsEnabled) {
                classes.push("EBS");
            }
            if (depData.efsEnabled) {
                classes.push("EFS");
            }
        }
        else if (depData.clusterIntegrationId === 3) {
            classes = ["PD", "NFS", "Cloud File Store"];
        }
        let classesOptions = [];
        classes.map((child) => {
            classesOptions.push(
                <Option key={child} name="type" value={child}>
                    <p> {child} </p>
                </Option>
            );
        });
        setVolumeClasses(classesOptions);
    }, []);

    // useEffect(() => {
    //     console.log("changed nodegroups :", appData.deployments.nodeGroupName);

    // }, [appData.deployments.nodeGroupName]);

    //this useEffect helps us to set the values of the selected application in appData state. Initially the data in context is empty. So, we will assign the value of initialApplication data to appData.
    useEffect(() => {
        //if (executeSubForms) {
        //console.log("context app inner: ", applicationData[serviceSelected.name].basicDetails);
        // Reset form set flag when service changes
        if (formSetForAddDepRef.current && formSetForAddDepRef.current !== (serviceSelected.name || serviceSelected.service_name)) {
            formSetForAddDepRef.current = false;
        }
        if (formSetForUpdateDepRef.current && formSetForUpdateDepRef.current !== serviceSelected.name) {
            formSetForUpdateDepRef.current = null;
        }
        if (addDep) {
            const addServiceKey = serviceSelected.name || serviceSelected.service_name;
            const serviceData = addUpdatedData.applicationData?.[addServiceKey];
            console.log("Addupdated data: ", serviceData, "Form already set:", formSetForAddDepRef.current);
            // If data exists and has valid basicDetails, use it immediately
            if (serviceData && serviceData.basicDetails && serviceData.basicDetails.appName) {
                // Always update appData to ensure environments are set, even if form was already set
                const appDataToSet = JSON.parse(JSON.stringify({ ...serviceData }));
                // Ensure environments are properly formatted (array with objects that have 'key' property)
                if (appDataToSet.environments && Array.isArray(appDataToSet.environments)) {
                    // Filter out any invalid entries and ensure all have 'key' property
                    appDataToSet.environments = appDataToSet.environments.filter(env => env && env.key);
                    console.log("====AppData environments being set (filtered)====: ", appDataToSet.environments);
                } else if (appDataToSet.environments && typeof appDataToSet.environments === 'object' && !Array.isArray(appDataToSet.environments)) {
                    // If environments is an object, normalize it
                    const normalizedEnvs = normalizeEnvVarsToArray(appDataToSet.environments);
                    appDataToSet.environments = mapEnvVarsToFrontend(normalizedEnvs);
                    console.log("====AppData environments normalized from object====: ", appDataToSet.environments);
                } else {
                    console.warn("====Environments not in expected format, resetting to empty array====: ", appDataToSet.environments);
                    appDataToSet.environments = [];
                }
                
                // Only set form if we haven't already set it for this service
                if (!formSetForAddDepRef.current || formSetForAddDepRef.current !== addServiceKey) {
                let vols = [];
                let tags = [];
                serviceData.volumes?.map((val) => {
                    if (val.volumeType === "Configmap") {
                        vols.push({
                            'configName': val.config.configName,
                            'createMountPath': val.config.createMountPath,
                            'createConfig': val.config.createConfig,
                        });

                        setAllOptions((prev) => ({
                            ...prev,
                            advancedSettings: true,
                        }));
                    }
                    else if (val.volumeType === "Secrets") {
                        vols.push({
                            'secretsName': val.secrets.secretsName,
                            'createSecretsMountPath': val.secrets.createSecretsMountPath,
                            'createSecret': val.secrets.createSecretConfig,
                        });

                        setAllOptions((prev) => ({
                            ...prev,
                            advancedSettings: true,
                        }));
                    }
                    else if (val.volumeType === "Storage") {
                        vols.push({
                            'storageName': val.storage.storageDes.storageName,
                            'type': "EBS",//val.storage.storageDes.type, //Fixed to EBS for now
                            'path': val.storage.storageDes.path,
                            'size': val.storage.storageDes.size,

                        });

                        setAllOptions((prev) => ({
                            ...prev,
                            advancedSettings: true,
                        }));
                    }
                });
                serviceData.deployments?.tags?.map((val, idx) => {
                    tags.push({
                        'name': val.name,
                        'value': val.value
                    });
                });
                let labels = [];
                (addUpdatedData.applicationData[addServiceKey].deployments.labels || []).map((val, idx) => {
                    labels.push({
                        'name': val.name,
                        'value': val.value
                    });
                });
                const formValues = {
                        'appName': serviceData.basicDetails?.appName,
                        'url': serviceData.basicDetails?.url,
                        'sourceType': serviceData.basicDetails?.sourceType,
                        'appSource': serviceData.basicDetails?.sourceType === "Git Repositories" ? "" : !serviceData.basicDetails?.appSource?.integration_type ? "PUBLIC" : (!serviceData.basicDetails?.appSource?.account_id ? `${serviceData.basicDetails?.appSource?.alias} - ${serviceData.basicDetails?.appSource?.integration_type}` : `${serviceData.basicDetails?.appSource?.account_id}${serviceData.basicDetails?.appSource?.alias ? `(${serviceData.basicDetails?.appSource?.alias})` : ``} / ${serviceData.basicDetails?.appSource?.region}`),
                        'imageRepo': serviceData.basicDetails?.imageRepo,
                        'imageTag': serviceData.basicDetails?.imageTag === "" ? null : serviceData.basicDetails?.imageTag,
                        'branch': serviceData.basicDetails?.branch === "" ? null : serviceData.basicDetails?.branch,
                        'dockerFilePath': serviceData.basicDetails?.dockerFilePath,
                        'buildContext': serviceData.basicDetails?.buildContext,
                        'containerRegistryId': !serviceData.basicDetails?.containerRegistryId?.integration_type ? null : (!serviceData.basicDetails?.containerRegistryId?.account_id ? `${serviceData.basicDetails?.containerRegistryId?.alias} - ${serviceData.basicDetails?.containerRegistryId?.integration_type}` : `${serviceData.basicDetails?.containerRegistryId?.account_id}${serviceData.basicDetails?.containerRegistryId?.alias ? `(${serviceData.basicDetails?.containerRegistryId?.alias})` : ``} / ${serviceData.basicDetails?.containerRegistryId?.region}`),
                        'port': serviceData.deployments?.port,
                        'healthCheckPath': serviceData.deployments?.healthCheckPath,
                        'endpointType': serviceData.deployments?.endpointType === "" ? null : serviceData.deployments?.endpointType,
                        'requestCpu': serviceData.deployments?.resources?.cpu?.requestCpu,
                        'limitCpu': serviceData.deployments?.resources?.cpu?.limitCpu,
                        'requestMem': serviceData.deployments?.resources?.memory?.requestMem,
                        'limitMem': serviceData.deployments?.resources?.memory?.limitMem,
                        'minimumReplica': serviceData.deployments?.autoScaling?.autoScalingData?.minimumReplica,
                        'maximumReplica': serviceData.deployments?.autoScaling?.autoScalingData?.maximumReplica,
                        'cpuAuto': serviceData.deployments?.autoScaling?.autoScalingData?.autoScalingParameter?.cpuAuto,
                        'memoryAuto': serviceData.deployments?.autoScaling?.autoScalingData?.autoScalingParameter?.memoryAuto,
                        'nodeGroupName': !serviceData.deployments?.nodeGroupName ? null : serviceData.deployments?.nodeGroupName,
                        'volumeList': vols.length > 0 ? vols : [{}],
                        'tags': tags.length > 0 ? tags : [{}],
                        'labels': labels.length > 0 ? labels : [{}],
                        'serviceType': addUpdatedData.applicationData[addServiceKey].deployments.serviceType === "" ? null : addUpdatedData.applicationData[addServiceKey].deployments.serviceType,
                        'domainHostUrl': addUpdatedData.applicationData[addServiceKey].deployments.domainHostUrl,
                        'acmCertificate': addUpdatedData.applicationData[addServiceKey].deployments.acmCertificate,
                        'dns': addUpdatedData.applicationData[addServiceKey].deployments.dns,
                        'gPath': addUpdatedData.applicationData[addServiceKey].deployments.gatewayHttps.gPath,
                        'entryPointCommandQueues': addUpdatedData.applicationData[addServiceKey].deployments.taskSchedulers.entryPointCommandQueues,
                        'entryPointCommandCrons': addUpdatedData.applicationData[addServiceKey].deployments.taskSchedulers.entryPointCommandCrons,
                        'yamlData': addUpdatedData.applicationData[addServiceKey].deployments[addUpdatedData.applicationData[addServiceKey].deployments.yamlType].yamlString,
                        //'': applicationData[serviceSelected.name].volumes
                    };
                form.setFieldsValue(formValues);
                console.log("====Setting add updated data====: ", addUpdatedData);
                setAppData(appDataToSet);
                setYamlData(serviceData.deployments?.[serviceData.deployments?.yamlType]?.yamlString);
                setExecuteEnvs(true);
                setDefaultValues(true);
                formSetForAddDepRef.current = addServiceKey; // Mark form as set for this service
                }
                // Always update appData with environments, even if form was already set
                else {
                    // Form was already set, but we still need to update appData to ensure environments are set
                    // Preserve existing environments if new data doesn't have them (during API calls)
                    if (!appDataToSet.environments || appDataToSet.environments.length === 0) {
                        const existingEnvs = appData.environments && appData.environments.length > 0 ? appData.environments : [];
                        if (existingEnvs.length > 0) {
                            appDataToSet.environments = existingEnvs;
                            console.log("====Preserving existing environments during update====: ", existingEnvs);
                        }
                    }
                    setAppData(appDataToSet);
                    console.log("====Updating appData with environments (form already set)====: ", appDataToSet.environments);
                }
            }
            // If data doesn't exist yet, check if processing is complete
            else {
                // Only reset form if we haven't set it yet for this service
                // AND if we don't already have appData with environments (to prevent clearing during API calls)
                if ((!formSetForAddDepRef.current || formSetForAddDepRef.current !== addServiceKey) && 
                    (!appData.environments || appData.environments.length === 0)) {
                // If serviceData is true, processing is complete but no data for this service - use initial
                if (addUpdatedData.selectedProject?.serviceData) {
                    form.setFieldsValue({
                        'tags': [{}],
                        'labels': [{}],
                        'volumeList': [{}],
                        'yamlData': initialApplicationData.deployments[initialApplicationData.deployments.yamlType].yamlString,
                    });
                    setAppData(JSON.parse(JSON.stringify({ ...initialApplicationData })));
                    setYamlData(initialApplicationData.deployments[initialApplicationData.deployments.yamlType].yamlString);
                    setExecuteEnvs(true);
                    setDefaultValues(true);
                    }
                }
                // If serviceData is not set yet, data is still being processed - wait (don't set anything yet)
                // If form is already set and appData has environments, preserve them (don't reset)
            }
        }
        else if (updateDep) {
            console.log("Update called: ", updatedData, updateFetched);
            if (updateFetched) {
                if (updatedData.applicationData[serviceSelected.name]) {
                    // Only set form if we haven't already set it for this service
                    if (!formSetForUpdateDepRef.current || formSetForUpdateDepRef.current !== serviceSelected.name) {
                    let vols = [];
                    let tags = [];
                    console.log("Update data: ", updatedData);
                    updatedData.applicationData[serviceSelected.name].volumes?.map((val) => {
                        if (val.volumeType === "Configmap") {
                            vols.push({
                                'disabled': val.config.disabled,
                                'configName': val.config.configName,
                                'createMountPath': val.config.createMountPath,
                                'createConfig': val.config.createConfig
                            });
                        }
                        else if (val.volumeType === "Secrets") {
                            vols.push({
                                'disabled': val.secrets.disabled,
                                'secretsName': val.secrets.secretsName,
                                'createSecretsMountPath': val.secrets.createSecretsMountPath,
                                'createSecrets': val.secrets.createSecrets
                            });
                        }
                        else if (val.volumeType === "Storage") {
                            vols.push({
                                'disabled': val.storage.disabled,
                                'storageName': val.storage.storageDes.storageName,
                                'type': "EBS",//val.storage.storageDes.type, //Fixed to EBS for now
                                'path': val.storage.storageDes.path,
                                'size': val.storage.storageDes.size,
                            });
                        }
                    });
                    updatedData.applicationData[serviceSelected.name].deployments?.tags?.map((val, idx) => {
                        tags.push({
                            'name': val.name,
                            'value': val.value
                        });
                    });
                let labels = [];
                (updatedData.applicationData[serviceSelected.name].deployments.labels || []).map((val, idx) => {
                    labels.push({
                        'name': val.name,
                        'value': val.value
                    });
                });
                    const basicDetails = updatedData.applicationData[serviceSelected.name].basicDetails || {};
                    const deployments = updatedData.applicationData[serviceSelected.name].deployments || {};
                    const formValues = {
                            'appName': basicDetails.appName,
                            'url': basicDetails.url,
                            'sourceType': basicDetails.sourceType,
                            'appSource': basicDetails.sourceType === "Git Repositories" ? "" : !basicDetails.appSource?.integration_type ? "PUBLIC" : (!basicDetails.appSource?.account_id ? `${basicDetails.appSource?.alias} - ${basicDetails.appSource?.integration_type}` : `${basicDetails.appSource?.account_id}${basicDetails.appSource?.alias ? `(${basicDetails.appSource?.alias})` : ``} / ${basicDetails.appSource?.region}`),
                            'imageRepo': basicDetails.imageRepo,
                            'imageTag': basicDetails.imageTag === "" ? null : basicDetails.imageTag,
                            'branch': basicDetails.branch === "" ? null : basicDetails.branch,
                            'dockerFilePath': basicDetails.dockerFilePath,
                            'buildContext': basicDetails.buildContext,
                            'containerRegistryId': !basicDetails.containerRegistryId?.integration_type ? null : (!basicDetails.containerRegistryId?.account_id ? `${basicDetails.containerRegistryId?.alias} - ${basicDetails.containerRegistryId?.integration_type}` : `${basicDetails.containerRegistryId?.account_id}${basicDetails.containerRegistryId?.alias ? `(${basicDetails.containerRegistryId?.alias})` : ``} / ${basicDetails.containerRegistryId?.region}`),
                            'port': deployments.port,
                            'healthCheckPath': deployments.healthCheckPath,
                            'endpointType': deployments.endpointType === "" ? null : deployments.endpointType,
                            'requestCpu': deployments.resources?.cpu?.requestCpu,
                            'limitCpu': deployments.resources?.cpu?.limitCpu,
                            'requestMem': deployments.resources?.memory?.requestMem,
                            'limitMem': deployments.resources?.memory?.limitMem,
                            'minimumReplica': deployments.autoScaling?.autoScalingData?.minimumReplica,
                            'maximumReplica': deployments.autoScaling?.autoScalingData?.maximumReplica,
                            'cpuAuto': deployments.autoScaling?.autoScalingData?.autoScalingParameter?.cpuAuto,
                            'memoryAuto': deployments.autoScaling?.autoScalingData?.autoScalingParameter?.memoryAuto,
                            'nodeGroupName': !deployments.nodeGroupName ? null : deployments.nodeGroupName,
                        'volumeList': vols.length > 0 ? vols : [{}],
                        'tags': tags.length > 0 ? tags : [{}],
                        'labels': labels.length > 0 ? labels : [{}],
                        'serviceType': deployments.serviceType === "" ? null : deployments.serviceType,
                            'domainHostUrl': deployments.domainHostUrl,
                            'acmCertificate': deployments.acmCertificate,
                            'dns': deployments.dns,
                            'gPath': deployments.gatewayHttps?.gPath,
                            'entryPointCommandQueues': deployments.taskSchedulers?.entryPointCommandQueues,
                            'entryPointCommandCrons': deployments.taskSchedulers?.entryPointCommandCrons,
                            'yamlData': deployments[deployments.yamlType]?.yamlString,
                            //'': applicationData[serviceSelected.name].volumes
                    };
                    console.log("====Update: Setting form fields for updateDep:", formValues);
                    form.setFieldsValue(formValues);
                    const appDataToSet = JSON.parse(JSON.stringify({ ...updatedData.applicationData[serviceSelected.name] }));
                    // Ensure serviceEnabled is set correctly based on serviceSelected.isActive
                    appDataToSet.serviceEnabled = serviceSelected.isActive !== undefined ? serviceSelected.isActive : (appDataToSet.serviceEnabled !== undefined ? appDataToSet.serviceEnabled : true);
                    // Ensure environments are properly formatted (array with objects that have 'key' property)
                    if (appDataToSet.environments && Array.isArray(appDataToSet.environments)) {
                        // Filter out any invalid entries and ensure all have 'key' property
                        appDataToSet.environments = appDataToSet.environments.filter(env => env && env.key);
                        console.log("====Update: AppData environments being set (filtered)====: ", appDataToSet.environments);
                    } else if (appDataToSet.environments && typeof appDataToSet.environments === 'object' && !Array.isArray(appDataToSet.environments)) {
                        // If environments is an object, normalize it
                        const normalizedEnvs = normalizeEnvVarsToArray(appDataToSet.environments);
                        appDataToSet.environments = mapEnvVarsToFrontend(normalizedEnvs);
                        console.log("====Update: AppData environments normalized from object====: ", appDataToSet.environments);
                    } else if (!appDataToSet.environments || appDataToSet.environments.length === 0) {
                        // If no environments, try to get from serviceSelected configuration
                        const rawConfigEnvs = serviceSelected?.configuration?.env_variables || serviceSelected?.configuration?.envs || serviceSelected?.environment_variables || [];
                        if (rawConfigEnvs && (Array.isArray(rawConfigEnvs) || typeof rawConfigEnvs === 'object')) {
                            const normalizedConfigEnvs = normalizeEnvVarsToArray(rawConfigEnvs);
                            appDataToSet.environments = mapEnvVarsToFrontend(normalizedConfigEnvs);
                            console.log("====Update: AppData environments from serviceSelected config====: ", appDataToSet.environments);
                        } else {
                            console.warn("====Update: No environments found, setting to empty array====");
                            appDataToSet.environments = [];
                        }
                    }
                    console.log("====Update: Setting appData with serviceEnabled:", appDataToSet.serviceEnabled, "and environments:", appDataToSet.environments?.length || 0);
                    console.log("====Update: Setting form fields with values:", form.getFieldsValue());
                    setAppData(appDataToSet);
                    console.log("Updated data inside useEffect: ", updatedData);
                    setYamlData(updatedData.applicationData[serviceSelected.name].deployments[updatedData.applicationData[serviceSelected.name].deployments.yamlType].yamlString);
                    formSetForUpdateDepRef.current = serviceSelected.name; // Mark form as set for this service
                    console.log("====Update: Form set for service:", serviceSelected.name);
                    }
                }
                else {
                    form.setFieldsValue({
                        'tags': [{}],
                        'labels': [{}],
                        'volumeList': [{}]
                    });
                    const initialAppData = JSON.parse(JSON.stringify({ ...initialApplicationData }));
                    // Ensure serviceEnabled is set correctly
                    initialAppData.serviceEnabled = serviceSelected.isActive !== undefined ? serviceSelected.isActive : true;
                    setAppData(initialAppData);
                    setYamlData(initialApplicationData.deployments[initialApplicationData.deployments.yamlType].yamlString);
                }
                // Set executeEnvs to true to ensure EnvironmentVariablesDep component renders
                setExecuteEnvs(true);
                setDefaultValues(true);
            }
        }
        else if (!cloneDep) {
            console.log("Triggers", applicationData, serviceSelected);
            if (applicationData[serviceSelected.name]) {
                let vols = [];
                let tags = [];
                // Preserve environments from applicationData, or fallback to service config if empty
                let envs = applicationData[serviceSelected.name].environments;
                if (!envs || envs.length === 0) {
                    const rawConfigEnvs = serviceSelected?.configuration?.env_variables || serviceSelected?.configuration?.envs || [];
                    const normalizedConfigEnvs = normalizeEnvVarsToArray(rawConfigEnvs);
                    envs = mapEnvVarsToFrontend(normalizedConfigEnvs);
                    console.log("Environments were empty, using service config:", rawConfigEnvs, "-> normalized:", normalizedConfigEnvs, "-> mapped:", envs);
                }
                applicationData[serviceSelected.name].volumes.map((val) => {
                    if (val.volumeType === "Configmap") {
                        vols.push({
                            'configName': val.config.configName,
                            'createMountPath': val.config.createMountPath,
                            'createConfig': val.config.createConfig,
                        });

                        setAllOptions((prev) => ({
                            ...prev,
                            advancedSettings: true,
                        }));
                    }
                    else if (val.volumeType === "Secrets") {
                        vols.push({
                            'secretsName': val.secrets.secretsName,
                            'createSecretsMountPath': val.secrets.createSecretsMountPath,
                            'createSecret': val.secrets.createSecretConfig,
                        });

                        setAllOptions((prev) => ({
                            ...prev,
                            advancedSettings: true,
                        }));
                    }
                    else if (val.volumeType === "Storage") {
                        vols.push({
                            'storageName': val.storage.storageDes.storageName,
                            'type': "EBS",//val.storage.storageDes.type, //Fixed to EBS for now
                            'path': val.storage.storageDes.path,
                            'size': val.storage.storageDes.size,
                        });

                        setAllOptions((prev) => ({
                            ...prev,
                            advancedSettings: true,
                        }));
                    }
                });
                applicationData[serviceSelected.name].deployments.tags?.map((val, idx) => {
                    tags.push({
                        'name': val.name,
                        'value': val.value
                    });
                });
                let labels = [];
                (applicationData[serviceSelected.name].deployments.labels || []).map((val, idx) => {
                    labels.push({
                        'name': val.name,
                        'value': val.value
                    });
                });
                form.setFieldsValue(
                    {
                        'appName': applicationData[serviceSelected.name].basicDetails.appName,
                        'url': applicationData[serviceSelected.name].basicDetails.url,
                        'sourceType': applicationData[serviceSelected.name].basicDetails.sourceType,
                        'appSource': applicationData[serviceSelected.name].basicDetails.sourceType === "Git Repositories" ? "" : !applicationData[serviceSelected.name].basicDetails.appSource?.integration_type ? "PUBLIC" : (!applicationData[serviceSelected.name].basicDetails.appSource?.account_id ? `${applicationData[serviceSelected.name].basicDetails.appSource?.alias} - ${applicationData[serviceSelected.name].basicDetails.appSource?.integration_type}` : `${applicationData[serviceSelected.name].basicDetails.appSource?.account_id}${applicationData[serviceSelected.name].basicDetails.appSource?.alias ? `(${applicationData[serviceSelected.name].basicDetails.appSource?.alias})` : ``} / ${applicationData[serviceSelected.name].basicDetails.appSource?.region}`),
                        'imageRepo': applicationData[serviceSelected.name].basicDetails.imageRepo,
                        'imageTag': applicationData[serviceSelected.name].basicDetails.imageTag === "" ? null : applicationData[serviceSelected.name].basicDetails.imageTag,
                        'branch': applicationData[serviceSelected.name].basicDetails.branch === "" ? null : applicationData[serviceSelected.name].basicDetails.branch,
                        'dockerFilePath': applicationData[serviceSelected.name].basicDetails.dockerFilePath,
                        'buildContext': applicationData[serviceSelected.name].basicDetails.buildContext,
                        // 'containerRegistryId': applicationData[serviceSelected.name].basicDetails.containerRegistryId.alias === "" ? null : applicationData[serviceSelected.name].basicDetails.containerRegistryId.alias,
                        'containerRegistryId': !applicationData[serviceSelected.name]?.basicDetails?.containerRegistryId?.integration_type ? null : (!applicationData[serviceSelected.name]?.basicDetails?.containerRegistryId?.account_id ? `${applicationData[serviceSelected.name]?.basicDetails?.containerRegistryId?.alias} - ${applicationData[serviceSelected.name]?.basicDetails?.containerRegistryId?.integration_type}` : `${applicationData[serviceSelected.name]?.basicDetails?.containerRegistryId?.account_id}${applicationData[serviceSelected.name]?.basicDetails?.containerRegistryId?.alias ? `(${applicationData[serviceSelected.name]?.basicDetails?.containerRegistryId?.alias})` : ``} / ${applicationData[serviceSelected.name]?.basicDetails?.containerRegistryId?.region}`),
                        'port': applicationData[serviceSelected.name].deployments.port,
                        'healthCheckPath': applicationData[serviceSelected.name].deployments.healthCheckPath,
                        'endpointType': applicationData[serviceSelected.name].deployments.endpointType === "" ? null : applicationData[serviceSelected.name].deployments.endpointType,
                        'requestCpu': applicationData[serviceSelected.name].deployments.resources.cpu.requestCpu,
                        'limitCpu': applicationData[serviceSelected.name].deployments.resources.cpu.limitCpu,
                        'requestMem': applicationData[serviceSelected.name].deployments.resources.memory.requestMem,
                        'limitMem': applicationData[serviceSelected.name].deployments.resources.memory.limitMem,
                        'minimumReplica': applicationData[serviceSelected.name].deployments.autoScaling.autoScalingData.minimumReplica,
                        'maximumReplica': applicationData[serviceSelected.name].deployments.autoScaling.autoScalingData.maximumReplica,
                        'cpuAuto': applicationData[serviceSelected.name].deployments.autoScaling.autoScalingData.autoScalingParameter.cpuAuto,
                        'memoryAuto': applicationData[serviceSelected.name].deployments.autoScaling.autoScalingData.autoScalingParameter.cpuAuto,
                        'nodeGroupName': !applicationData[serviceSelected.name].deployments.nodeGroupName ? null : applicationData[serviceSelected.name].deployments.nodeGroupName,
                        'volumeList': vols.length > 0 ? vols : [{}],
                        'tags': tags.length > 0 ? tags : [{}],
                        'labels': labels.length > 0 ? labels : [{}],
                        'serviceType': applicationData[serviceSelected.name].deployments.serviceType === "" ? null : applicationData[serviceSelected.name].deployments.serviceType,
                        'domainHostUrl': applicationData[serviceSelected.name].deployments.domainHostUrl,
                        'acmCertificate': applicationData[serviceSelected.name].deployments.acmCertificate,
                        'dns': applicationData[serviceSelected.name].deployments.dns,
                        'gPath': applicationData[serviceSelected.name].deployments.gatewayHttps.gPath,
                        'entryPointCommandQueues': applicationData[serviceSelected.name].deployments.taskSchedulers.entryPointCommandQueues,
                        'entryPointCommandCrons': applicationData[serviceSelected.name].deployments.taskSchedulers.entryPointCommandCrons,
                        'yamlData': applicationData[serviceSelected.name].deployments[applicationData[serviceSelected.name].deployments.yamlType].yamlString,
                        //'': applicationData[serviceSelected.name].volumes
                    }
                );
                console.log("Setting app data: ", form.getFieldValue(["yamlData"]), applicationData[serviceSelected.name].deployments[applicationData[serviceSelected.name].deployments.yamlType].yamlString);
                setAppData(JSON.parse(JSON.stringify({ 
                    ...applicationData[serviceSelected.name],
                    environments: envs.length > 0 ? envs : applicationData[serviceSelected.name].environments
                })));
                setYamlData(applicationData[serviceSelected.name].deployments[applicationData[serviceSelected.name].deployments.yamlType].yamlString);
            }
            else {
                // Extract environments from service configuration if available
                const rawConfigEnvs = serviceSelected?.configuration?.env_variables || serviceSelected?.configuration?.envs || [];
                const normalizedConfigEnvs = normalizeEnvVarsToArray(rawConfigEnvs);
                const mappedEnvs = mapEnvVarsToFrontend(normalizedConfigEnvs);
                console.log("Extracting envs from service config for", serviceSelected.name, ":", rawConfigEnvs, "-> normalized:", normalizedConfigEnvs, "-> mapped:", mappedEnvs);
                form.setFieldsValue({
                    'tags': [{}],
                    'labels': [{}],
                    'volumeList': [{}],
                    'yamlData': initialApplicationData.deployments[initialApplicationData.deployments.yamlType].yamlString,
                });
                setAppData(JSON.parse(JSON.stringify({ 
                    ...initialApplicationData,
                    environments: mappedEnvs.length > 0 ? mappedEnvs : initialApplicationData.environments
                })));
                setYamlData(initialApplicationData.deployments[initialApplicationData.deployments.yamlType].yamlString);
            }
            // Set executeEnvs to true (not toggle) to ensure EnvironmentVariablesDep component renders in create flow
            setExecuteEnvs(true);
            setDefaultValues(true);
        }
        else {
            // if (cloneApplicationData[serviceSelected.name]) {
            //     setAppData(JSON.parse(JSON.stringify({ ...cloneApplicationData[serviceSelected.name], })));
            // }
            // else {
            //     setAppData(JSON.parse(JSON.stringify({ ...initialApplicationData, })));
            // }
            if (cloneFetched) {
                console.log("Clone app data: ", cloneApplicationData);
                if (cloneApplicationData[serviceSelected.name]) {
                    let vols = [];
                    let tags = [];
                    cloneApplicationData[serviceSelected.name].volumes.map((val) => {
                        if (val.volumeType === "Configmap") {
                            vols.push({
                                'configName': val.config.configName,
                                'createMountPath': val.config.createMountPath,
                                'createConfig': val.config.createConfig,
                            });
                        }
                        else if (val.volumeType === "Secrets") {
                            vols.push({
                                'secretsName': val.secrets.secretsName,
                                'createSecretsMountPath': val.secrets.createSecretsMountPath,
                                'createSecret': val.secrets.createSecretConfig,
                            });
                        }
                        else if (val.volumeType === "Storage") {
                            vols.push({
                                'storageName': val.storage.storageDes.storageName,
                                'type': "EBS",//val.storage.storageDes.type, //Fixed to EBS for now
                                'path': val.storage.storageDes.path,
                                'size': val.storage.storageDes.size,

                            });
                        }
                    });
                    console.log("Clone vols: ", vols);
                    cloneApplicationData[serviceSelected.name].deployments.tags.map((val, idx) => {
                        tags.push({
                            'name': val.name,
                            'value': val.value
                        });
                    });
                    let labels = [];
                    (cloneApplicationData[serviceSelected.name].deployments.labels || []).map((val, idx) => {
                        labels.push({
                            'name': val.name,
                            'value': val.value
                        });
                    });
                    form.setFieldsValue(
                        {
                            'appName': cloneApplicationData[serviceSelected.name].basicDetails.appName,
                            'url': cloneApplicationData[serviceSelected.name].basicDetails.url,
                            'sourceType': cloneApplicationData[serviceSelected.name].basicDetails.sourceType,
                            'appSource': cloneApplicationData[serviceSelected.name].basicDetails.sourceType === "Git Repositories" ? "" : !cloneApplicationData[serviceSelected.name].basicDetails.appSource?.integration_type ? "PUBLIC" : (!cloneApplicationData[serviceSelected.name].basicDetails.appSource.account_id ? `${cloneApplicationData[serviceSelected.name].basicDetails.appSource.alias} - ${cloneApplicationData[serviceSelected.name].basicDetails.appSource?.integration_type}` : `${cloneApplicationData[serviceSelected.name].basicDetails.appSource.account_id}${cloneApplicationData[serviceSelected.name].basicDetails.appSource.alias ? `(${cloneApplicationData[serviceSelected.name].basicDetails.appSource.alias})` : ``} / ${cloneApplicationData[serviceSelected.name].basicDetails.appSource.region}`),
                            'imageRepo': cloneApplicationData[serviceSelected.name].basicDetails.imageRepo,
                            'imageTag': cloneApplicationData[serviceSelected.name].basicDetails.imageTag === "" ? null : cloneApplicationData[serviceSelected.name].basicDetails.imageTag,
                            'branch': cloneApplicationData[serviceSelected.name].basicDetails.branch === "" ? null : cloneApplicationData[serviceSelected.name].basicDetails.branch,
                            'dockerFilePath': cloneApplicationData[serviceSelected.name].basicDetails.dockerFilePath,
                            'buildContext': cloneApplicationData[serviceSelected.name].basicDetails.buildContext,
                            // 'containerRegistryId': applicationData[serviceSelected.name].basicDetails.containerRegistryId.alias === "" ? null : applicationData[serviceSelected.name].basicDetails.containerRegistryId.alias,
                            'containerRegistryId': !cloneApplicationData[serviceSelected.name].basicDetails.containerRegistryId?.integration_type ? null : (!cloneApplicationData[serviceSelected.name].basicDetails.containerRegistryId.account_id ? `${cloneApplicationData[serviceSelected.name].basicDetails.containerRegistryId.alias} - ${cloneApplicationData[serviceSelected.name].basicDetails.containerRegistryId?.integration_type}` : `${cloneApplicationData[serviceSelected.name].basicDetails.containerRegistryId.account_id}${cloneApplicationData[serviceSelected.name].basicDetails.containerRegistryId.alias ? `(${cloneApplicationData[serviceSelected.name].basicDetails.containerRegistryId.alias})` : ``} / ${cloneApplicationData[serviceSelected.name].basicDetails.containerRegistryId.region}`),
                            'port': cloneApplicationData[serviceSelected.name].deployments.port,
                            'healthCheckPath': cloneApplicationData[serviceSelected.name].deployments.healthCheckPath,
                            'endpointType': cloneApplicationData[serviceSelected.name].deployments.endpointType === "" ? null : cloneApplicationData[serviceSelected.name].deployments.endpointType,
                            'requestCpu': cloneApplicationData[serviceSelected.name].deployments.resources.cpu.requestCpu,
                            'limitCpu': cloneApplicationData[serviceSelected.name].deployments.resources.cpu.limitCpu,
                            'requestMem': cloneApplicationData[serviceSelected.name].deployments.resources.memory.requestMem,
                            'limitMem': cloneApplicationData[serviceSelected.name].deployments.resources.memory.limitMem,
                            'minimumReplica': cloneApplicationData[serviceSelected.name].deployments.autoScaling.autoScalingData.minimumReplica,
                            'maximumReplica': cloneApplicationData[serviceSelected.name].deployments.autoScaling.autoScalingData.maximumReplica,
                            'cpuAuto': cloneApplicationData[serviceSelected.name].deployments.autoScaling.autoScalingData.autoScalingParameter.cpuAuto,
                            'memoryAuto': cloneApplicationData[serviceSelected.name].deployments.autoScaling.autoScalingData.autoScalingParameter.cpuAuto,
                            'nodeGroupName': !cloneApplicationData[serviceSelected.name].deployments.nodeGroupName ? null : cloneApplicationData[serviceSelected.name].deployments.nodeGroupName,
                            'volumeList': vols.length > 0 ? vols : [{}],
                            'tags': tags.length > 0 ? tags : [{}],
                            'labels': labels.length > 0 ? labels : [{}],
                            'serviceType': cloneApplicationData[serviceSelected.name].deployments.serviceType === "" ? null : cloneApplicationData[serviceSelected.name].deployments.serviceType,
                            'domainHostUrl': cloneApplicationData[serviceSelected.name].deployments.domainHostUrl,
                            'acmCertificate': cloneApplicationData[serviceSelected.name].deployments.acmCertificate,
                            'dns': cloneApplicationData[serviceSelected.name].deployments.dns,
                            'gPath': cloneApplicationData[serviceSelected.name].deployments.gatewayHttps.gPath,
                            'entryPointCommandQueues': cloneApplicationData[serviceSelected.name].deployments.taskSchedulers.entryPointCommandQueues,
                            'entryPointCommandCrons': cloneApplicationData[serviceSelected.name].deployments.taskSchedulers.entryPointCommandCrons,
                            'yamlData': cloneApplicationData[serviceSelected.name].deployments[cloneApplicationData[serviceSelected.name].deployments.yamlType].yamlString,                            //'': applicationData[serviceSelected.name].volumes
                        }
                    );
                    console.log("Else entered", cloneApplicationData);
                    // setIsFormSet(true);
                    setAppData(JSON.parse(JSON.stringify({ ...cloneApplicationData[serviceSelected.name] })));
                    setYamlData(cloneApplicationData[serviceSelected.name].deployments[cloneApplicationData[serviceSelected.name].deployments.yamlType].yamlString);
                }
                else {
                    form.setFieldsValue({
                        'tags': [{}],
                        'labels': [{}],
                        'volumeList': [{}]
                    });
                    setAppData(JSON.parse(JSON.stringify({ ...initialApplicationData, })));
                    setYamlData(initialApplicationData.deployments[initialApplicationData.deployments.yamlType].yamlString);
                }
                // Set executeEnvs to true (not toggle) to ensure EnvironmentVariablesDep component renders in clone flow
                setExecuteEnvs(true);
                setDefaultValues(true);
            }
        }
        //}
    }, [serviceSelected.name, cloneFetched, updateFetched, addUpdatedData?.selectedProject?.serviceData, addUpdatedData?.applicationData?.[serviceSelected.name], updatedData?.applicationData?.[serviceSelected.name], applicationData?.[serviceSelected.name]]);

    // Ensure executeEnvs is set to true in create flow when service is selected
    // useEffect(() => {
    //     if (!cloneDep && !updateDep && !addDep && serviceSelected?.name) {
    //         // In create flow, ensure executeEnvs is true so environment variables section can open
    //         if (!executeEnvs) {
    //             setExecuteEnvs(true);
    //         }
    //         // Ensure allOptions.envVars is true so the body can open
    //         if (!allOptions.envVars) {
    //             setAllOptions(prev => ({
    //                 ...prev,
    //                 envVars: true
    //             }));
    //         }
    //     }
    // }, [serviceSelected?.name, cloneDep, updateDep, addDep]);

    // Capture initial form data for comparison
    useEffect(() => {
        if (updateDep && appData && form.getFieldsValue() && Object.keys(form.getFieldsValue()).length > 0 ) {
            console.log("form.getFieldsValue() :", form.getFieldsValue())
            const currentFormData = form.getFieldsValue();
            if (!initialFormData && (currentFormData.appName || currentFormData.dockerFilePath || currentFormData.imageTag)) {
                setInitialFormData(JSON.parse(JSON.stringify(currentFormData)));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateDep, updateFetched, appData?.basicDetails?.appName, appData?.basicDetails?.dockerFilePath, appData?.basicDetails?.imageTag, initialFormData]);

    // Capture initial environment data for comparison
    useEffect(() => {
        if (updateDep && appData && appData.environments && appData.environments.length > 0 && (Object.keys(appData.environments[0]).includes("is_synced")) && !initialEnvData) {
            console.log("Setting initial environment data:", appData.environments);
            setInitialEnvData(deepClonePreservingUndefined(appData.environments));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateDep, appData?.environments?.length, initialEnvData]);

    // Capture initial account details for comparison
    useEffect(() => {
        if (updateDep && (currentTaskAccountDetails === "Atmosly" || currentTaskAccountDetails?.secret_name) && !initialAccountDetails) {
            console.log("Setting initial account details:", currentTaskAccountDetails);
            setInitialAccountDetails(JSON.parse(JSON.stringify(currentTaskAccountDetails)));
        }
    }, [updateDep, currentTaskAccountDetails, initialAccountDetails]);

    // useEffect(() => {
    //     console.log("Forms: ", form);
    //     setAppData({ ...appData, form: form });
    // }, [form]);


    useEffect(() => {
        // Prevent infinite loops by comparing serialized appData
        const currentAppDataStr = JSON.stringify(appData);
        const prevAppDataStr = prevAppDataRef.current ? JSON.stringify(prevAppDataRef.current) : null;
        
        // Only update if appData actually changed
        if (currentAppDataStr === prevAppDataStr && !appDataUpdateRef.current) {
            return;
        }
        
        appDataUpdateRef.current = false;
        prevAppDataRef.current = JSON.parse(JSON.stringify(appData));
        
        const timeout = setTimeout(() => {
            if (addDep) {
                console.log("App data in add dep: ", JSON.parse(JSON.stringify(addUpdatedData)), appData);
                // Preserve environments from existing data if appData doesn't have them (to prevent loss during API calls)
                const existingServiceData = addUpdatedData.applicationData?.[serviceSelected.name];
                const preservedEnvironments = (appData.environments && appData.environments.length > 0) 
                    ? appData.environments 
                    : (existingServiceData?.environments && existingServiceData.environments.length > 0)
                        ? existingServiceData.environments
                        : [];
                
                const serviceDataToSave = {
                            ...appData,
                    environments: preservedEnvironments, // Always preserve environments
                            basicDetails: {
                                ...appData.basicDetails,
                                // serviceName: serviceSelected.name
                            }
                };
                
                setAddUpdatedData(addUpdatedData => ({
                    ...addUpdatedData,
                    applicationData: {
                        ...addUpdatedData.applicationData,
                        [serviceSelected.name]: JSON.parse(JSON.stringify(serviceDataToSave))
                    }
                }));
                localStorage.setItem('addUpdatedData', JSON.stringify({
                    ...addUpdatedData,
                    applicationData: {
                        ...addUpdatedData.applicationData,
                        [serviceSelected.name]: JSON.parse(JSON.stringify(serviceDataToSave))
                    }
                }));
                console.log("Local storage val: ", JSON.parse(localStorage.getItem('addUpdatedData')).applicationData);
                setDeploymentForms(deploymentForms => {
                    return {
                        ...deploymentForms,
                        [serviceSelected.name]: form
                    }
                });
            }
            else if (updateDep) {
                if (updateFetched) {
                    console.log("Setting the data: ", appData, updatedData.applicationData);
                    localStorage.setItem('updatedData', JSON.stringify({
                        ...JSON.parse(localStorage.getItem('updatedData')),
                        applicationData: {
                            ...JSON.parse(localStorage.getItem('updatedData')).applicationData,
                            [serviceSelected.name]: JSON.parse(JSON.stringify({
                                ...appData,
                                basicDetails: {
                                    ...appData.basicDetails,
                                    // serviceName: serviceSelected.name
                                }
                            }))
                        }
                    }));
                    setUpdatedData(updatedData => ({
                        ...updatedData,
                        applicationData: {
                            ...updatedData.applicationData,
                            [serviceSelected.name]: JSON.parse(JSON.stringify({
                                ...appData,
                                basicDetails: {
                                    ...appData.basicDetails,
                                    // serviceName: serviceSelected.name
                                }
                            }))
                        }
                    }));
                    setDeploymentForms(deploymentForms => {
                        return {
                            ...deploymentForms,
                            [serviceSelected.name]: form
                        }
                    });
                }
            }
            else if (cloneDep) {
                if (cloneFetched) {
                    localStorage.setItem('cloneAppData', JSON.stringify({
                        ...cloneApplicationData,
                        [serviceSelected.name]: JSON.parse(JSON.stringify({
                            ...appData, basicDetails: {
                                ...appData.basicDetails,
                                serviceName: serviceSelected.name
                            }
                        }))
                    }));
                    setCloneApplicationData(cloneApplicationData => ({
                        ...cloneApplicationData,
                        [serviceSelected.name]: JSON.parse(JSON.stringify({
                            ...appData, basicDetails: {
                                ...appData.basicDetails,
                                serviceName: serviceSelected.name
                            }
                        }))
                    }));
                    setDeploymentForms(deploymentForms => {
                        return {
                            ...deploymentForms,
                            [serviceSelected.name]: form
                        }
                    });
                }
            }
            else if (!cloneDep) {
                console.log("Appdata from envs: ", appData, applicationData, serviceSelected);
                localStorage.setItem('app-data', JSON.stringify({
                    ...JSON.parse(localStorage.getItem('app-data')),
                    [serviceSelected.name]: JSON.parse(JSON.stringify({ ...appData }))
                }));
                setApplicationData(applicationData => ({
                    ...applicationData,
                    [serviceSelected.name]: JSON.parse(JSON.stringify({ ...appData }))
                }));
                setDeploymentForms(deploymentForms => {
                    return {
                        ...deploymentForms,
                        [serviceSelected.name]: form
                    }
                });
            }
        }, 200);

        return (() => {
            clearTimeout(timeout);
        })
        //setIsForm(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appData, updateFetched, cloneFetched, serviceSelected.name]);

    useEffect(() => {
        console.log("AppData being set: ", appData, serviceSelected, defaultValues, cloneDep, updateDep);
        // if (containerRegs.length > 0) {
        if (!cloneDep && !updateDep && !addDep) {
            if (Object.keys(serviceSelected).length > 0 && defaultValues) {
                // Check if data is already converted by useDeploymentContent
                let serviceData = applicationData[serviceSelected.name];
                
                if (serviceData) {
                    // Use converted data (same pattern as updateDep at line 1095)
                    let vols = [];
                    let tags = [];
                    serviceData.volumes?.map((val) => {
                        if (val.volumeType === "Configmap") {
                            vols.push({
                                'configName': val.config.configName,
                                'createMountPath': val.config.createMountPath,
                                'createConfig': val.config.createConfig,
                            });
                        }
                        else if (val.volumeType === "Secrets") {
                            vols.push({
                                'secretsName': val.secrets.secretsName,
                                'createSecretsMountPath': val.secrets.createSecretsMountPath,
                                'createSecret': val.secrets.createSecretConfig,
                            });
                        }
                        else if (val.volumeType === "Storage") {
                            vols.push({
                                'storageName': val.storage.storageDes.storageName,
                                'type': "EBS",//val.storage.storageDes.type, //Fixed to EBS for now
                                'path': val.storage.storageDes.path,
                                'size': val.storage.storageDes.size,
                            });
                        }
                    });
                    serviceData.deployments.tags?.map((val, idx) => {
                        tags.push({
                            'name': val.name,
                            'value': val.value
                        });
                    });

                    // very important
                    serviceData.basicDetails.serviceName = serviceSelected.name;
                    serviceData.serviceSelectedId = serviceSelected.id ? serviceSelected.id : serviceSelected.service_id;
                    serviceData.serviceEnabled = serviceSelected.isActive;//serviceEnabled[serviceSelected.name] === true ? true : false,

                    form.setFieldsValue({
                        'appName': serviceData.basicDetails.appName,
                        'url': serviceData.basicDetails.url,
                        'sourceType': serviceData.basicDetails.sourceType,
                        'appSource': serviceData.basicDetails.sourceType === "Git Repositories" ? "" : !serviceData.basicDetails.appSource?.integration_type ? "PUBLIC" : (!serviceData.basicDetails.appSource?.account_id ? `${serviceData.basicDetails.appSource?.alias} - ${serviceData.basicDetails.appSource?.integration_type}` : `${serviceData.basicDetails.appSource?.account_id}${serviceData.basicDetails.appSource?.alias ? `(${serviceData.basicDetails.appSource?.alias})` : ``} / ${serviceData.basicDetails.appSource?.region}`),
                        'imageRepo': serviceData.basicDetails.imageRepo,
                        'imageTag': serviceData.basicDetails.imageTag === "" ? null : serviceData.basicDetails.imageTag,
                        'branch': serviceData.basicDetails.branch === "" ? null : serviceData.basicDetails.branch,
                        'dockerFilePath': serviceData.basicDetails.dockerFilePath,
                        'buildContext': serviceData.basicDetails.buildContext,
                        'containerRegistryId': !serviceData.basicDetails.containerRegistryId?.integration_type ? null : (!serviceData.basicDetails.containerRegistryId?.account_id ? `${serviceData.basicDetails.containerRegistryId?.alias} - ${serviceData.basicDetails.containerRegistryId?.integration_type}` : `${serviceData.basicDetails.containerRegistryId?.account_id}${serviceData.basicDetails.containerRegistryId?.alias ? `(${serviceData.basicDetails.containerRegistryId?.alias})` : ``} / ${serviceData.basicDetails.containerRegistryId?.region}`),
                        'port': serviceData.deployments.port,
                        'healthCheckPath': serviceData.deployments.healthCheckPath,
                        'endpointType': serviceData.deployments.endpointType === "" ? null : serviceData.deployments.endpointType,
                        'requestCpu': serviceData.deployments.resources.cpu.requestCpu,
                        'limitCpu': serviceData.deployments.resources.cpu.limitCpu,
                        'requestMem': serviceData.deployments.resources.memory.requestMem,
                        'limitMem': serviceData.deployments.resources.memory.limitMem,
                        'minimumReplica': serviceData.deployments.autoScaling.autoScalingData.minimumReplica,
                        'maximumReplica': serviceData.deployments.autoScaling.autoScalingData.maximumReplica,
                        'cpuAuto': serviceData.deployments.autoScaling.autoScalingData.autoScalingParameter.cpuAuto,
                        'memoryAuto': serviceData.deployments.autoScaling.autoScalingData.autoScalingParameter.memoryAuto,
                        'nodeGroupName': !serviceData.deployments.nodeGroupName ? null : serviceData.deployments.nodeGroupName,
                        'volumeList': vols.length > 0 ? vols : [{}],
                        'tags': tags.length > 0 ? tags : [{}],
                        'serviceType': serviceData.deployments.serviceType === "" ? null : serviceData.deployments.serviceType,
                        'domainHostUrl': serviceData.deployments.domainHostUrl,
                        'acmCertificate': serviceData.deployments.acmCertificate,
                        'dns': serviceData.deployments.dns,
                        'gPath': serviceData.deployments.gatewayHttps.gPath,
                        'entryPointCommandQueues': serviceData.deployments.taskSchedulers.entryPointCommandQueues,
                        'entryPointCommandCrons': serviceData.deployments.taskSchedulers.entryPointCommandCrons,
                        'yamlData': serviceData.deployments[serviceData.deployments.yamlType].yamlString,
                    });
                    const appDataCopy = JSON.parse(JSON.stringify({ ...serviceData }));
                    console.log("Setting appData with deploymentOption:", appDataCopy.deployments?.deploymentOption);
                    setAppData(appDataCopy);
                    setYamlData(serviceData.deployments[serviceData.deployments.yamlType].yamlString);
                    
                    // Log to verify YAML mode detection
                    if (appDataCopy.deployments?.deploymentOption === "yaml") {
                        console.log("YAML mode detected! deploymentOption:", appDataCopy.deployments.deploymentOption, "yamlType:", appDataCopy.deployments.yamlType);
                    }
                } else {
                    // Fallback: Simple setup like else part (line 1619)
                    setAppData(appData => ({
                        ...appData,
                        serviceEnabled: serviceSelected.isActive,
                        basicDetails: {
                            ...appData.basicDetails,
                            serviceName: serviceSelected.name,
                        },
                        serviceSelectedId: serviceSelected.id ? serviceSelected.id : serviceSelected.service_id,
                    }));
                }
            }
        }
        else {
            if (Object.keys(serviceSelected).length > 0 && defaultValues) {
                setAppData(appData => ({
                    ...appData,
                    serviceEnabled: serviceSelected.isActive,
                    basicDetails: {
                        ...appData.basicDetails,
                        serviceName: serviceSelected.name,
                    },
                    serviceSelectedId: serviceSelected.id ? serviceSelected.id : serviceSelected.service_id,
                }));
                // setSampleEnvData((sampleEnvData) => ({
                //     ...sampleEnvData,
                //     applicationData: {
                //         ...sampleEnvData.applicationData,
                //         [serviceSelected.name]: {
                //             ...sampleEnvData.applicationData[serviceSelected.name],
                //             basicDetails: {
                //                 ...sampleEnvData.applicationData[serviceSelected.name].basicDetails,
                //                 serviceName: serviceSelected.name
                //             },
                //             serviceEnabled: serviceSelected.isActive,
                //             serviceSelectedId: serviceSelected.id ? serviceSelected.id : serviceSelected.service_id,
                //         }
                //     }
                // }));
                // const mySampleData = JSON.parse(localStorage.getItem("sampleEnvData"));
                // console.log("Setting env data: ", mySampleData);
                // localStorage.setItem("sampleEnvData", JSON.stringify({
                //     ...mySampleData,
                //     applicationData: {
                //         ...mySampleData.applicationData,
                //         [serviceSelected.name]: {
                //             ...mySampleData.applicationData[serviceSelected.name],
                //             basicDetails: {
                //                 ...mySampleData.applicationData[serviceSelected.name].basicDetails,
                //                 serviceName: serviceSelected.name
                //             },
                //             serviceEnabled: serviceSelected.isActive,
                //             serviceSelectedId: serviceSelected.id ? serviceSelected.id : serviceSelected.service_id,
                //         }
                //     }
                // }));
            }
            // }
            // else {
            //     setDefaultValues(false);
            // }
        }
    }, [serviceSelected.name, serviceSelected.isActive, defaultValues, containerRegs, applicationData?.[serviceSelected.name]]);


    const handlePrevious = (importantFields, currentIdx) => {
        // setImportantIdx(importantIdx => importantIdx - 1);
        if (currentIdx !== 0) {
            form.setFields([
                {
                    name: importantFields[currentIdx],
                    warnings: []
                },
                {
                    name: importantFields[currentIdx - 1],
                    warnings: warnings(false, false, importantFields, handlePrevious, handleNext, currentIdx - 1)
                }
            ]);

            warningsRef.current = [
                {
                    name: importantFields[currentIdx],
                    warnings: []
                },
                {
                    name: importantFields[currentIdx - 1],
                    warnings: warnings(false, false, importantFields, handlePrevious, handleNext, currentIdx - 1)
                }
            ];

            form.scrollToField(importantFields[currentIdx - 1], {
                behavior: "smooth",
                block: 'center',
                inline: 'center',
            });
        }
        else {
            form.setFields([{
                name: importantFields[currentIdx],
                warnings: []
            }]);
            warningsRef.current = [{
                name: importantFields[currentIdx],
                warnings: []
            }];
            setGenerateImpField(true);
            handlePrevBtn();
        }
        setGenerateImpField(true);
        setPrevBtn(true);
        setNextBtn(false);
    }

    const handleNext = (importantFields, currentIdx) => {
        // setImportantIdx(importantIdx => importantIdx + 1);
        if (currentIdx !== importantFields.length - 1) {
            form.setFields([
                {
                    name: importantFields[currentIdx],
                    warnings: []
                },
                {
                    name: importantFields[currentIdx + 1],
                    warnings: warnings(false, false, importantFields, handlePrevious, handleNext, currentIdx + 1)
                }
            ]);

            warningsRef.current = [
                {
                    name: importantFields[currentIdx],
                    warnings: []
                },
                {
                    name: importantFields[currentIdx + 1],
                    warnings: warnings(false, false, importantFields, handlePrevious, handleNext, currentIdx + 1)
                }
            ];

            form.scrollToField(importantFields[currentIdx + 1], {
                behavior: "smooth",
                block: 'center',
                inline: 'center',
            });
        }
        else {
            // handleSaveAndNextImp();
            if (keySelected === lastEnabledService) {
                form.setFields([{
                    name: importantFields[currentIdx],
                    warnings: []
                }]);
                warningsRef.current = [{
                    name: importantFields[currentIdx],
                    warnings: []
                }];
                buttonRef1.current.scrollIntoView({ behavior: 'smooth' });
            }
            else {
                handleSave();
            }
        }
        setPrevBtn(false);
        setNextBtn(true);
    }

    const generateImportantFields = () => {
        const importantFields = [];
        console.log("Getting form fields...", "domain" in form.getFieldsValue());

        // console.log("form :", form.getFieldsValue());
        // console.log("selectedEnv :", selectedEnv);
        // console.log("cloneDeploymentData :", cloneDeploymentData);
        // console.log("appData :", appData);

        let allBasicDetailsRequiredFiled = ["appName", "branch", "dockerFilePath"];
        let allContainerBasicDetailsRequiredFiled = ["appName", "imageRepo", "imageTag"];
        let allDeploymentRequiredFiled = ["port", "endpointType"];
        let allResourcesCpuRequiredFiled = ["requestCpu", "limitCpu"];
        let allResourcesMemoryRequiredFiled = ["requestMem", "limitMem"];

        // old code
        // domain is compulsory and container registry id also if source type is git repositories
        if (selectedEnv.cluster_unique_id !== cloneDeploymentData.clusterId && appData.basicDetails.sourceType === "Git Repositories") {
            importantFields.push("containerRegistryId");
        }
        // if ("domain" in form.getFieldsValue()) {
        //     console.log("Enters here as well...");
        //     importantFields.push("domain");
        // }

        // new code for required fields should be mandatory too if empty
        // source type is git repositories so push required fields
        if (appData.basicDetails.sourceType === "Git Repositories") {
            let field = allBasicDetailsRequiredFiled.filter(field => !appData.basicDetails[field]);
            // console.log("basic details required field :", field);
            importantFields.push(...field);
        }
        else if(appData.basicDetails.sourceType === "Container Registry"){
            // source type is container registry so push required fields
            let field = allContainerBasicDetailsRequiredFiled.filter(field => !appData.basicDetails[field]);
            // console.log("container basic details required field :", field);
            importantFields.push(...field);
        }

        const isYamlDeployedService = appData?.deployments?.deploymentOption === "yaml";

        // push deployment section required fields (only when not YAML-deployed - form fields are not in DOM for YAML editor)
        if(appData?.deployments && !isYamlDeployedService){
            let field = allDeploymentRequiredFiled.filter(field => !appData.deployments[field]);
            // if service type there and is empty
            if("serviceType" in form.getFieldsValue() && !appData.deployments.serviceType){
                field.push("serviceType");
            }

            // console.log("deployment section required field :", field);
            importantFields.push(...field);
        }

        // domain is compulsory in importantFields (only when visual form is shown)
        if (!isYamlDeployedService && "domain" in form.getFieldsValue()) {
            console.log("Enters here as well...");
            importantFields.push("domain");
        }

        // For YAML-deployed service: treat YAML editor as the mandatory field so we scroll to it instead of stuck on missing form fields
        if (isYamlDeployedService) {
            const yamlValue = (typeof yamlData === 'string' ? yamlData : '').trim();
            if (!yamlValue) {
                importantFields.push("yamlData");
            }
        }
        
        // resources section required fields (only when not YAML-deployed - not in DOM for YAML editor)
        if(!isYamlDeployedService && appData?.deployments?.resources && appData?.deployments?.autoScaling){
            let field = [];
            field.push(...allResourcesCpuRequiredFiled.filter(field => !appData.deployments.resources.cpu[field]));
            field.push(...allResourcesMemoryRequiredFiled.filter(field => !appData.deployments.resources.memory[field]));
            // if minimum replica there and is empty
            if("minimumReplica" in form.getFieldsValue() && appData.deployments.autoScaling.autoScalingData.minimumReplica === ""){
                field.push("minimumReplica");
            }

            // console.log("resources section required field :", field);
            importantFields.push(...field);
        }

        console.log("Getting all important fields...", importantFields);

        if (importantFields.length > 0) {
            form.setFields([{
                name: importantFields[0],
                warnings: warnings(false, false, importantFields, handlePrevious, handleNext, 0)
            }]);

            warningsRef.current = [{
                name: importantFields[0],
                warnings: warnings(false, false, importantFields, handlePrevious, handleNext, 0)
            }];

            try {
                form.scrollToField(importantFields[0], {
                    behavior: "smooth",
                    block: 'center',
                    inline: 'center',
                });
            } catch (err) {
                // Field may not be in DOM (e.g. YAML tab vs Form tab); advance to next instead of getting stuck
                if (nextBtn || !prevBtn) {
                    if (keySelected !== lastEnabledService) {
                        handleSave();
                    } else {
                        buttonRef1.current?.scrollIntoView({ behavior: 'smooth' });
                    }
                } else if (prevBtn) {
                    setGenerateImpField(true);
                    handlePrevBtn();
                }
            }
            setNextBtn(false);
            setPrevBtn(false);
        }
        else {
            if (nextBtn || !prevBtn) {
                if (keySelected !== lastEnabledService) {
                    handleSave();
                }
                else {
                    buttonRef1.current.scrollIntoView({ behavior: 'smooth' });
                }
            }
            else if (prevBtn) {
                setGenerateImpField(true);
                handlePrevBtn();
            }
        }
    }

    useEffect(() => {
        console.log("Generate imp field: ", generateImpField, keySelected);
        if (importantEnabled && serviceHighlighted.service_id == serviceSelected.service_id && cloneDep && generateImpField && defaultValues && serviceSelected.isActive) {
            generateImportantFields();
        }
        else if (importantEnabled && serviceHighlighted.service_id == serviceSelected.service_id && cloneDep && generateImpField && defaultValues && !serviceSelected.isActive) {
            handleSaveAndNext();
        }
        else if (!importantEnabled) {
            const fields = form.getFieldsError().map(({ name, errors, warnings }) => ({
                name,
                errors,
                warnings: [], // Clear warnings only
            }));
            form.setFields(fields);
            warningsRef.current = fields;
        }
    }, [defaultValues, importantEnabled, serviceHighlighted.service_id, cloneDep, generateImpField]);

    useEffect(() => {
        let ctr = 0;
        let tempNewVars = 0;
        appData.environments.forEach((val) => {
            // Exclude deleted env vars from error count
            if (val.error && val.lastAction !== "Delete") {
                ctr++;
            }
            else if(val.isNew && val.lastAction !== "Delete"){
                tempNewVars++;
            }
        });
        setErrorVars(ctr);
        setNewVars(tempNewVars);
    }, [appData.environments]);

    useEffect(() => {
        console.log("my yaml data: ", yamlData, appData.deployments.yamlType);
        setAppData(appData => ({
            ...appData,
            deployments: {
                ...appData.deployments,
                [appData.deployments.yamlType]: {
                    yamlString: yamlData
                }
            }
        }));
    }, [yamlData]);

    useEffect(() => {
        setFilteredOptions(dnsList);
    }, [dnsList]);

    useEffect(() => {
        const zone = appData.deployments.dns;
        const recordPrefix = appData.deployments.domainHostUrl;
        if (appData.deployments.serviceType !== "Existing Load Balancer(ALB Ingress)" || !zone || !depData.clusterId) {
            setAcmCerts([]);
            return;
        }
        const prefixParam = recordPrefix ? `&record_prefix=${encodeURIComponent(recordPrefix)}` : "";
        api.get(`/api/project_env/acm_certificates/?cluster_unique_id=${depData.clusterId}&domain=${encodeURIComponent(zone)}${prefixParam}`)
            .then((res) => setAcmCerts(res.data?.data?.certificates || []))
            .catch(() => setAcmCerts([])); // no toast — an empty list still leaves "Create new certificate"
    }, [appData.deployments.serviceType, appData.deployments.dns, appData.deployments.domainHostUrl, depData.clusterId]);


    const applyDnsCheckError = (data) => {
        const details = data?.error_details;
        let firstDetail = details;
        if (Array.isArray(details)) {
            const head = details[0];
            firstDetail = typeof head === 'object' && head !== null ? Object.values(head)[0] : head;
        }
        else if (typeof details === 'object' && details !== null) {
            firstDetail = Object.values(details)[0];
        }

        let msg;
        if (firstDetail === "Hostname already exists") {
            msg = "Hostname is in use. An ingress will be created, but you must manually update the DNS record.";
        }
        else if (!firstDetail || firstDetail === "Failed") {
            msg = "Failed to validate DNS record. Please try again.";
        }
        else {
            msg = typeof firstDetail === 'string' ? firstDetail : JSON.stringify(firstDetail);
        }
        setDnsMsg({ error: true, msg });
        setValidateDomainStatus("error");
    };

    const dnsCheck = useDebounce((recordPrefix, zoneName, zoneId, dnsRecordType, checkFor, signal) => {
        setValidateDomainStatus("validating");
        api.post('/api/cluster/check-dns/', [{
            "record_name": recordPrefix,
            "zone_id": zoneId,
            "dns_record_type": dnsRecordType,
            "zone_name": zoneName,
            "check_for": checkFor
        }], { signal }).then((res) => {
            let data = res.data;
            if (data.status) {
                setDnsMsg({
                    error: false,
                    msg: typeof data.data === 'object' ? Object.values(data.data)[0] : data.data
                })
                setValidateDomainStatus("success");
            }
            else {
                applyDnsCheckError(data);
            }
        }).catch((err) => {
            if (axios.isCancel(err)) {
                console.log("Request canceled", err.message);
                return;
            }
            console.log("Error in check-dns:", err);
            applyDnsCheckError(err?.response?.data);
        });
    }, 100, []);

    const validateNameUnique = (rule, value, callback) => {
        let myVal = value?.toString().trim();
        if (myVal === "") {
            callback();
        }
        else {
            let myObj = {};
            if (addDep) {
                myObj = {
                    ...addUpdatedData.applicationData,
                    ...addUpdatedData.dataSourcesData,
                    ...addUpdatedData.mongoDataSourcesData,
                    ...addUpdatedData.postgresDataSourcesData,
                    ...addUpdatedData.redisData
                };
            }
            else if (updateDep) {
                myObj = {
                    ...updatedData.applicationData,
                    ...updatedData.dataSourcesData,
                    ...updatedData.mongoDataSourcesData,
                    ...updatedData.postgresDataSourcesData,
                    ...updatedData.redisData
                };
            }
            else if (!cloneDep) {
                myObj = {
                    ...applicationData,
                    ...dataSourcesData,
                    ...mongoDataSourcesData,
                    ...postgresDataSourcesData,
                    ...redisData
                };
            }
            else {
                myObj = {
                    ...cloneApplicationData,
                    ...cloneDataSourcesData,
                    ...cloneMongoDataSourcesData,
                    ...clonePostgresDataSourcesData,
                    ...cloneRedisData
                };
            }
            console.log("myObj: ", myObj, Object.keys(myObj));
            let resArr = Object.keys(myObj).filter((val) => {
                console.log("MyOBJ: ", myObj[val]);
                if (val !== serviceSelected.name && myObj[val].serviceEnabled) {
                    console.log("Value: ", myObj[val].displayName, myVal);
                    if ((myObj[val].basicDetails && myObj[val].basicDetails.appName && myObj[val].basicDetails.appName === myVal) || (myObj[val].displayName === myVal)) {
                        return val;
                    }
                    else {
                        console.log("Else entered", myObj[val]);
                        return false;
                    }
                }
                else {
                    console.log("same", myObj[val]);
                    return false;
                }
            });

            console.log("Res arr: ", resArr);
            if (resArr.length > 0) {
                console.log("Callback Called");
                callback("Service name should be unique.");
            }
            else {
                callback();
            }
        }
    }
    const handleSave = async () => {
        console.log("Check entered", form.getFieldsValue(), prerequisite);
        let myError = {}, envError = false;
        // if (prevBtn) {
        //     handlePrevBtn();
        // }
        // else {
        appData.environments.forEach((val) => {
            // Exclude deleted env vars from error validation
            if (val.error && val.lastAction !== "Delete") {
                envError = true;
            }
        });
        if (envError) {
            toggleAlert("error", "Failed", "Please fill the missing fields in the env variables section for the enabled services.");
        }
        else {
            try {
                console.log("Getting validations: ", form.getFieldsError());
                await form.validateFields();
            }
            catch (error) {
                console.log("Error caught...", error);
                myError = error;
            }

            if (Object.keys(myError).length > 0) {
                setFormErrors({
                    ...formErrors,
                    [serviceSelected.name]: {
                        error: myError
                    }
                });
                if (!updateDep) {
                    set_alertOptions(alertOptions => ({
                        status: true,
                        type: "error",
                        message: "Service validation failed.",
                        description: "Please fill all the fields for the selected service in order to proceed to the next service.",
                    }));

                    // opacity=0 after 10sec
                    setTimeout(() => {
                        set_alertOptions(alertOptions => ({
                            status: false,
                            type: "error",
                            message: "Service validation failed",
                            description: "Please fill all the fields for the selected service in order to proceed to the next service.",
                        }));
                    }, 5 * 1000);
                }
                else {
                    set_alertOptions(alertOptions => ({
                        status: true,
                        type: "error",
                        message: "Service validation failed.",
                        description: "Please enter correct information for the service to proceed.",
                    }));

                    // opacity=0 after 10sec
                    setTimeout(() => {
                        set_alertOptions(alertOptions => ({
                            status: false,
                            type: "error",
                            message: "Service validation failed",
                            description: "Please enter correct information for the service to proceed.",
                        }));
                    }, 5 * 1000);
                }
            }
            else {
                delete formErrors[serviceSelected.name];
                setFormErrors({ ...formErrors });
                console.log("My important fields...", generateImpField);
                if (((!generateImpField && cloneDep) || !cloneDep)) {
                    targetRef.current.scrollIntoView({ behavior: 'smooth' });
                }
                console.log("Checks: ",);
                if (updateDep) {
                    setPrerequisite(true);
                    setIsSubmitted(true);
                    //handleServiceRedeploy();
                }
                // else if (nextBtn) {
                //     console.log("Next clicked: ", nextBtn);
                //     handleSaveAndNextImp();
                // }
                // else if(prevBtn) {
                //     handlePrevBtn();
                // }
                else {
                    setGenerateImpField(true);
                    handleSaveAndNext();
                }
            }
            //handleSaveAndNextImp();
        }
        // }
    }

    const showConfirm = () => {
        // confirm({
        //   title: 'Environment Variables Warning',
        //   //icon: <ExclamationCircleFilled />,
        //   content: 'This environment has some variables dependent on the services that are not getting deployed. Do you want to procced creating environment?',
        //   onOk() {
        //     console.log('OK');
        //     handleSubmit();
        //   },
        //   onCancel() {
        //     console.log('Cancel');
        //   },
        // });
        setOpenModel({
            modalType: 'CONFIRM_ACTION',
            modalProps: {
                data: "",
                title: "WARNING!",
                subTitle: `Some environment variables are associated with services that are not being deployed. Do you want to continue with the environment setup?`,
                cancelButton: "Cancel",
                saveButton: "OK",
                onConfirm: handleSubmit,
                onCancel: () => { console.log("onCancel") },
                columnId: null,
                className: "large-Box"
            },
        });
    };

    const handleNumberChange = name => value => {
        form.setFieldValue(name, value);
        if (name === "minimumReplica" || name === "maximumReplica") {
            setAppData(appData => ({
                ...appData,

                deployments: {
                    ...appData.deployments,
                    autoScaling: {
                        ...appData.deployments.autoScaling,
                        autoScalingData: {
                            ...appData.deployments.autoScaling.autoScalingData,
                            [name]: value
                        }
                    }
                }
            }));
        }
        else if (name === "cpuAuto" || name === "memoryAuto") {
            setAppData(appData => ({
                ...appData,

                deployments: {
                    ...appData.deployments,
                    autoScaling: {
                        ...appData.deployments.autoScaling,
                        autoScalingData: {
                            ...appData.deployments.autoScaling.autoScalingData,
                            autoScalingParameter: {
                                ...appData.deployments.autoScaling.autoScalingData.autoScalingParameter,
                                [name]: value
                            }
                        }
                    }
                }
            }));
        }
    }

    const handleDomainBlur = (e) => {
        let val = e.target.value;
        if (val && appData.deployments.dns && appData.deployments.hostedAccount) {
            dnsCheck(val, appData.deployments.dns, appData.deployments.hostedAccount, appData.deployments.recordType, serviceSelected.name);
        } else {
            setDnsMsg({
                error: false,
                msg: ""
            });
        }
    }

    const handleChange = (e, idx) => {
        let val = (e.target.name === "entryPointCommandCrons" || e.target.name === "entryPointCommandQueues") ? e.target.value : e.target.value?.toString().trim();//.replace(/\s/g, '');
        form.setFieldValue(e.target.name, val);
        console.log("My change: ", e.target);
        if (e.target.name === "size" || e.target.name === "path" || e.target.name === "type" || e.target.name === "storageName") {
            appData.volumes[idx].storage.storageDes[e.target.name] = val;
            appData.volumes[idx].config = {
                configEnabled: false,
                configName: "",
                createConfig: "",
                createMountPath: "",
                configFileName: "",
            };
            appData.volumes[idx].secrets = {
                secretsEnabled: false,
                secretsName: "",
                createSecrets: "",
                createSecretsMountPath: "",
                secretsFileName: "",
            };
            setAppData({ ...appData, });
        }
        else if (e.target.name === "createConfig" || e.target.name === "createMountPath" || e.target.name === "configFileName" || e.target.name === "configName") {
            appData.volumes[idx].config[e.target.name] = val;
            appData.volumes[idx].storage = {
                createStorage: false,
                storageDes: {
                    storageName: "",
                    size: "",
                    type: "",
                    path: ""
                }
            };
            appData.volumes[idx].secrets = {
                secretsEnabled: false,
                secretsName: "",
                createSecrets: "",
                createSecretsMountPath: "",
                secretsFileName: "",
            };
            setAppData({ ...appData, });
        }
        else if (e.target.name === "createSecrets" || e.target.name === "createSecretsMountPath" || e.target.name === "secretsFileName" || e.target.name === "secretsName") {
            appData.volumes[idx].secrets[e.target.name] = val;
            appData.volumes[idx].storage = {
                createStorage: false,
                storageDes: {
                    storageName: "",
                    size: "",
                    type: "",
                    path: ""
                }
            };
            appData.volumes[idx].config = {
                configEnabled: false,
                configName: "",
                createConfig: "",
                createMountPath: "",
                configFileName: "",
            };

            setAppData({ ...appData, });
        }
        else if (e.target.name === "port" || e.target.name === "customDomain" || e.target.name === "domainHostUrl" || e.target.name === "domainHostName" || e.target.name === "healthCheckPath") {
            if (e.target.name === "domainHostUrl") {
                setAppData(appData => ({
                    ...appData,

                    deployments: {
                        ...appData.deployments,
                        [e.target.name]: val
                    }
                }));
                // dnsCheck.cancel();
                form.validateFields(['serviceType']);
                if (form.getFieldValue('domainHostUrl') !== "" && form.getFieldValue('gPath') !== "") {
                    form.validateFields(['gPath']);
                }
                setDnsMsg({
                    error: false,
                    msg: ""
                });
            }
            else {
                setAppData(appData => ({
                    ...appData,

                    deployments: {
                        ...appData.deployments,
                        [e.target.name]: val
                    }
                }));
            }
        }
        else if (e.target.name === "gPath" || e.target.name === "gPort" || e.target.name === "https") {
            setAppData(appData => ({
                ...appData,

                deployments: {
                    ...appData.deployments,
                    loadBalancer: {
                        ...appData.deployments.loadBalancer,
                        tcp: "",
                        udp: "",
                        lHttps: ""
                    },
                    gatewayHttps: {
                        ...appData.deployments.gatewayHttps,
                        [e.target.name]: val
                    }
                }
            }));
        }
        else if (e.target.name === "tcp" || e.target.name === "udp" || e.target.name === "lHttps") {
            setAppData(appData => ({
                ...appData,

                deployments: {
                    ...appData.deployments,
                    gatewayHttps: {
                        ...appData.deployments.gatewayHttps,
                        gPath: "",
                        gPort: "",
                        https: false
                    },
                    loadBalancer: {
                        ...appData.deployments.loadBalancer,
                        [e.target.name]: val
                    }
                }
            }));
        }
        else if (e.target.name === "spot" || e.target.name === "onDemand") {
            setAppData(appData => ({
                ...appData,

                deployments: {
                    ...appData.deployments,
                    instanceCapacityType: {
                        ...appData.deployments.instanceCapacityType,
                        [e.target.name]: val
                    }
                }
            }));
        }
        else if (e.target.name === "requestCpu" || e.target.name === "limitCpu" || e.target.name === "requestMem" || e.target.name === "limitMem") {
            if (e.target.name === "requestCpu" || e.target.name === "limitCpu") {
                if (e.target.name === "requestCpu") {
                    setAppData(appData => ({
                        ...appData,

                        deployments: {
                            ...appData.deployments,
                            resources: {
                                ...appData.deployments.resources,
                                cpu: {
                                    ...appData.deployments.resources.cpu,
                                    [e.target.name]: val,
                                    limitCpu: ""
                                }
                            }
                        }
                    }));
                    console.log("Entering change....", e.target.value);
                    form.setFieldValue('limitCpu', "");
                }
                else {
                    setAppData(appData => ({
                        ...appData,

                        deployments: {
                            ...appData.deployments,
                            resources: {
                                ...appData.deployments.resources,
                                cpu: {
                                    ...appData.deployments.resources.cpu,
                                    [e.target.name]: val
                                }
                            }
                        }
                    }));
                }
            }
            else {
                if (e.target.name === "requestMem") {
                    setAppData(appData => ({
                        ...appData,

                        deployments: {
                            ...appData.deployments,
                            resources: {
                                ...appData.deployments.resources,
                                memory: {
                                    ...appData.deployments.resources.memory,
                                    [e.target.name]: val,
                                    limitMem: ""
                                }
                            }
                        }
                    }));
                    form.setFieldValue('limitMem', "");
                }
                else {
                    setAppData(appData => ({
                        ...appData,

                        deployments: {
                            ...appData.deployments,
                            resources: {
                                ...appData.deployments.resources,
                                memory: {
                                    ...appData.deployments.resources.memory,
                                    [e.target.name]: val
                                }
                            }
                        }
                    }));
                }
            }
        }

        else if ((e.target.name === "entryPointCommandCrons") || (e.target.name === "entryPointCommandQueues")) {
            setAppData(appData => ({
                ...appData,

                deployments: {
                    ...appData.deployments,
                    taskSchedulers: {
                        ...appData.deployments.taskSchedulers,
                        [e.target.name]: val
                    }
                }
            }));
        }

        else if ((e.target.name === "name" || e.target.name === "value") && allOptions.deployments) {
            console.log("Tags triggered: ", form.getFieldsValue().tags);
            appData.deployments.tags[idx][e.target.name] = val;
            const updatedItems = form.getFieldsValue().tags.map((item, ind) =>
                ind === idx ? { ...item, [e.target.name]: val } : item
            );
            form.setFieldValue('tags', updatedItems);
            if (e.target.name === "value") {
                console.log("Validating...",);
                form.validateFields([["tags", idx, "name"]]);
            }
            else {
                console.log("Validating value: ",);
                form.validateFields([["tags", idx, "value"]]);
            }
            setAppData(appData => ({
                ...appData,
                deployments: {
                    ...appData.deployments
                }
            }));
            setRemoveIcon(false);
            //form.validateFields();
        }
        else {
            setAppData(appData => ({
                ...appData,

                basicDetails: {
                    ...appData.basicDetails,
                    [e.target.name]: val
                }
            }));
        }
    }

    const handleNodeSelectorChange = (e, idx) => {
        let val = e.target.value?.toString().trim();
        form.setFieldValue(e.target.name, val);
        console.log("Labels change: ", e.target);
        
        if (e.target.name === "labelName" || e.target.name === "labelValue") {
            const fieldName = e.target.name === "labelName" ? "name" : "value";
            console.log("Labels triggered: ", form.getFieldsValue().labels);
            
            if (!appData.deployments.labels) {
                appData.deployments.labels = [];
            }
            if (!appData.deployments.labels[idx]) {
                appData.deployments.labels[idx] = { name: "", value: "" };
            }
            appData.deployments.labels[idx][fieldName] = val;
            
            const updatedItems = form.getFieldsValue().labels.map((item, ind) =>
                ind === idx ? { ...item, [fieldName]: val } : item
            );
            form.setFieldValue('labels', updatedItems);
            
            setAppData(appData => ({
                ...appData,
                deployments: {
                    ...appData.deployments
                }
            }));
            setRemoveIcon(false);
        }
    }

    const handleSelectChange = (value, event, id) => {
        console.log("Out application data: ", applicationData, value);
        form.setFieldValue(event.name, value);
        //console.log("field value: ", form.getFieldValue(event.name));
        if (event.name === "branch" || event.name === "containerRegistryId" || event.name === "imageTag") {
            setAppData(appData => ({
                ...appData,
                basicDetails: {
                    ...appData.basicDetails,
                    [event.name]: value
                }
            }));
        }
        else if (event.name === "volumeType") {
            console.log("In application data: ", applicationData);
            appData.volumes[id] = {
                volumeType: value,
                // disabled:false,
                config: {
                    configEnabled: false,
                    createConfig: "",
                    createMountPath: "",
                    configFileName: "",
                    configName: ""
                },
                storage: {
                    createStorage: false,
                    storageDes: {
                        storageName: "",
                        size: "",
                        type: "EBS", //Fixed to EBS for now
                        path: ""
                    }
                },
                secrets: {
                    secretsEnabled: false,
                    createSecrets: "",
                    createSecretsMountPath: "",
                    secretsFileName: "",
                    secretsName: ""
                }
            }

            setAppData({
                ...appData,
                volumes: appData.volumes
            });
            console.log("Updated items: ", form.getFieldsValue());
            const updatedItems = form.getFieldsValue().volumeList.map((item, idx) =>
                idx === id ? { ...item, type: "EBS" } : item
            );
            form.setFieldsValue({ volumeList: updatedItems });
            setRemoveVolumeIcon(false);
            //setAppData({ ...appData });
        }
        else if (event.name === "type") {
            console.log("type entered");
            appData.volumes[id].storage.storageDes.type = value;
            setAppData({ ...appData });
        }
        else {
            console.log("Inside else");
            if (event.name === "endpointType") {
                setAppData(appData => ({
                    ...appData,

                    deployments: {
                        ...appData.deployments,
                        [event.name]: value,
                        serviceType: "",
                        customDomain: false,
                        domainHostUrl: "",
                        domainHostName: "",
                        acmCertificate: "",
                    }
                }));
                form.setFieldsValue({
                    'serviceType': null,
                    'domainHostUrl': "",
                    'domainHostName': "",
                    'acmCertificate': ""
                });
            }
            else if (event.name === "serviceType") {
                setAppData(appData => ({
                    ...appData,

                    deployments: {
                        ...appData.deployments,
                        [event.name]: value,
                        customDomain: false,
                        domainHostUrl: "",
                        domainHostName: "",
                        acmCertificate: "",
                        gatewayHttps: {
                            ...appData.deployments.gatewayHttps,
                            gPath: ""
                        }
                    }
                }));
                form.setFieldsValue({
                    'domainHostUrl': "",
                    'domainHostName': "",
                    'gPath': "",
                    'acmCertificate': ""
                });
            }
            // else if (event.name === "nodeGroupName") {
            //     setAppData(appData => ({
            //         ...appData,

            //         deployments: {
            //             ...appData.deployments,
            //             nodeGroupName: value,
            //             nodeGroupType: event['data-alias'],
            //         }
            //     }));
            // }
            else {
                setAppData(appData => ({
                    ...appData,

                    deployments: {
                        ...appData.deployments,
                        [event.name]: value
                    }
                }));
            }
        }
    };

    const handleMultiSelectChange = (value, event, id) => {
        console.log("Out application data: ", applicationData);
        console.log("value, event :", value, event);
        form.setFieldValue("nodegroupName", value);

        let listOfNods = [];
        if (event && Array.isArray(event)) {
            event.map((temp, ind) => {
                listOfNods.push({
                    nodegroup_name: temp.value,
                    nodegroup_type: temp["data-alias"],
                    nodegroup_unique_id: temp["key"],
                    arch_type: temp["data-arch"]
                })
            })
        }

        console.log("listOfNods :", listOfNods);
        setAppData(appData => ({
            ...appData,

            deployments: {
                ...appData.deployments,
                nodeGroupName: value,
                // nodeGroupType: event['data-alias'],
                listOfNodegroups: listOfNods,
            }
        }));
    }

    const filterBranches = (input, option) => (option?.value.toLowerCase() ?? '').includes(input.toLowerCase());
    const switchChange = (checked, event) => {
        console.log(event);
    }

    const onFinish = () => {
        setSubmitAll({
            ...submitAll,
            [serviceSelected.name]: true,
        });
        message.success('Submit success!');
    };
    const onFinishFailed = () => {
        message.error('Submit failed!');
    };

    // const validateName = (rule, value, callback) => {
    //     if (/\s/.test(value)) {
    //         callback('App Name should not contain spaces');
    //     } else {
    //         callback();
    //     }
    // }

    const validateMaxReplica = (rule, value, callback) => {
        if (appData.deployments.autoScaling.enabled && form.getFieldsValue(["minimumReplica"]).minimumReplica > value?.toString().trim()) {
            callback('Maximum replica should be greater than minimum replica.');
        }
        else {
            callback();
        }
    }

    // const validateMinReplica = (rule, value, callback) => {
    //     console.log("My value: ", value);
    //     if (value?.toString().trim() < 1 && value?.toString().trim() !== null) {
    //         callback("Minimum replica must be at least 1.");
    //     }
    //     else {
    //         callback();
    //     }
    // }

    const validateResources = (rule, value, callback) => {
        console.log("Rule: ", rule, appData.deployments.resources.cpu.requestCpu !== "");
        let val = value?.toString().trim();
        if (value) {
            val = value.toString().replace(/\s/g, '');
        }
        if (!val) {
            callback();
        }
        else if (isNaN(val)) {
            callback("This field should contain only numbers.");
        }
        else if (parseInt(val) < parseInt("100")) {
            if (rule.field === "requestCpu") {
                callback("Minimum CPU should be at least 100m.");
            }
            else if (rule.field === "limitCpu") {
                callback("Maximum CPU limit should be at least 100m.");
            }
            else if (rule.field === "requestMem") {
                callback("Minimum Memory should be at least 100m.");
            }
            else {
                callback("Maximum Memory should be at least 100mi.");
            }
        }
        else {
            if (rule.field === "limitCpu" && parseInt(appData.deployments.resources.cpu.requestCpu) > parseInt(val)) {
                console.log("Enters", rule, appData.deployments.resources.cpu.requestCpu, value);
                callback("Maximum CPU should be greater than Minimum CPU.");
            }
            else if (rule.field === "limitMem" && parseInt(appData.deployments.resources.memory.requestMem) > parseInt(val)) {
                callback("Maximum Memory should be greater than Minimum Memory.");
            }
            else {
                callback();
            }
        }
    }

    const validatePercentage = (rule, value, callback) => {
        let val = value?.toString().trim();
        // if(value && value !== ""){
        //     val = value.replace(/\s/g, '');
        // }
        if (appData.deployments.autoScaling.enabled && val) {
            if (rule.field === "cpuAuto") {
                if (isNaN(val)) {
                    callback("Please enter a valid percentage.");
                }
                // else if (parseInt(val) <= 0) {
                //     callback("CPU Percentage should be greater than 0.");
                // }
                else {
                    callback();
                }
            }
            else {
                if (isNaN(val)) {
                    callback("Please enter a valid percentage.");
                }
                // else if (parseInt(val) <= 0) {
                //     callback("Memory Percentage should be greater than 0.");
                // }
                else {
                    callback();
                }
            }
        }
        else {
            callback();
        }
    }

    const validatePort = (rule, value, callback) => {
        let val = value?.toString().trim();
        if (!val || val === "") {
            callback("Please enter service port!");
        }
        if (isNaN(val)) {
            callback("Please enter a valid port.");
        }
        else {
            if (parseInt(value) < 0 || parseInt(val) > 65535) {
                callback("Port should have a value between 0 to 65535");
            }
            else {
                callback();
            }
        }
    }

    const validatePrefix = (rule, value, callback) => {
        // if(prefixCheck){
        //     callback("Combination of Domain host url and prefix should be unique");
        // }
        // else{
        //     callback();
        // }
        let myVal = value?.toString().trim();
        if (appData.deployments.domainHostUrl !== "" && myVal) {
            // let test = false;
            // Object.keys(applicationData).some((val) => {
            //     if (val !== serviceSelected.name) {
            //         if (applicationData[val].deployments.domainHostUrl + applicationData[val].deployments.gatewayHttps.gPath ===
            //             appData.deployments.domainHostUrl + value) {
            //                 callback("Combination of Domain host url and prefix should be unique");
            //                 test = true;
            //                 return true;
            //         }
            //         // else{
            //         //     callback();
            //         // }
            //     }
            //     // else{
            //     //     callback();
            //     // }
            // });

            // if(!test){
            //     callback();
            // }
            console.log("Application inside path: ", applicationData);
            console.log("appappData inside path: ", appData);
            let resArr = [];
            if (addDep) {
                resArr = Object.keys(addUpdatedData.applicationData).filter((val) => {
                    if (val !== serviceSelected.name) {
                        return addUpdatedData.applicationData[val].serviceEnabled && addUpdatedData.applicationData[val].deployments.domainHostUrl + addUpdatedData.applicationData[val].deployments.gatewayHttps.gPath === appData.deployments.domainHostUrl + myVal;
                    }
                    else {
                        return false;
                    }
                });
            }
            else if (updateDep) {
                resArr = Object.keys(updatedData.applicationData).filter((val) => {
                    if (val !== serviceSelected.name) {
                        return updatedData.applicationData[val].serviceEnabled && updatedData.applicationData[val].deployments.domainHostUrl + updatedData.applicationData[val].deployments.gatewayHttps.gPath === appData.deployments.domainHostUrl + myVal;
                    }
                    else {
                        return false;
                    }
                });
            }
            else if (!cloneDep) {
                resArr = Object.keys(applicationData).filter((val) => {
                    if (val !== serviceSelected.name) {
                        return applicationData[val].serviceEnabled && applicationData[val].deployments.domainHostUrl + applicationData[val].deployments.gatewayHttps.gPath === appData.deployments.domainHostUrl + myVal;
                    }
                    else {
                        return false;
                    }
                });
            }
            else {
                resArr = Object.keys(cloneApplicationData).filter((val) => {
                    if (val !== serviceSelected.name) {
                        return cloneApplicationData[val].serviceEnabled && cloneApplicationData[val].deployments.domainHostUrl + cloneApplicationData[val].deployments.gatewayHttps.gPath === appData.deployments.domainHostUrl + myVal;
                    }
                    else {
                        return false;
                    }
                });
            }
            console.log("Resarr: ", resArr);
            if (resArr.length >= 1) {
                callback("In an environment, combination of domain and path for all the enabled applications should be unique.");
            }
            else {
                callback();
            }
        }
        else {
            callback();
        }
    }

    const validateType = (rule, value, callback) => {
        let myVal = value?.toString().trim();//value.replace(/\s/g, '');
        if (appData.deployments.domainHostUrl !== "") {
            // let resArr = Object.keys(applicationData).filter((val) => {
            //     return applicationData[val].serviceEnabled === true;
            // });
            let resArr = [];
            if (addDep) {
                resArr = Object.entries(addUpdatedData.applicationData);
            }
            else if (updateDep) {
                resArr = Object.entries(updatedData.applicationData);
            }
            else if (!cloneDep) {
                resArr = Object.entries(applicationData);
            }
            else {
                resArr = Object.entries(cloneApplicationData);
            }
            // if (resArr.includes(appData.deployments.domainHostUrl)){
            //     if(!Object.keys(applicationData).map((val) => {
            //         return applicationData[val].serviceEnabled && applicationData[val].deployments.domainHostUrl;
            //     }).includes(appData.deployments.domainHostUrl)){

            //     }
            // }
            console.log("Res arr: ", resArr);
            let finalArr = resArr.filter((val) => {
                if (val[0] !== serviceSelected.name) {
                    console.log("My vals diff: ", val[1].deployments.serviceType, myVal);
                    if (val[1].deployments.serviceType !== myVal &&
                        val[1].deployments.domainHostUrl === appData.deployments.domainHostUrl && val[1].serviceEnabled) {
                        return val;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return false;
                }
            });
            console.log("Final arr: ", finalArr);
            if (finalArr.length > 0) {
                callback("In an environment, service type for all the enabled applications should be the same if those applications have same domain host.");
            }
            else {
                callback();
            }
        }
        // else if (!selectedServiceTypes.includes(myVal)) {
        //     callback("Please select a valid load balancer type from dropdown. Selected load balancer type may not exist in chosen cluster.");
        // }
        else {
            callback();
        }
    }

    const validateSize = (rule, value, callback) => {
        let val = value?.toString().trim();
        if (!val || val === "") {
            callback();
        }
        else if (isNaN(val)) {
            callback("Please enter a valid storage size.");
        }
        if (parseInt(val) < 5) {
            callback("Storage size should be at least 5GB.");
        }
        else {
            callback();
        }
    }

    function toggleAlert(type, message, description, timeoutMs = 5 * 1000) {
        console.log("Toggle alert called: ");
        set_alertOptions(alertOptions => ({
            status: true,
            type: type,
            message: message,
            description: description,
        }));

        // opacity=0 after 10sec
        setTimeout(() => {
            set_alertOptions(alertOptions => ({
                status: false,
                type: type,
                message: message,
                description: description,
            }));
        }, timeoutMs);
    }

    const handleCancelButton = () => {
        setAppData({});
        let envId = location.pathname.split('/').slice(-1)[0];
        navigate(`/environments/environment/${envId}/env-overview`);
        // navigate(-1);
    }

    const validateNodegroups = (rule, value, callback) => {
        console.log("enters node validate: ", appData.deployments.listOfNodegroups);
        let checkAmd = false, checkArm = false;
        appData.deployments.listOfNodegroups.forEach((val) => {
            if (val.arch_type?.includes("amazon_linux_2_amd")) {
                checkAmd = true;
            }
            else if (val.arch_type?.includes("amazon_linux_2_arm")) {
                checkArm = true;
            }
        });
        if (checkAmd && checkArm) {
            callback("The selected nodegroups should not be a combination of AMD and ARM types");
        }
        else {
            callback();
        }
    }

    let items = [
        {
            name: 'Deployment',
            info: "Deployment manages stateless application workloads by overseeing a set of Pods."
        },
        {
            name: 'StatefulSet',
            info: "StatefulSet runs a group of Pods with persistent identities, ideal for applications requiring stable storage or unique network identities."
        },
        {
            name: 'Job & CronJob',
            info: "Manages one-time or scheduled tasks, with Job running tasks to completion and CronJob running them on a schedule."
        },
    ];

    items = useMemo(() => {
        return items.map((val, idx) => {
            return {
                label: <div style={{ width: "343px", display: "flex", flexDirection: "column", ...detailSubTextStyle, color: (val.name === appData.deployments.yamlType) ? "#4D99EF" : "#5E6366", marginLeft: "0", borderBottom: idx !== items.length - 1 ? "1px solid #eeeef2" : "", padding: "10px 15px" }} onClick={() => {
                    setAppData(appData => ({
                        ...appData,
                        deployments: {
                            ...appData.deployments,
                            yamlType: val.name,
                        }
                    }));
                    console.log("Setting yaml data: ", appData.deployments);
                    setYamlData(appData.deployments[val.name].yamlString);
                    console.log("My val: ", val, appData.deployments[val.name].yamlString);
                    form.setFieldValue("yamlData", appData.deployments[val.name].yamlString);
                    console.log("Setting form: ", form.getFieldsValue(["yamlData"]));
                }}>
                    <div>
                        <img src={val.name === appData.deployments.yamlType ? fileIconSelected : fileIcon} style={{ height: "15px", width: "15px" }} alt="icon" />
                        {/* {val.service_name === "Add new service" && <img src={plusIcon} style={{ height: "14px", width: "14px" }} alt="icon" />} */}
                        <span style={{ marginLeft: "10px", transform: "translateY(3px)", fontSize: "12px", height: "20px" }}>{val.name}</span>
                    </div>
                    <p style={{ marginTop: "10px", fontSize: "10px", fontWeight: "300", fontFamily: "Nunito Sans" }}>{val.info}</p>
                </div>,
                key: val.name
            };
        })
    }, [appData.deployments]);

    const handleFieldsChange = (changedFields) => {
        console.log("Fields changed: ", changedFields);
        const fieldsToUpdate = changedFields.map((val) => {
            const fieldName = val.name[0]; // 'name' is an array; we use the first item
            // const warningMessage = warnings[fieldName]; // Access stored warning for the field
            console.log("Getting val: ", val, warningsRef);

            return {
                name: fieldName,
                warnings: warningsRef.current.find(x => x.name === fieldName)?.warnings, // Apply warning if exists
                errors: val.errors, // Retain any validation errors
            };
        });
        console.log("Fields to update: ", fieldsToUpdate);
        form.setFields(fieldsToUpdate);
    }

    const validateDNS = (rule, value, callback) => {
        const dnsRegex = /^[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;
        let val = value?.toString().trim();
        if (!val || val === "") {
            callback();
        }
        else if (!dnsRegex.test(val)) {
            callback("Please enter a valid DNS zone.");
        }
        else {
            callback();
        }
    }

    // AWS ACM RequestCertificate DomainName: length 1-253, pattern
    // (\*\.)?(((?!-)[A-Za-z0-9-]{0,62}[A-Za-z0-9])\.)+((?!-)[A-Za-z0-9-]{1,62}[A-Za-z0-9])
    const validateAcmCertificate = (rule, value, callback) => {
        let val = value?.toString().trim();
        if (!val || val === ACM_CREATE_NEW) {
            callback();
        }
        else if (val.length > 253 || !/^(\*\.)?(((?!-)[A-Za-z0-9-]{0,62}[A-Za-z0-9])\.)+((?!-)[A-Za-z0-9-]{1,62}[A-Za-z0-9])$/.test(val)) {
            callback("Enter a valid certificate domain name, e.g. app.example.com or *.example.com");
        }
        else if (acmZoneMismatch(val, appData.deployments.dns)) {
            callback(`Certificate domain must be ${normalizeDomain(appData.deployments.dns)} or a subdomain of it`);
        }
        else {
            callback();
        }
    }

    const validateMountPath = (rule, value, callback) => {
        const pathRegex = /^\/[a-zA-Z0-9_-]+\/[a-zA-Z0-9_-]+$/;
        let val = value;
        if (!val || val === "") {
            callback();
        }
        else if (val.endsWith("/")) {
            callback("Mount path should not end with /");
        }
        // else if (!pathRegex.test(val)) {
        //     callback('Invalid path format. It should be in the format /<folder-name>/<file-name>');
        // }
        else {
            callback();
        }
    }

    const handleSearch = (input) => {
        console.log("Getting search input...", input);
        setSearchValue(input);
        // Only filter if user typed something
        if (input) {
            setFilteredOptions(
                dnsList.filter((option) =>
                    option.value.toLowerCase().includes(input.toLowerCase())
                )
            );
        } else {
            setFilteredOptions(dnsList); // Show full list on focus or empty input
        }
    };

    const openDrawer = () => {
        setOpenRightDrawer({
            drawerType: "advanceYamlInfoRightDrawer",
            drawerProps: {
                columnId: "Atmosly Template Variables",
            },
        });
    }

    // Check if form data has changed from initial state
    const hasFormDataChanged = () => {
        console.log("Has form data changed called: ", updateDep, initialFormData);
        if (!updateDep || !initialFormData){
            // setTooltip(false);
            return false;
        }
        
        const currentFormData = form.getFieldsValue();
        
        // Handle the case where domain field might be added later
        const normalizedCurrentData = { ...currentFormData };
        const normalizedInitialData = { ...initialFormData };
        
        // If domain field is missing from initial data but present in current data, 
        // add it to initial data with the same value to avoid false positive
        if (!("domain" in normalizedInitialData) && "domain" in normalizedCurrentData) {
            normalizedInitialData.domain = normalizedCurrentData.domain;
            setInitialFormData({...initialFormData, domain: normalizedCurrentData.domain});
        }
        
        // Deep comparison function that handles type differences (int vs string)
        const deepCompare = (obj1, obj2) => {
            if (obj1 === obj2) return true;
            if (obj1 === null || obj1 === undefined || obj2 === null || obj2 === undefined) {
                return obj1 === obj2;
            }
            if (typeof obj1 !== typeof obj2) {
                // Handle type coercion for numbers and strings
                if ((typeof obj1 === 'number' && typeof obj2 === 'string') || 
                    (typeof obj1 === 'string' && typeof obj2 === 'number')) {
                    return Number(obj1) === Number(obj2);
                }
                return false;
            }
            if (typeof obj1 !== 'object') return obj1 === obj2;
            
            if (Array.isArray(obj1) !== Array.isArray(obj2)) return false;
            
            if (Array.isArray(obj1)) {
                if (obj1.length !== obj2.length) return false;
                for (let i = 0; i < obj1.length; i++) {
                    if (!deepCompare(obj1[i], obj2[i])) return false;
                }
                return true;
            }
            
            const keys1 = Object.keys(obj1);
            const keys2 = Object.keys(obj2);
            if (keys1.length !== keys2.length) return false;
            
            for (let key of keys1) {
                if (!keys2.includes(key)) return false;
                if (!deepCompare(obj1[key], obj2[key])) return false;
            }
            return true;
        };
        
        // Check if form data has changed
        const formDataChanged = !deepCompare(normalizedCurrentData, normalizedInitialData);
        
        // Check if environment variables have changed
        const envVarsChanged = initialEnvData ? !deepCompare(appData.environments, initialEnvData) : false;
        
        // Check if account details have changed
        const accountDetailsChanged = initialAccountDetails ? !deepCompare(currentTaskAccountDetails, initialAccountDetails) : false;
        
        const hasChanged = formDataChanged || envVarsChanged || accountDetailsChanged;
        console.log("Form data changed:", formDataChanged, "Env vars changed:", envVarsChanged, "Account details changed:", accountDetailsChanged, "Overall changed:", hasChanged);
        // console.log("Current form:", normalizedCurrentData, "Initial form:", normalizedInitialData);
        // console.log("Current envs:", appData.environments, "Initial envs:", initialEnvData);
        console.log("Current account details:", currentTaskAccountDetails, "Initial account details:", initialAccountDetails);
        
        // update the context for topbar button enable/disable
        setEditServiceDataChanged(!hasChanged);
        if(!hasChanged){
            setTooltip("No changes detected. Make changes to enable re-deploy.");
        }
        else{
            setTooltip(false);
        }
        return hasChanged;
    };

    // Check if app data has changed from initial state
    // const hasAppDataChanged = () => {
    //     if (!updateDep || !initialApplicationData) return false;
        
    //     const hasChanged = JSON.stringify(appData) !== JSON.stringify(initialApplicationData);
    //     console.log("App data changed:", hasChanged, "Current:", appData, "Initial:", initialApplicationData);
    //     return hasChanged;
    // };

    // Memoize environments string for comparison
    const environmentsStr = useMemo(() => {
        return appData?.environments ? JSON.stringify(appData.environments) : '';
    }, [appData?.environments]);

    // Trigger change detection when environment variables or account details change
    useEffect(() => {
        if (updateDep && initialFormData && initialEnvData) {
            // Force re-evaluation of hasFormDataChanged when env vars or account details change
            const hasChanged = hasFormDataChanged();
            console.log("Environment variables or account details changed, re-evaluating form changes:", hasChanged);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [environmentsStr, currentTaskAccountDetails, updateDep, initialFormData, initialEnvData, initialAccountDetails]);


    // to change secret manager integration
    const handleChangeSource = (e) => {
        e.stopPropagation();
        console.log("My project: ", currentTaskAccountDetails);
        
        // Ensure the currentProjectDep has the updated account details for the current task
        const updatedProjectDep = {
            ...currentProjectDep,
            tasks: currentProjectDep?.tasks?.map((task, idx) => {
                if (idx === serviceIdx) {
                    return {
                        ...task,
                        accountDetails: {
                            ...(currentTaskAccountDetails || task.accountDetails),
                            secret_name: task.secret_name,
                        }
                    };
                }
                return task;
            })
        };
        
        setOpenModel({
          modalType: 'DETAILS_MODAL',
          modalProps: {
            component: <SecretManagerModal 
                selectedAppId={keySelected} 
                currentProject={updatedProjectDep} 
                setCurrentProject={setCurrentProjectDep} 
                fromEnvironment={true}
                secretName={currentProjectDep?.tasks?.[serviceIdx]?.secret_name}
            />,
            cancelButton: "Cancel",
            saveButton: "Save",
            maskClosable: false,
            // data: item,
            // title: section.toUpperCase(),
            // subTitle: `Please provide the name of the ${section} to be deleted`,
            // onDelete: onDelete,
            // columnId: null,
          },
        });
        //}
    }

    // const handleChangeSecretName = () => {
    //     let secretName = currentProjectDep.tasks.find(val => val.id === serviceIdx)?.secret_name;
    //     console.log("handleChangeSecretName -> secretName :", secretName);
    //     setOpenModel({
    //         modalType: 'CHANGE_SECRET_NAME',
    //         modalProps: {
    //             data: {
    //                 name: secretName
    //             },
    //             title: "Change Secret Name",
    //             subTitle: "",
    //             cancelButton: "Cancel",
    //             saveButton: "Change",
    //             onChange: (taskName) => {
    //                 console.log("onChange :", taskName);
    //                 currentProjectDep.tasks.map((temp, idx) => {
    //                     if (temp.id === serviceIdx) {
    //                         // let tempEnvData = {...envData}
    //                         currentProjectDep.tasks[idx].secret_name = taskName;
    //                     }
    //                 });

    //                 setCurrentProjectDep({ ...currentProjectDep, tasks: [...currentProjectDep.tasks] });
    //                 localStorage.setItem("ProjectDep", JSON.stringify({ ...currentProjectDep, tasks: [...currentProjectDep.tasks] }));
                    
    //                 // Close this if user confirmed execution
    //                 setOpenModel({
    //                     modalType: false,
    //                     modalProps: {
    //                         data: ""
    //                     },
    //                 });
    //             },
    //             handleCancel: () => { 
    //                 console.log("onCancel");
    //                 setOpenModel({
    //                 modalType: false,
    //                 modalProps: {
    //                     data: ""
    //                 },
    //                 });
    //             },
    //             columnId: null,
    //             className: "large-Box"
    //         },
    //     });
    // }

    const updateDisabled = updateDep ? (!hasFormDataChanged() || yamlLabelWarning) : yamlLabelWarning;
    const redeployDisabled = updateDisabled || refreshNodegroups || isNodegroupValidationInProgress;
    const redeployTooltip = yamlLabelWarning
        ? 'Labels contain a key with the reserved "atmosly_app" prefix. Remove it to enable re-deploy.'
        : refreshNodegroups || isNodegroupValidationInProgress
            ? "Validating nodegroups. Please wait..."
            : updateDisabled
                ? "No changes detected. Make changes to enable re-deploy."
                : "";
    return (
        // <Scrollbars style={{ width: '100%', height: 'calc(100vh - 350px' }}>
        <div ref={targetRef} style={serviceSelected.isActive ? { width: "100%", padding: "10px 20px 0 10px" } : { width: "100%", padding: "10px 20px 0 10px", opacity: "0.5", pointerEvents: "none" }}>
            {console.log("Current form data: ", form.getFieldsValue())}
            <Alert
                message={alertOptions.message}
                description={alertOptions.description}
                type={alertOptions.type}
                showIcon
                style={alertOptions.status ? marginsBot : fadeMarginBot}
            />
            {/* Banner notification for applications in isImportedNoCloud clusters */}
            {depData?.provisioner === 'imported' && appData.basicDetails.sourceType === "Git Repositories" && (
                <Alert
                    message="Node Affinity Configuration"
                    description={
                        <span>
                            Add the label
                            <span style={{ fontWeight: 'bold'}}> key : </span> <span style={{ color: '#E6007E', borderRadius: '4px', fontWeight: 'bold', fontSize: '14px'}}> atmosly 
                            </span> <span style={{ fontWeight: 'bold'}}> value : </span> <span style={{ color: '#E6007E', borderRadius: '4px', fontWeight: 'bold', fontSize: '14px'}}> ci-cd </span>
                            to the nodes you want to use for CI.
                            If no node has this label, CI will fall back to any available node.
                        </span>
                    }
                    type="info"
                    showIcon
                    closable={true}
                    style={{ marginBottom: '20px', borderRadius: '8px' }}
                />
            )}
            <Form form={form} name={serviceSelected.name} onFinish={handleSubmit} onFieldsChange={handleFieldsChange} validateTrigger="onBlur" onFinishFailed={onFinishFailed}>
                <div style={{ marginBottom: "40px", cursor: "pointer" }} onClick={() => {
                    let options = {
                        ...allOptions,
                        basicDetails: !allOptions.basicDetails,
                    };
                    setAllOptions({
                        ...options,
                    });
                }}>
                    <Box title={<div style={{ display: "flex", justifyContent: "space-between", width: "100%" }} >
                        <p style={innerTitleStyle}> Basic Details </p>
                        <img src={!allOptions.basicDetails ? downIcon : upIcon} style={{ width: "12px", height: "16px" }} />
                    </div>} titleStyle={innerTitleStyle} style={{ borderRadius: "20px" }}>
                        {allOptions.basicDetails && <div style={{ marginTop: "20px", cursor: "default" }} onClick={(e) => {
                            e.stopPropagation();
                        }}>
                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
                                <div style={fieldStyles}>
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <Label style={{ ...labelStyle }}> App Name* </Label>
                                        <CustomInfoTooltip title={"App name is 63 characters or fewer, uses lowercase alphanumeric characters, starts and ends with an alphanumeric character, and contains no spaces."} placement="bottomLeft" />
                                        {/* <Tooltip title={"App name is 63 characters or fewer, uses lowercase alphanumeric characters, starts and ends with an alphanumeric character, and contains no spaces."} placement="bottomLeft">
                                            <InfoCircleFilled style={{ transform: "translateY(-4px)", color: "#8896A1" }} />
                                        </Tooltip> */}
                                    </div>
                                    <Form.Item
                                        name="appName"
                                        rules={[
                                            {
                                                validator: validateName
                                            },
                                            {
                                                validator: validateNameUnique
                                            },
                                            {
                                                validator: validateSpaces
                                            }
                                        ]}
                                    >
                                        <Input data-testid={`service-app-name-input-${serviceIdx}`} placeholder="Enter name" disabled={updateDep} style={inputStyle} value={appData.basicDetails?.appName} name="appName" onBlur={handleChange} />
                                    </Form.Item>
                                </div>

                                <div style={fieldStyles}>
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <Label style={{ ...labelStyle }}> Application Source Type </Label>
                                        {/* {!serviceSelected.configuration.is_owner && <CustomInfoTooltip title={"You are not the repo owner"} placement="bottomLeft" />} */}
                                    </div>
                                    <Form.Item
                                        name="sourceType"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please enter a url!',
                                            },
                                            // {
                                            //     validator: validateSpaces
                                            // }
                                        ]}
                                    >

                                        <Input data-testid="service-source-type-input" placeholder="Select Application source type" disabled style={inputStyle} value={appData.basicDetails?.sourceType} name="sourceType" />
                                    </Form.Item>
                                </div>

                                {/* {appData.basicDetails.sourceType === "Container Registry" && <div style={fieldStyles}>
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <Label style={{ ...labelStyle }}> Image Repo* </Label>
                                    </div>
                                    <Form.Item
                                        name="imageRepo"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please enter a url!',
                                            },
                                        ]}
                                    >

                                        <Input placeholder="Select Image Repo" style={inputStyle} disabled value={appData.basicDetails.imageRepo} name="imageRepo" />
                                    </Form.Item>
                                </div>} */}
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
                                {appData.basicDetails.sourceType === "Git Repositories" && <>
                                    <div style={fieldStyles}>
                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                            <Label style={{ ...labelStyle }}> Git Source* </Label>
                                            {!serviceSelected?.configuration?.is_owner && <CustomInfoTooltip title={"You are not the repo owner"} placement="bottomLeft" />}
                                        </div>
                                        <Form.Item
                                            name="url"
                                            rules={hasApiError("url") ? [
                                                {
                                                    validator: customApiValidator,
                                                }
                                            ] : [
                                                {
                                                    required: true,
                                                    message: 'Please enter a url!',
                                                },
                                                // {
                                                //     validator: validateSpaces
                                                // }
                                            ]}
                                        >

                                            <Input data-testid="service-url-input" placeholder="Enter URL" style={inputStyle} disabled value={appData.basicDetails?.url} name="url" onBlur={handleChange} />
                                        </Form.Item>
                                    </div>
                                    <div style={fieldStyles}>
                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                            <Label style={{ ...labelStyle }}> Branch* </Label>
                                            <CustomInfoTooltip title={deploymentHelpChecks.application.branch} placement="bottomLeft" />
                                        </div>
                                        <Form.Item
                                            name="branch"
                                            rules={hasApiError("branch") ? [
                                                {
                                                    validator: customApiValidator,
                                                }
                                            ] : [
                                                {
                                                    required: true,
                                                    message: 'Please select a branch!',
                                                },
                                            ]}
                                        >
                                            <Select style={{ width: '100%' }}
                                                disabled={updateDep}
                                                showSearch
                                                //filterOption={filterBranches}
                                                filterSort={(optionA, optionB) => customSortOptions(optionA, optionB, searchValue)} // Custom sorting function
                                                filterOption={(inputValue, option) => customFilterOption(inputValue, option)} // Custom filtering function
                                                //getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                                data-testid={`service-branch-select-${serviceIdx}`}
                                                placeholder="Select branch"
                                                // value={appData.basicDetails.branch === "" ? null : appData.basicDetails.branch}
                                                onSearch={(value) => {
                                                    setSearchValue(value);
                                                }}
                                                onChange={handleSelectChange}
                                                notFoundContent={branchLoad ? <Spin size="small" /> : null}
                                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                            >
                                                {repoList}
                                            </Select>
                                        </Form.Item>
                                    </div>
                                </>}
                                {appData.basicDetails.sourceType === "Container Registry" && <>
                                    <div style={fieldStyles}>
                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                            <Label style={{ ...labelStyle }}> App Source* </Label>
                                            {/* <CustomInfoTooltip title={"Build context for this build is the root directory of the git repo."} placement="bottomLeft" /> */}
                                        </div>
                                        <Form.Item
                                            name="appSource"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please enter app source!',
                                                },
                                                // {
                                                //     validator: validateSpaces
                                                // }
                                            ]}
                                        >
                                            <div style={{ height: "44px" }}>
                                                <Input data-testid="service-app-source-input" placeholder="Enter app source" disabled style={inputStyle} value={appData.basicDetails?.appSource === "PUBLIC" ? appData.basicDetails?.appSource : !appData.basicDetails.appSource?.account_id ? `${appData.basicDetails.appSource?.alias} - ${appData.basicDetails.appSource?.integration_type}` : `${appData.basicDetails.appSource?.account_id}${appData.basicDetails.appSource?.alias ? `(${appData.basicDetails.appSource?.alias})` : ``} / ${appData.basicDetails.appSource?.region}`} name="appSource" />
                                            </div>
                                        </Form.Item>
                                    </div>
                                    <div style={fieldStyles}>
                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                            <Label style={{ ...labelStyle }}> Image Repo* </Label>
                                            {/* <CustomInfoTooltip title={deploymentHelpChecks.application.containerRegistryId} placement="bottomLeft" /> */}
                                        </div>
                                        <Form.Item
                                            name="imageRepo"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please select an image repo!',
                                                },
                                                // {
                                                //     validator: validateSpaces
                                                // }
                                            ]}
                                        >
                                            <Input data-testid="service-image-repo-input" disabled placeholder="Select Image repo" style={inputStyle} value={appData.basicDetails?.imageRepo} />
                                        </Form.Item>
                                    </div>
                                </>}
                                {/* <div style={fieldStyles}>
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <Label style={{ ...labelStyle }}> Docker File Path* </Label>
                                        <CustomInfoTooltip title={"Build context for this build is the root directory of the git repo."} placement="bottomLeft" />
                                    </div>
                                    <Form.Item
                                        name="dockerFilePath"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please enter docker file path!',
                                            },
                                        ]}
                                    >
                                        <div style={{ height: "44px" }}>
                                            <Input data-testid={`service-dockerfile-path-input-${serviceIdx}`} placeholder="Enter path" addonBefore='./' value={appData.basicDetails.dockerFilePath} name="dockerFilePath" onBlur={handleChange} />
                                        </div>
                                    </Form.Item>
                                </div> */}
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                {appData.basicDetails.sourceType === "Git Repositories" && <>

                                    {/* <div style={fieldStyles}>
                            <Label style={labelStyle}> Build Context </Label>
                            <Input data-testid="service-build-context-input" placeholder="Enter Context" style={inputStyle} value={appData.basicDetails.context} name="context" onBlur={handleChange} />
                        </div> */}
                                    <div style={fieldStyles}>
                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                            <Label style={{ ...labelStyle }}> Docker File Path* </Label>
                                            <CustomInfoTooltip title={"Specify the path to the Dockerfile within your repository. This file contains the instructions to build your application's Docker image."} placement="bottomLeft" />
                                        </div>
                                        <Form.Item
                                            name="dockerFilePath"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please enter docker file path!',
                                                },
                                                {
                                                    validator: validateSpaces
                                                }
                                            ]}
                                        >
                                            <Input data-testid={`service-dockerfile-path-input-git-${serviceIdx}`} placeholder="Enter path" addonBefore='./' value={appData.basicDetails?.dockerFilePath} name="dockerFilePath" onBlur={handleChange} disabled={updateDep} />
                                        </Form.Item>
                                    </div>
                                    {/* commented for build context */}
                                    <div style={fieldStyles}>
                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                            <Label style={{ ...labelStyle }}> Build Context </Label>
                                            <CustomInfoTooltip title={"Please specify the path where the docker build command will be executed."} placement="bottomLeft" />
                                        </div>
                                        <div style={{ height: "44px" }}>
                                            <Form.Item
                                                name="buildContext"
                                                rules={[
                                                    {
                                                        validator: validateSpaces
                                                    }
                                                ]}
                                            // rules={[
                                            //     {
                                            //         required: true,
                                            //         message: 'Please enter build context!',
                                            //     },
                                            // ]}
                                            >
                                                <Input data-testid={`service-build-context-path-input-${serviceIdx}`} placeholder="Enter path" addonBefore='./' value={appData.basicDetails?.buildContext} name="buildContext" onBlur={handleChange} disabled={updateDep} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    {/* Added for removal of build context */}
                                    {/* <div style={fieldStyles}>
                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                            <Label style={{ ...labelStyle }}> Container Registry* </Label>
                                            <CustomInfoTooltip title={deploymentHelpChecks.application.containerRegistryId} placement="bottomLeft" />
                                        </div>
                                        <Form.Item
                                            name="containerRegistryId"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please select a container registry!',
                                                },
                                            ]}
                                        >
                                            <Select data-testid={`service-container-registry-select-${serviceIdx}`} style={{ width: '100%' }} getPopupContainer={(triggerNode) => triggerNode.parentNode} placeholder="Select container registry" value={!appData.basicDetails.containerRegistryId ? null : !appData.basicDetails.containerRegistryId.account_id ? `${appData.basicDetails.containerRegistryId.alias} - ${appData.basicDetails.containerRegistryId.integration_type}` : `${appData.basicDetails.containerRegistryId.account_id}${appData.basicDetails.containerRegistryId.alias ? `(${appData.basicDetails.containerRegistryId.alias})` : ``} / ${appData.basicDetails.containerRegistryId.region}`} onBlur={(value, event) => {
                                                // console.log('event["data-region"] :', event["data-region"]);
                                                // console.log('value :', value);
                                                containerRegs.map((val) => {
                                                    if ((val.alias === value) || (event["data-region"] === val.region)) {
                                                        // console.log('val :', val);
                                                        setAppData(appData => ({
                                                            ...appData,
                                                            basicDetails: {
                                                                ...appData.basicDetails,
                                                                containerRegistryId: val
                                                            }
                                                        }));
                                                    }
                                                })
                                            }}>
                                                {containerRegistryList}
                                            </Select>
                                        </Form.Item>
                                    </div> */}
                                </>}
                                {appData.basicDetails.sourceType === "Container Registry" && <>
                                    <div style={fieldStyles}>
                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                            <Label style={{ ...labelStyle }}> Image Tag* </Label>
                                            {/* <CustomInfoTooltip title={"Build context for this build is the root directory of the git repo."} placement="bottomLeft" /> */}
                                        </div>
                                        <div style={{ height: "44px" }}>
                                            <Form.Item
                                                name="imageTag"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please enter image tag!',
                                                    },
                                                ]}
                                            >
                                                {appData.basicDetails.appSource !== "PUBLIC" ?
                                                    <Select style={{ width: '100%' }}
                                                        showSearch
                                                        filterSort={(optionA, optionB) => customSortOptions(optionA, optionB, searchValue)} // Custom sorting function
                                                        filterOption={(inputValue, option) => customFilterOption(inputValue, option)} // Custom filtering function

                                                        optionLabelProp={appData.basicDetails.imageTag}
                                                        onSearch={(value) => {
                                                            console.log("Enters search", value);
                                                            setSearchValue(value);
                                                        }}
                                                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                                        data-testid="service-image-tag-select"
                                                        placeholder="Select image tag" value={(!appData.basicDetails?.imageTag || appData.basicDetails?.imageTag === "") ? null : appData.basicDetails.imageTag}
                                                        onChange={handleSelectChange}
                                                        disabled={updateDep}
                                                        notFoundContent={imageTagLoading && <Spin spinning={imageTagLoading} />}

                                                    >
                                                        {imageTagList}
                                                    </Select> :
                                                    <Input data-testid="service-image-tag-input" placeholder="Enter image tag" name="imageTag" value={appData.basicDetails?.imageTag} disabled={updateDep} onBlur={handleChange} style={{ ...inputStyle }} />
                                                }
                                            </Form.Item>

                                        </div>
                                    </div>
                                </>}
                            </div>
                            {appData.basicDetails.sourceType === "Git Repositories" && <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
                                {/* Commented for build context */}
                                <div style={fieldStyles}>
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <Label style={{ ...labelStyle }}> Container Registry* </Label>
                                        <CustomInfoTooltip title={deploymentHelpChecks.application.containerRegistryId} placement="bottomLeft" />
                                    </div>
                                    <Form.Item
                                        name="containerRegistryId"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please select a container registry!',
                                            },
                                            ...(hasApiError("containerRegistryId") ? [{ validator: customApiValidator }] : [])
                                        ]}
                                    >
                                        <Select style={{ width: '100%' }}
                                            showSearch
                                            filterSort={(optionA, optionB) => customSortOptions(optionA, optionB, searchValue)} // Custom sorting function
                                            filterOption={(inputValue, option) => customFilterOption(inputValue, option)} // Custom filtering function
                                            onSearch={(value) => {
                                                console.log("Enters search", value);
                                                setSearchValue(value);
                                            }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                            data-testid={`service-container-registry-input-${serviceIdx}`}
                                            placeholder="Select container registry"
                                            // value={!appData.basicDetails?.containerRegistryId ? null : !appData.basicDetails.containerRegistryId.account_id ? `${appData.basicDetails.containerRegistryId.alias} - ${appData.basicDetails.containerRegistryId.integration_type}` : `${appData.basicDetails.containerRegistryId.account_id}${appData.basicDetails.containerRegistryId.alias ? `(${appData.basicDetails.containerRegistryId.alias})` : ``} / ${appData.basicDetails.containerRegistryId.region}`}
                                            value={appData.basicDetails?.containerRegistryId?.id || undefined}
                                            onChange={(value, event) => {
                                                // Use find to get the full object based on the selected ID
                                                const selectedRegistry = containerRegs.find(val => val.id === value);
                                                if (selectedRegistry) {
                                                    setAppData(appData => ({
                                                        ...appData,
                                                        basicDetails: {
                                                            ...appData.basicDetails,
                                                            containerRegistryId: selectedRegistry
                                                        }
                                                    }));
                                                }
                                            }} disabled={updateDep}>
                                            {containerRegistryList}
                                        </Select>
                                    </Form.Item>
                                </div>
                                <div style={{ display: "flex", justifyContent: "space-between", width: "47%", height: "fit-content" }}>
                                    <div style={{ display: "flex" }}>
                                        <Label style={{ ...labelStyle }}> Enable CI/CD </Label>
                                        <CustomInfoTooltip title={deploymentHelpChecks.application.enableAutoTrigger} placement="bottomLeft" style={{ transform: "translateY(-2px)", marginLeft: "10px" }} />
                                    </div>
                                    {/* {<Input placeholder="Enter Variable here" style={inputStyle} value={appData.containerRegistryId} name="dockerFilePath" onBlur={handleChange} />} */}
                                    <Switch data-testid={`service-enable-cicd-switch-${serviceIdx}`} style={{ backgroundColor: appData.basicDetails.enableAutoTrigger && "#132f44" }} disabled={updateDep} checked={appData.basicDetails.enableAutoTrigger} onChange={(checked) => {
                                        setAppData(appData => ({
                                            ...appData,
                                            basicDetails: {
                                                ...appData.basicDetails,
                                                enableAutoTrigger: checked
                                            }
                                        }));
                                    }} />
                                </div>
                            </div>}
                            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
                                <div style={fieldStyles}>
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <Label style={{ ...labelStyle }}> Architecture Type* </Label>
                                        <CustomInfoTooltip title={"Select the CPU architecture (ARM or AMD) the application image is built and run for."} placement="bottomLeft" />
                                    </div>
                                    <Select style={{ width: '100%' }}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                        data-testid={`service-architecture-type-select-${serviceIdx}`}
                                        placeholder="Select architecture type"
                                        disabled={updateDep && appData.basicDetails.sourceType === "Container Registry"}
                                        value={appData.basicDetails?.architectureType || undefined}
                                        onChange={(value) => {
                                            setAppData(appData => ({
                                                ...appData,
                                                basicDetails: {
                                                    ...appData.basicDetails,
                                                    architectureType: value
                                                }
                                            }));
                                        }}>
                                        <Option key="amd64" name="architectureType" value="amd64">AMD</Option>
                                        <Option key="arm64" name="architectureType" value="arm64">ARM</Option>
                                    </Select>
                                </div>
                            </div>
                            {/* <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button style={{ marginRight: "10px", border: "1px solid #132f44", color: "#132f44", height: "20px", fontSize: "16px", fontFamily: "Nunito Sans", fontWeight: "600" }}> Cancel </Button>
                        <Button style={{ background: "#132f44", color: "white", height: "20px", border: "1px solid #132f44", fontSize: "16px", fontFamily: "Nunito Sans", fontWeight: "600" }} onClick={() => {
                            handleSaveAndNext(1);
                        }}> Save & Next</Button>
                    </div> */}
                        </div>}
                        {error && error.status && <p className="isoHelperText">  {error.msg} </p>}
                    </Box>
                </div>
                {/* {executeEnvs && <div style={{ marginBottom: "40px", cursor: "pointer" }} onClick={() => { */}
                {<div style={{ marginBottom: "40px" }}>
                    <Box title={
                        <div style={{ display: "flex", justifyContent: "space-between" }} >
                            <div style={{ display: "flex" }}>
                                <p style={{ ...innerTitleStyle, marginRight: "20px" }}> Environment Variables
                                    {/* {currentTaskAccountDetails !== "Atmosly" && currentProjectDep?.tasks?.[serviceIdx]?.secret_name && <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <span style={{ fontSize: "12px", textWrap: "nowrap", marginRight: "10px" }}>Secret name: {currentProjectDep?.tasks?.[serviceIdx]?.secret_name}</span>
                                        <i className="ion-android-create" style={{ display: "flex", justifyContent: "center", fontSize: "20px", color: "#4482FF", marginRight: "12px", cursor: "pointer", opacity: "1" }} onClick={() => handleChangeSecretName()} />
                                    </div>} */}
                                </p>
                                {errorVars !== 0 && <div style={{ borderRadius: "100%", border: "1px solid red", backgroundColor: "red", color: "white", fontFamily: "Poppins", padding: "0 8px", height: "fit-content", width: "fit-content", marginRight: "10px" }}>{errorVars}</div>}
                                {newVars !== 0 && <div style={{ borderRadius: "100%", border: "1px solid #4D99EF", backgroundColor: "#4D99EF", color: "white", fontFamily: "Poppins", padding: "0 8px", height: "fit-content", width: "fit-content" }}>{newVars}</div>}
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                {currentTaskAccountDetails && <div style={{ display: "flex", alignItems: "center" }}>
                                    <Box title="Selected provider for secrets management" titleStyle={secretTitleStyle} style={{ margin: "0 10px", padding: "0", border: "0" }} />
                                    <Button onClick={handleChangeSource} style={{ marginRight: "20px", borderColor: "#132f44", color: "#132f44", cursor: "pointer" }}>
                                        <div style={{ display: "flex", justifyContent: "start", alignItems: "center", width: "100%" }}>
                                        {/* {console.log("Entering atmosly: ", currentTaskAccountDetails)} */}
                                        {currentTaskAccountDetails?.account_id && <img src={currentTaskAccountDetails?.integration == 13 ? gcpSecretManagerLogo : awsSecretManagerLogo} style={{ marginRight: "8px", width: "14px", height: "14px", borderRadius: "100%" }} />}
                                        <span>{`${currentTaskAccountDetails?.account_id ? `${currentTaskAccountDetails?.account_id}` : `Atmosly >`}`}</span>
                                        </div>
                                    </Button>
                                </div>}
                                <img src={!allOptions.envVars ? downIcon : upIcon} style={{ width: "12px", height: "16px", cursor: "pointer" }} onClick={() => {
                                    let options = {
                                        ...allOptions,
                                        envVars: !allOptions.envVars,
                                    };
                                    setAllOptions({
                                        ...options,
                                    });
                                }} />
                            </div>
                        </div>
                    } titleStyle={innerTitleStyle} style={{ borderRadius: "20px" }}>
                        {/* {console.log("My key: ", serviceIdx)} */}
                        
                        {
                            updateDep && allOptions.envVars && showBuildTimeNotification && <CustomAlert
                                // showIcon
                                type={"onlyInfo"}
                                // message={"You are viewing run-time environment variables. Build-time environment variables are managed in the workflow. Go to Workflow."}
                                description={<span style={{ fontWeight: "400", fontSize: "14px", fontFamily: "Nunito Sans" }}>You are viewing Run-Time environment variables. Build-Time environment variables are managed in the workflow. Go to <b style={{ cursor: "pointer", color: "#6486EE", textDecoration: "underline" }} onClick={(e) => {
                                    e.stopPropagation();
                                    let tempService = updatedData?.selectedEnv?.services.filter((temp) => temp.service_id?.toString() === serviceSelected.id?.toString())?.[0];
                                    if (tempService?.service_id && tempService?.workflow_unique_id) {
                                        window.open(`${process.env.REACT_APP_GOOGLE_REDIRECT_URI}/application-blueprint/application/${tempService.service_id}/workflow/${tempService.workflow_unique_id}?to=Env Vars`, "_blank");
                                    }
                                }}>Workflow</b>.</span>}
                                style={{
                                    marginBottom: "10px"
                                }}
                                closable
                                onClose={() => {
                                    setShowBuildTimeNotification(false);
                                }}
                            />
                        }
                        {console.log("My key executeEnvs: ", executeEnvs)}
                        {executeEnvs && <EnvironmentVariablesDep serviceIdx={serviceIdx} valueFromDropdown={valueFromDropdown} setValueFromDropdown={setValueFromDropdown} executeEnvs={executeEnvs} setExecuteEnvs={setExecuteEnvs} serviceSelected={serviceSelected} appData={appData} setAppData={setAppData} setAppFromEnv={setAppFromEnv} allOptions={allOptions} />}
                    </Box>
                </div>}
                <div style={{ marginBottom: "40px", cursor: "pointer" }} onClick={() => {
                    // setOptionsSelected(optionsSelected => ({
                    //     ...optionsSelected,
                    //     deployments: !optionsSelected.deployments
                    // }));

                    //commented for now to implement new design

                    // let options = {
                    //     // basicDetails: false,
                    //     // envVars: false,
                    //     ...allOptions,
                    //     deployments: !allOptions.deployments,
                    //     //volumes: false
                    // };

                    // setAllOptions({
                    //     ...options,
                    // });
                    // setApplicationKey(3);
                }}>
                    {/* <Box title={
                        <div style={{ display: "flex", justifyContent: "space-between", cursor: "pointer" }}>
                            <p> Deployment </p>
                            <img src={!allOptions.deployments ? downIcon : upIcon} style={{ width: "12px", height: "16px" }} />
                        </div>
                    } titleStyle={innerTitleStyle} style={{ borderRadius: "20px" }}> */}
                    {console.log("Getting app data and deployments option: ", form.getFieldsError(["yamlData"]), appData.deployments.deploymentOption)}
                    <Card
                        title={
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                {/* <p>Deployment</p> */}
                                {appData.deployments.deploymentOption === "yaml" ? <Dropdown menu={{ items, selectedKeys: [appData.deployments.yamlType], className: "yaml-dropdown", getPopupContainer: (triggerNode) => triggerNode.parentNode }} trigger={['click']}>
                                    <Button style={{ color: "#4d99ef", border: "1px solid #4d99ef", fontWeight: "600", fontSize: "14px", height: "27px", textAlign: "center", padding: "0 15px", borderRadius: "5px", marginTop: "2px" }}>
                                        <div style={{ transform: "translateY(-1px)" }}>
                                            <img src={fileIconSelected} style={{ height: "20px", width: "20px", marginRight: "7px", transform: "translateY(-1px)" }} alt="icon" />
                                            <span>{appData.deployments.yamlType}</span>
                                            <RightOutlined style={{ fontSize: "9px", marginLeft: "5px", fontWeight: "600", transform: "translateY(-1px)" }} />
                                        </div>
                                    </Button>
                                </Dropdown> : <p style={{...innerTitleStyle, marginTop: "2px"}}>Deployment</p>}
                                {/* <div>
                                    <Button name="visual" disabled={((updateDep || cloneDep) && appData.deployments.deploymentOption === "yaml")} style={{ height: "25px", textAlign: "center", marginRight: "10px", color: appData.deployments.deploymentOption === "visual" ? "#6486EE" : "#5E6366", border: appData.deployments.deploymentOption === "visual" ? "1px solid #6484EE" : "1px solid #5E6366", padding: "0 15px" }} onClick={(e) => {
                                        setAppData(appData => ({
                                            ...appData,
                                            deployments: {
                                                ...appData.deployments,
                                                deploymentOption: "visual"
                                            }
                                        }));
                                    }}>Visual</Button>
                                    <Button name="yaml" disabled={((updateDep || cloneDep) && appData.deployments.deploymentOption === "visual")} style={{ height: "25px", textAlign: "center", color: appData.deployments.deploymentOption === "yaml" ? "#6486EE" : "#5E6366", border: appData.deployments.deploymentOption === "yaml" ? "1px solid #6484EE" : "1px solid #5E6366", padding: "0 15px" }} onClick={(e) => {
                                        setAppData(appData => ({
                                            ...appData,
                                            deployments: {
                                                ...appData.deployments,
                                                deploymentOption: "yaml"
                                            }
                                        }));
                                    }}>YAML</Button>
                                </div> */}
                                <Segmented
                                    data-testid={`service-deployment-mode-toggle-${serviceIdx}`}
                                    value={appData?.deployments?.deploymentOption}
                                    onChange={(value) => {
                                        console.log("Selected value in Segmented :", value);
                                        setAppData((prev) => ({
                                            ...prev,
                                            deployments: {
                                                ...prev.deployments,
                                                deploymentOption: value,
                                            },
                                        }));
                                    }}
                                    options={[
                                        { label: "Form Editor", value: "visual", disabled: (updateDep || cloneDep) },   //  && appData.deployments.deploymentOption === "yaml"
                                        { label: "YAML Editor", value: "yaml", disabled: (updateDep || cloneDep) },   //  && appData.deployments.deploymentOption === "yaml"
                                    ]}
                                    style={{
                                        background: "#F1F5F9", // light background
                                        borderRadius: "999px", // pill shape
                                        padding: "2px",
                                        fontSize: "14px",
                                        fontWeight: "400",
                                    }}
                                    className="editor-toggle"
                                />
                            </div>
                        }
                        className="custom-card"
                        style={{
                            border: form.getFieldsError(["yamlData"])[0]?.errors.length > 0 && "1px solid #ff4d4f !important"
                        }}
                    >
                        {appData.deployments.deploymentOption === "visual" && allOptions.deployments && <div style={{ marginTop: "20px", cursor: "default" }} onClick={(e) => {
                            e.stopPropagation();
                        }}>
                            <div style={{ display: "flex" }}>
                                <div style={{ borderRadius: "100%", backgroundColor: depColor.services ? "#132f44" : "lightgray", display: "flex", justifyContent: "center", alignItems: "center", padding: "0 12px", marginRight: "10px" }}><p style={{ fontFamily: "Poppins", fontSize: "22px", fontWeight: "bold", color: "white" }}>1</p></div>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}><p style={{ ...headLabelStyle }}> Services </p></div>
                            </div>
                            <Box onClick={() => {
                                setDepColor({
                                    services: true,
                                    resources: false,
                                    taskSchedulers: false,
                                    tags: false
                                });
                            }} style={{ border: "1px solid #f3f3f3", borderRadius: "10px", padding: "20px 20px 0 20px", marginTop: "20px", backgroundColor: "#fbfbfb" }}>
                                <div style={{ display: 'flex', justifyContent: "space-between", marginBottom: "20px" }}>
                                    <div style={fieldStyles}>
                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                            <Label style={{ ...labelStyle }}> Service Port* </Label>
                                            <CustomInfoTooltip title={deploymentHelpChecks.application.port} placement="bottomLeft" />
                                        </div>
                                        <Form.Item
                                            name="port"
                                            rules={[
                                                {
                                                    validator: validatePort
                                                },
                                                {
                                                    validator: validateSpaces
                                                }
                                            ]}
                                        >
                                            <Input data-testid={`service-port-input-${serviceIdx}`} placeholder="Enter port" style={inputStyle} value={appData.deployments?.port} name="port" onBlur={handleChange} />
                                        </Form.Item>
                                    </div>
                                    <div style={fieldStyles}>
                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                            <Label style={{ ...labelStyle }}> Health Check Path </Label>
                                            <CustomInfoTooltip title={deploymentHelpChecks.application.healthCheckPath} placement="bottomLeft" />
                                        </div>
                                        <Form.Item name="healthCheckPath" rules={[
                                            {
                                                validator: validateSpaces
                                            }
                                        ]}>
                                            <Input data-testid={`service-health-check-path-input-${serviceIdx}`} placeholder="Enter health check path" style={{ ...inputStyle, paddingTop: "5px", width: "100%" }} name="healthCheckPath" value={appData.deployments?.healthCheckPath} onBlur={handleChange} />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: "space-between", marginBottom: "20px" }}>
                                    <div style={fieldStyles}>
                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                            <Label style={{ ...labelStyle }}> Endpoint Type* </Label>
                                            <CustomInfoTooltip title={deploymentHelpChecks.application.endpointType} placement="bottomLeft" />
                                        </div>
                                        {/* {<Input placeholder="Enter Type here" style={inputStyle} value={appData.deployments.port} name="type" onBlur={handleChange} />} */}
                                        <Form.Item
                                            name="endpointType"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please select an endpoint type!',
                                                },
                                            ]}
                                        >
                                            <Select data-testid={`service-endpoint-type-select-${serviceIdx}`} style={{ width: '100%' }} getPopupContainer={(triggerNode) => triggerNode.parentNode} placeholder="Select endpoint type" value={appData.deployments?.endpointType === "" ? null : appData.deployments.endpointType} onChange={handleSelectChange}>
                                                {deploymentTypes}
                                            </Select>
                                        </Form.Item>
                                    </div>
                                    {console.log("Endpoint type: ", appData.deployments.endpointType)}
                                    {appData.deployments.endpointType && appData.deployments.endpointType !== "Cluster IP" && <div style={fieldStyles}>
                                        <Label style={labelStyle}> Service Type* </Label>
                                        {/* {<Input placeholder="Enter Type here" style={inputStyle} value={appData.deployments.port} name="type" onBlur={handleChange} />} */}
                                        <Form.Item
                                            name="serviceType"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please select a service type!',
                                                },
                                                {
                                                    validator: validateType
                                                }
                                            ]}
                                        >
                                            <Select data-testid="service-type-select" style={{ width: '100%' }} getPopupContainer={(triggerNode) => triggerNode.parentNode} placeholder="Select service type" value={appData.deployments?.serviceType === "" ? null : appData.deployments.serviceType} onChange={handleSelectChange}>
                                                {serviceTypes}
                                            </Select>
                                        </Form.Item>
                                    </div>}
                                </div>
                                {appData.deployments.endpointType && appData.deployments.endpointType !== "Cluster IP" && appData.deployments.serviceType.includes("Existing Load Balancer") && <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div style={fieldStyles}>
                                        <Label style={labelStyle}> Domain{appData.deployments.endpointType && appData.deployments.endpointType !== "Cluster IP" && appData.deployments.serviceType.includes("Existing Load Balancer") ? '*' : ''} </Label>
                                        <Form.Item name="domain" style={{ marginBottom: (form.getFieldError('domainHostUrl').length > 0 || form.getFieldError('dns').length > 0) ? "24px" : "0px" }}>
                                            <Space.Compact style={{ width: "100%" }}>
                                                <Form.Item
                                                    name={"domainHostUrl"}
                                                    noStyle
                                                    rules={[
                                                        {
                                                            required: appData.deployments.endpointType && appData.deployments.endpointType !== "Cluster IP" && appData.deployments.serviceType.includes("Existing Load Balancer"),
                                                            message: 'Please enter a Domain!',
                                                        },
                                                        {
                                                            validator: validateSpaces
                                                        }
                                                    ]}
                                                >
                                                    <Input data-testid="service-domain-url-input" placeholder="Enter domain" style={{ ...inputStyle, width: "65%" }} value={appData.deployments?.domainHostUrl} name="domainHostUrl" 
                                                        suffix={<div>
                                                            {validateDomainStatus === "validating" && <span style={{ marginRight: "15px" }}><LoadingOutlined /></span>}
                                                        </div>}
                                                        /*suffix={<div>
                                                            {validateDomainStatus === "validating" && <span style={{ marginRight: "15px" }}><LoadingOutlined /></span>}
                                                            <span>{"." + depData.dns} </span>
                                                        </div>} */
                                                        // onBlur={handleChange}
                                                        onChange={handleChange}
                                                        onBlur={handleDomainBlur}
                                                    />
                                                </Form.Item>
                                                <Form.Item name={"dns"} noStyle rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please select a DNS Zone!'
                                                    },
                                                    {
                                                        validator: validateDNS
                                                    }]}>
                                                    <AutoComplete
                                                        ref={autoCompleteRef}
                                                        options={filteredOptions}
                                                        style={{ width: "35%", textAlign: "left", height: "44px" }}
                                                        variant="outlined"
                                                        onChange={(value, option) => {
                                                            console.log("My value inside autocomplete: ", value, option);
                                                            if (appData.deployments.domainHostUrl && value && option?.hostedAccount) {
                                                                dnsCheck(appData.deployments.domainHostUrl, value, option.hostedAccount, option.recordType, serviceSelected.name);
                                                            }
                                                            // ACM certificates are listed per hosted zone, so a zone change
                                                            // invalidates whatever was picked for the previous one.
                                                            form.setFieldValue('acmCertificate', "");
                                                            setAppData(appData => ({
                                                                ...appData,
                                                                deployments: {
                                                                    ...appData.deployments,
                                                                    dns: value,
                                                                    acmCertificate: "",
                                                                    recordType: option && Object.keys(option).length > 0 ? option.recordType : null,
                                                                    hostedAccount: option && Object.keys(option).length > 0 ? option.hostedAccount : null,
                                                                }
                                                            }));
                                                        }}
                                                        onSelect={() => autoCompleteRef.current.blur()}
                                                        suffixIcon={<DownOutlined style={{ pointerEvents: 'none' }} />}
                                                        data-testid="service-dns-zone-select"
                                                        placeholder="Select/Enter DNS Zone"
                                                        value={appData.deployments?.dns}
                                                        searchValue={searchValue}
                                                        onFocus={() => {
                                                            handleSearch("");
                                                        }}
                                                        // filterOption={(inputValue, option) => {
                                                        //     console.log("Input value...", inputValue);
                                                        //     return option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
                                                        // }
                                                        // }
                                                        onSearch={handleSearch}
                                                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                                    />
                                                </Form.Item>
                                            </Space.Compact>
                                        </Form.Item>
                                        {dnsMsg.error && (
                                            <CustomAlert
                                                showIcon
                                                type="warning"
                                                className="dns-warning-alert"
                                                message="Warning!"
                                                description={dnsMsg.msg}
                                                closable={false}
                                                style={{ margin: "8px 0px 24px", padding: "5px 12px" }}
                                            />
                                        )}
                                        {/* : dnsMsg.msg ? (
                                            <p style={{ color: "green" }}>{dnsMsg.msg}</p>
                                        ) : null} */}
                                    </div>
                                    <div style={fieldStyles}>
                                        <Label style={labelStyle}> Path{appData.deployments.endpointType && appData.deployments.endpointType !== "Cluster IP" && appData.deployments.serviceType.includes("Existing Load Balancer") ? '*' : ''} </Label>
                                        <Form.Item
                                            name="gPath"
                                            rules={[
                                                {
                                                    required: appData.deployments.endpointType && appData.deployments.endpointType !== "Cluster IP" && appData.deployments.serviceType.includes("Existing Load Balancer"),
                                                    message: 'Please select a path!',
                                                },
                                                {
                                                    validator: validatePrefix
                                                },
                                                {
                                                    validator: validateSpaces
                                                }
                                            ]}
                                        >
                                            <Input data-testid="service-gateway-path-input" placeholder="Enter path" style={inputStyle} value={appData.deployments?.gatewayHttps?.gPath} name="gPath" onBlur={handleChange} />
                                        </Form.Item>
                                    </div>
                                </div>}
                                {appData.deployments.endpointType && appData.deployments.endpointType !== "Cluster IP" && appData.deployments.serviceType === "Existing Load Balancer(ALB Ingress)" && appData.deployments.dns && <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div style={fieldStyles}>
                                        <Label style={labelStyle}> ACM Certificate* </Label>
                                        <Form.Item
                                            name="acmCertificate"
                                            rules={[
                                                {
                                                    required: appData.deployments.endpointType && appData.deployments.endpointType !== "Cluster IP" && appData.deployments.serviceType === "Existing Load Balancer(ALB Ingress)" && appData.deployments.dns,
                                                    message: 'Please select a certificate!',
                                                },
                                                {
                                                    validator: validateAcmCertificate
                                                }
                                            ]}
                                        >
                                            <Select
                                                data-testid="service-acm-certificate-select"
                                                options={[
                                                    ...(acmCerts.some((c) => (c.acm_certificate || "").toLowerCase() === `${appData.deployments.domainHostUrl}.${appData.deployments.dns}`.toLowerCase())
                                                        ? []
                                                        : [{ value: ACM_CREATE_NEW, label: ACM_CREATE_NEW }]),
                                                    ...acmCerts.map((cert) => ({ value: cert.acm_certificate, label: cert.acm_certificate }))
                                                ]}
                                                style={{ width: "100%", textAlign: "left", height: "44px" }}
                                                variant="outlined"
                                                suffixIcon={<DownOutlined style={{ pointerEvents: 'none' }} />}
                                                placeholder="Select a certificate or create a new one"
                                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                                onChange={(value) => setAppData(appData => ({
                                                    ...appData,
                                                    deployments: {
                                                        ...appData.deployments,
                                                        acmCertificate: value || ""
                                                    }
                                                }))}
                                            />
                                        </Form.Item>
                                    </div>
                                    <div style={fieldStyles} />
                                </div>}
                            </Box>

                            {appData.deployments.serviceType === "Gateway HTTPS" && (
                                <div style={{ padding: "0 0 0 20px" }}>
                                    {/* <Label style={labelStyle}> Custom Domain </Label>
                        <Switch style={{ backgroundColor: appData.deployments.customDomain && "#132f44" }} checked={appData.deployments.customDomain} onBlur={(checked) => {
                            setSwitchState(switchState => ({
                                ...switchState,
                                customDomain: checked ? "true" : "false"
                            }));
                            setAppData(appData => ({
                                ...appData,
                                deployments: {
                                    ...appData.deployments,
                                    customDomain: checked
                                }
                            }));
                        }} /> */}
                                    {/* <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
                                <div style={fieldStyles}>
                                    <Label style={subLabelStyle}> Domain </Label>
                                    <Input placeholder="Enter name here" style={inputStyle} value={appData.deployments.domainHostUrl} name="domainHostUrl" suffix={appData.deployments.domainHostName} onBlur={handleChange} />
                                </div>
                                <div style={fieldStyles}>
                                    <Label style={subLabelStyle}> Path </Label>
                                    <Input placeholder="Enter here" style={inputStyle} value={appData.deployments.gatewayHttps.gPath} name="gPath" onBlur={handleChange} />
                                </div>
                            </div>

                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
                                <div style={fieldStyles}>
                                    <Label style={subLabelStyle}> Port </Label>
                                    <Input placeholder="Enter" style={inputStyle} value={appData.deployments.gatewayHttps.gPort} name="gPort" onBlur={handleChange} />
                                </div>
                                <div style={fieldStyles}>
                                    <div style={{ width: "50%", display: "flex", justifyContent: "space-between" }}>
                                        <Label style={subLabelStyle}> Https </Label>
                                        <Switch style={{ backgroundColor: appData.deployments.gatewayHttps.https && "#132f44" }} checked={appData.deployments.gatewayHttps.https} onBlur={(checked) => {
                                            setAppData(appData => ({
                                                ...appData,
                                                deployments: {
                                                    ...appData.deployments,
                                                    gatewayHttps: {
                                                        ...appData.deployments.gatewayHttps,
                                                        https: checked
                                                    }
                                                }
                                            }));
                                        }} />
                                    </div>
                                </div>
                            </div> */}
                                </div>)}
                            {/* {appData.deployments.serviceType === "Load Balancer TCP" && (
                        <div style={{ padding: "0 0 0 20px" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
                                <div style={fieldStyles}>
                                    <Label style={subLabelStyle}> Load Balancer TCP </Label>
                                    <Input placeholder="Enter name here" style={inputStyle} value={appData.deployments.loadBalancer.tcp} name="tcp" onBlur={handleChange} />
                                </div>
                                <div style={fieldStyles}>
                                    <Label style={subLabelStyle}> Load Balancer UDP </Label>
                                    <Input placeholder="Enter here" style={inputStyle} value={appData.deployments.loadBalancer.udp} name="udp" onBlur={handleChange} />
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
                                <div style={fieldStyles}>
                                    <Label style={subLabelStyle}> Gateway HTTPS </Label>
                                    <Input placeholder="Enter" style={inputStyle} value={appData.deployments.loadBalancer.lHttps} name="lHttps" onBlur={handleChange} />
                                </div>
                            </div>
                        </div>
                    )} */}
                            {/* <div style={switchState.customDomain === "false" ? { ...subDivStyle, pointerEvents: "none", opacity: "0.5", marginBottom: "20px" } : { ...subDivStyle, marginBottom: "20px" }} aria-disabled={switchState.customDomain === "false" ? true : false}>
                        <Label style={subLabelStyle}> Domain Host URL </Label>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <Input placeholder="Enter Prefix" style={{ ...inputStyle, width: "48%" }} value={appData.deployments.domainHostUrl} name="domainHostUrl" onBlur={handleChange} />
                            <Input placeholder="Host Url" style={{ ...inputStyle, width: "48%" }} value={appData.deployments.domainHostName} name="domainHostName" onBlur={handleChange} />
                        </div>
                    </div> */}
                            <div style={{ marginBottom: "20px" }}>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div style={{ display: "flex", marginTop: "15px" }}>
                                        <div style={{ borderRadius: "100%", backgroundColor: depColor.resources ? "#132f44" : "lightgray", display: "flex", justifyContent: "center", alignItems: "center", padding: "0 10px", marginRight: "10px" }}><p style={{ fontFamily: "Poppins", fontSize: "22px", fontWeight: "bold", color: "white" }}>2</p></div>
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}><p style={{ ...headLabelStyle }}> Resources </p></div>
                                    </div>
                                    <Box onClick={() => {
                                        setDepColor({
                                            services: false,
                                            resources: true,
                                            taskSchedulers: false,
                                            tags: false
                                        });
                                    }} style={{ ...subDivStyle, marginTop: "20px", marginBottom: "20px", padding: "20px 20px 0 20px", border: "1px solid #f3f3f3", borderRadius: "10px", marginTop: "20px", backgroundColor: "#fbfbfb" }}>
                                        {/* <Label style={headLabelStyle}> CPU </Label> */}
                                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
                                            <div style={fieldStyles}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <Label style={{ ...subLabelStyle }}> Minimum CPU* </Label>
                                                    <CustomInfoTooltip title={deploymentHelpChecks.application.requestCpu} placement="bottomLeft" />
                                                </div>
                                                <Form.Item
                                                    name="requestCpu"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Please enter minimum cpu!',
                                                        },
                                                        {
                                                            validator: validateResources
                                                        },
                                                        {
                                                            validator: validateSpaces
                                                        }
                                                    ]}
                                                >
                                                    <Input data-testid={`service-cpu-request-input-${serviceIdx}`} placeholder="Enter minimum" style={inputStyle} value={appData.deployments?.resources && appData.deployments.resources.cpu.requestCpu} name="requestCpu" suffix="m" onBlur={handleChange} />
                                                </Form.Item>
                                            </div>
                                            <div style={fieldStyles}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <Label style={{ ...subLabelStyle }}> Maximum CPU* </Label>
                                                    <CustomInfoTooltip title={deploymentHelpChecks.application.limitCpu} placement="bottomLeft" />
                                                </div>
                                                <Form.Item
                                                    name="limitCpu"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Please enter maximum cpu!',
                                                        },
                                                        {
                                                            validator: validateResources
                                                        },
                                                        {
                                                            validator: validateSpaces
                                                        }
                                                    ]}
                                                >
                                                    <Input data-testid={`service-cpu-limit-input-${serviceIdx}`} placeholder="Enter maximum" style={inputStyle} value={appData.deployments?.resources && appData.deployments.resources.cpu.limitCpu} name="limitCpu" suffix="m" onBlur={handleChange} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        {/* <Label style={headLabelStyle}> Memory </Label> */}
                                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
                                            <div style={fieldStyles}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <Label style={{ ...subLabelStyle }}> Minimum Memory* </Label>
                                                    <CustomInfoTooltip title={deploymentHelpChecks.application.requestMem} placement="bottomLeft" />
                                                </div>
                                                <Form.Item
                                                    name="requestMem"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Please enter minimum memory!',
                                                        },
                                                        {
                                                            validator: validateResources
                                                        },
                                                        {
                                                            validator: validateSpaces
                                                        }
                                                    ]}
                                                >
                                                    <Input data-testid={`service-memory-request-input-${serviceIdx}`} placeholder="Enter minimum" style={inputStyle} value={appData.deployments?.resources && appData.deployments.resources.memory.requestMem} name="requestMem" suffix="Mi" onBlur={handleChange} />
                                                </Form.Item>
                                            </div>
                                            <div style={fieldStyles}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <Label style={{ ...subLabelStyle }}> Maximum Memory* </Label>
                                                    <CustomInfoTooltip title={deploymentHelpChecks.application.limitMem} placement="bottomLeft" />
                                                </div>
                                                <Form.Item
                                                    name="limitMem"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Please enter maximum memory!',
                                                        },
                                                        {
                                                            validator: validateResources
                                                        },
                                                        {
                                                            validator: validateSpaces
                                                        }
                                                    ]}
                                                >
                                                    <Input data-testid={`service-memory-limit-input-${serviceIdx}`} placeholder="Enter maximum" style={inputStyle} value={appData.deployments?.resources && appData.deployments.resources.memory.limitMem} name="limitMem" suffix="Mi" onBlur={handleChange} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
                                            <div style={fieldStyles}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <Label style={{ ...subLabelStyle }}> Minimum Replica* </Label>
                                                    <CustomInfoTooltip title={deploymentHelpChecks.application.minimumReplica} placement="bottomLeft" />
                                                </div>
                                                <Form.Item
                                                    name="minimumReplica"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Please enter minimum replica!',
                                                        },
                                                        // {
                                                        //     validator: validateMinReplica
                                                        // }
                                                    ]}
                                                >
                                                    <InputNumber data-testid={`service-min-replica-input-${serviceIdx}`} max={100000} placeholder="Choose" style={{ ...inputStyle, paddingTop: "5px", width: "100%" }} value={appData.deployments?.autoScaling && appData.deployments.autoScaling.autoScalingData.minimumReplica} onChange={handleNumberChange("minimumReplica")} />
                                                </Form.Item>
                                            </div>
                                            {depData?.provisioner !== 'imported' && (
                                                <div style={fieldStyles}>
                                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                            <Label style={{ ...subLabelStyle }}> Nodegroup Name* </Label>
                                                            <CustomInfoTooltip title={deploymentHelpChecks.application.nodegroupName} placement="bottomLeft" style={{ marginLeft: "10px" }} />
                                                        </div>
                                                        {refreshNodegroups ? <RefreshLoader src={refreshIcon} /> : <img src={refreshIcon} onClick={() => {
                                                            setRefreshNodegroups(true);
                                                            setAfterRefresh(true);
                                                        }} />}
                                                    </div>
                                                    <Form.Item name="nodeGroupName">
                                                        <Select
                                                            data-testid={`service-nodegroup-select-${serviceIdx}`}
                                                        mode="multiple"
                                                            placeholder="Select nodegroup name"
                                                            value={appData.deployments?.nodeGroupName === "" ? null : appData.deployments.nodeGroupName}
                                                            onChange={handleMultiSelectChange}
                                                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                                            style={{ width: "100%" }}
                                                        >
                                                            {nodeGroups}
                                                        </Select>
                                                    </Form.Item>
                                                </div>
                                            )}
                                            {depData?.provisioner === 'imported' && (
                                                <div style={fieldStyles}>
                                                    <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                            <Label style={{ ...subLabelStyle }}> Labels (optional) </Label>
                                                            <CustomInfoTooltip title={"Provide key=value pairs to influence scheduling (e.g., kubernetes.io/arch=amd64). Leave empty to let the cluster schedule freely."} placement="bottomLeft" style={{ marginLeft: "10px" }} />
                                                        </div>
                                                    </div>
                                                    <Form.List name="labels">
                                                        {(fields, { add, remove }) => (
                                                            <>
                                                                {fields.map(({ name, ...restField }, ind) => (
                                                                    <ContentHolder key={"label-" + ind} style={{ display: "flex", justifyContent: 'space-between', alignItems: 'center', marginTop: "0px" }}>
                                                                        <div style={{ width: "48%", marginRight: "10px" }}>
                                                                            <Form.Item name={[name, "name"]}>
                                                                                <Input name="labelName" id={ind} value={appData.deployments?.labels && appData.deployments?.labels[ind] && appData.deployments?.labels[ind]['name']} onBlur={(e) => { handleNodeSelectorChange(e, ind) }} placeholder="Key (e.g., kubernetes.io/arch)" style={{ ...inputStyle }} />
                                                                            </Form.Item>
                                                                        </div>
                                                                        <div style={{ width: "48%" }}>
                                                                            <Form.Item name={[name, "value"]}>
                                                                                <Input name="labelValue" id={ind} value={appData.deployments?.labels && appData.deployments?.labels[ind] && appData.deployments?.labels[ind]['value']} onBlur={(e) => { handleNodeSelectorChange(e, ind) }} placeholder="Value (e.g., amd64)" style={{ ...inputStyle }} />
                                                                            </Form.Item>
                                                                        </div>
                                                                        <Link id={ind} onClick={(e) => { remove(name); appData.deployments.labels.splice(e.currentTarget.id, 1); setAppData({ ...appData, deployments: appData.deployments }); }} style={{ marginLeft: "10px", transform: "translateY(-10px)" }}>
                                                                            <img src={deleteIcon} />
                                                                        </Link>
                                                                    </ContentHolder>
                                                                ))}
                                                                <div style={{ display: "flex", justifyContent: "flex-end", padding: "0 10px", marginBottom: "20px" }}>
                                                                    <Button onClick={() => { add(); appData.deployments.labels.push({ name: "", value: "" }); setAppData({ ...appData, deployments: appData.deployments }); }} style={{ backgroundColor: "#132f44", marginTop: "2px" }}>
                                                                        <p style={{ fontFamily: "Nunito Sans", fontSize: "14px", fontWeight: "600", color: "white" }}><PlusOutlined /> Add Label </p>
                                                                    </Button>
                                                                </div>
                                                            </>
                                                        )}
                                                    </Form.List>
                                                </div>
                                            )}
                                        </div>
                                        <div style={{ width: "47%", display: "flex", justifyContent: "space-between", marginBottom: "25px" }}>
                                            {console.log("Auto scaling: ", appData.deployments.autoScaling)}
                                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                <Label style={{ ...headLabelStyle }}> Auto Scaling </Label>
                                                <CustomInfoTooltip title={deploymentHelpChecks.application.autoScaling} placement="bottomLeft" style={{ marginLeft: "10px" }} />
                                            </div>
                                            <Switch data-testid={`service-autoscaling-switch-${serviceIdx}`} style={{ backgroundColor: appData.deployments.autoScaling.enabled && "#132f44" }} checked={appData.deployments.autoScaling.enabled} onChange={(checked) => {
                                                // setSwitchState(switchState => ({
                                                //     ...switchState,
                                                //     autoScaling: checked ? "true" : "false"
                                                // }));
                                                setAppData(appData => ({
                                                    ...appData,

                                                    deployments: {
                                                        ...appData.deployments,
                                                        autoScaling: {
                                                            ...appData.deployments.autoScaling,
                                                            enabled: checked,
                                                            maximumReplica: '',
                                                            cpuAuto: '',
                                                            memoryAuto: ''
                                                        }
                                                    }
                                                }));
                                                form.setFieldsValue({
                                                    'maximumReplica': '',
                                                    'cpuAuto': '',
                                                    'memoryAuto': ''
                                                });
                                            }} />
                                        </div>
                                        <div>
                                            {console.log("auto scaling: ", appData.deployments.autoScaling)}
                                            <div style={!appData.deployments.autoScaling.enabled ? { pointerEvents: "none", opacity: "0.5" } : {}} aria-disabled={!appData.deployments.autoScaling.enabled}>
                                                <div style={{ ...fieldStyles, display: "flex", marginBottom: "20px", justifyContent: "space-between" }}>
                                                    <div>
                                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                            <Label style={{ ...subLabelStyle }}> Maximum Replica{appData.deployments.autoScaling.enabled ? '*' : ''} </Label>
                                                            <CustomInfoTooltip title={deploymentHelpChecks.application.maximumReplica} placement="bottomLeft" />
                                                        </div>
                                                        <Form.Item
                                                            name="maximumReplica"
                                                            rules={[
                                                                {
                                                                    required: appData.deployments.autoScaling.enabled,
                                                                    message: 'Please enter maximum replicas!',
                                                                },
                                                                {
                                                                    validator: validateMaxReplica
                                                                }
                                                            ]}
                                                        >
                                                            <InputNumber data-testid={`service-max-replica-input-${serviceIdx}`} max={100000} placeholder="Choose" style={{ ...inputStyle, paddingTop: "5px", width: "100%" }} value={appData.deployments?.autoScaling?.autoScalingData?.maximumReplica} onChange={handleNumberChange("maximumReplica")} />
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                    <div style={{ display: "flex" }}>
                                                        <Label style={{ ...subLabelStyle }}> Auto Scaling Parameter </Label>
                                                        <CustomInfoTooltip title={deploymentHelpChecks.application.autoScalingParam} placement="bottomLeft" style={{ marginLeft: "10px" }} />
                                                    </div>
                                                    <div>
                                                        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
                                                            <div style={fieldStyles}>
                                                                <Label style={subLabelStyle}> CPU(%){appData.deployments.autoScaling.enabled ? '*' : ''} </Label>
                                                                <Form.Item
                                                                    name="cpuAuto"
                                                                    rules={[
                                                                        {
                                                                            required: appData.deployments.autoScaling.enabled,
                                                                            message: 'Please enter CPU percentage!',
                                                                        },
                                                                        {
                                                                            type: 'number',
                                                                            min: 1,
                                                                            max: 100,
                                                                            message: "CPU percentage should be between 1 and 100."
                                                                        },
                                                                        {
                                                                            validator: validatePercentage
                                                                        }
                                                                    ]}
                                                                >
                                                                    <InputNumber data-testid={`service-cpu-threshold-input-${serviceIdx}`} placeholder="70" style={{ ...inputStyle, paddingTop: "5px", width: "100%" }} value={appData.deployments?.autoScaling?.autoScalingData?.autoScalingParameter?.cpuAuto} onChange={handleNumberChange("cpuAuto")} />
                                                                </Form.Item>
                                                            </div>
                                                            <div style={fieldStyles}>
                                                                <Label style={subLabelStyle}> RAM(%){appData.deployments.autoScaling.enabled ? '*' : ''} </Label>
                                                                <Form.Item
                                                                    name="memoryAuto"
                                                                    rules={[
                                                                        {
                                                                            required: appData.deployments.autoScaling.enabled,
                                                                            message: 'Please enter RAM paercentage!',
                                                                        },
                                                                        {
                                                                            type: 'number',
                                                                            min: 1,
                                                                            max: 100,
                                                                            message: "RAM percentage should be between 1 and 100."
                                                                        },
                                                                        {
                                                                            validator: validatePercentage
                                                                        }
                                                                    ]}
                                                                >
                                                                    <InputNumber data-testid={`service-memory-threshold-input-${serviceIdx}`} placeholder="70" style={{ ...inputStyle, paddingTop: "5px", width: "100%" }} value={appData.deployments?.autoScaling?.autoScalingData?.autoScalingParameter?.memoryAuto} onChange={handleNumberChange("memoryAuto")} />
                                                                </Form.Item>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div style={fieldStyles}>
                                        <Label style={subLabelStyle}> CPU </Label>
                                        <InputNumber min={0} max={100000} placeholder="Enter value" style={{ ...inputStyle, paddingTop: "5px", width: "100%" }} value={appData.deployments.autoScaling.autoScalingData.autoScalingParameter.cpuAuto} onChange={handleNumberChange("cpuAuto")} />
                                    </div>
                                    <div style={fieldStyles}>
                                        <Label style={subLabelStyle}> Memory </Label>
                                        <InputNumber min={0} max={100000} placeholder="Enter value" style={{ ...inputStyle, paddingTop: "5px", width: "100%" }} value={appData.deployments.autoScaling.autoScalingData.autoScalingParameter.memoryAuto} onChange={handleNumberChange("memoryAuto")} />
                                    </div>
                                </div> */}
                                                </div>
                                            </div>
                                        </div>
                                        {/* <Label style={subLabelStyle}> Server Preference </Label>
                                <div style={{ display: "flex", width: "48%", marginBottom: "20px" }}>
                                    
                                    <Select style={{ width: '100%' }} placeholder="Select" value={appData.deployments.serverPreference === "" ? null : appData.deployments.serverPreference} onBlur={handleSelectChange}>
                                        {servicePreferences}
                                    </Select>
                                </div> */}
                                        {/* <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "20px" }}>
                                    <div style={{ border: "1px solid #D0D5DD", borderRadius: "10px", display: "flex", flexDirection: "column", width: "100%", padding: "20px" }}>
                                        <div style={{ display: "flex", justifyContent: "space-between", width: "90%" }}>
                                            <div></div>
                                            <div style={{ display: "flex", width: "60%", justifyContent: "space-between" }}>
                                                <div style={{ width: "47%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                    <Label style={{ fontSize: "10px" }}> Request </Label>
                                                </div>
                                                <div style={{ width: "47%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                    <Label style={{ fontSize: "10px" }}> Limit </Label>
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "space-between", width: "90%" }}>
                                            <Label style={subLabelStyle}> CPU (m) </Label>
                                            <div style={{ display: "flex", width: "60%", justifyContent: "space-between" }}>
                                                <Input style={{ marginBottom: "20px", width: "47%", textAlign: "center" }} value={appData.deployments.resources.cpu.requestCpu} name="requestCpu" onBlur={handleChange} />
                                                <Input style={{ marginBottom: "20px", width: "47%", textAlign: "center" }} value={appData.deployments.resources.cpu.limitCpu} name="limitCpu" onBlur={handleChange} />
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "space-between", width: "90%" }}>
                                            <Label style={subLabelStyle}> Memory (Mi) </Label>
                                            <div style={{ display: "flex", width: "60%", justifyContent: "space-between" }}>
                                                <Input style={{ marginBottom: "20px", width: "47%", textAlign: "center" }} value={appData.deployments.resources.memory.requestMem} name="requestMem" onBlur={handleChange} />
                                                <Input style={{ marginBottom: "20px", width: "47%", textAlign: "center" }} value={appData.deployments.resources.memory.limitMem} name="limitMem" onBlur={handleChange} />
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                    </Box>
                                </div>
                                <div>
                                    <div style={{ width: "100%" }}>
                                        <div style={{ display: "flex", marginTop: "15px" }}>
                                            <div style={{ borderRadius: "100%", backgroundColor: depColor.tags ? "#132f44" : "lightgray", display: "flex", justifyContent: "center", alignItems: "center", padding: "0 10px", marginRight: "10px" }}><p style={{ fontFamily: "Poppins", fontSize: "22px", fontWeight: "bold", color: "white" }}>3</p></div>
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}><p style={{ ...headLabelStyle }}> Tags </p></div>
                                        </div>
                                        <Form.List name="tags">
                                            {(fields, { add, remove }) => (
                                                <>
                                                    <Box onClick={() => {
                                                        setDepColor({
                                                            services: false,
                                                            resources: false,
                                                            taskSchedulers: false,
                                                            tags: true
                                                        });
                                                    }} style={{ border: "1px solid #f3f3f3", borderRadius: "10px", paddingTop: "0", marginTop: "20px", padding: "20px 20px 0 20px", backgroundColor: "#fbfbfb" }}>
                                                        {fields.map(({ name, ...restField }, ind) => (
                                                            <ContentHolder key={"tag-" + ind} style={{ display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                                                                <div style={{ width: "48%" }}>
                                                                    <Form.Item
                                                                        name={[name, "name"]}
                                                                        rules={[
                                                                            {
                                                                                required: appData?.deployments?.tags?.[ind]?.['value'] !== "",
                                                                                message: 'Please enter a name for this tag!',
                                                                            },
                                                                            {
                                                                                validator: (_, value) => {
                                                                                    const interestingItems = new Set(["environment", "name", "provider"]);
                                                                                    let regExp = new RegExp(/^[a-z0-9]+$/i);
                                                                                    if (value && value !== "") {
                                                                                        value = value.replace(/\s/g, '');
                                                                                    }
                                                                                    if (value === "" || !value) {
                                                                                        return Promise.resolve();
                                                                                    }
                                                                                    else if (regExp.test(value)) {
                                                                                        if (!value || value === "" || !interestingItems.has(value.toLowerCase())) {
                                                                                            return Promise.resolve();
                                                                                        }
                                                                                        else {
                                                                                            return Promise.reject(new Error("A tag name can not be 'environment', 'name' or 'provider'."));
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        return Promise.reject(new Error("A label can only have alphanumeric characters."));
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                validator: validateSpaces
                                                                            }
                                                                        ]}
                                                                    >
                                                                        <Input
                                                                            data-testid={`service-tag-name-input-${serviceIdx}`}
                                                                            name="name"
                                                                            id={ind}
                                                                            value={appData.deployments?.tags[ind] && appData.deployments?.tags[ind]['name']}
                                                                            onBlur={(e) => { handleChange(e, ind) }}
                                                                            placeholder="Name"
                                                                            style={{ ...inputStyle }}
                                                                        />

                                                                    </Form.Item>
                                                                </div>
                                                                <div style={{ width: "48%" }}>
                                                                    <Form.Item
                                                                        name={[name, "value"]}
                                                                        rules={[
                                                                            {
                                                                                required: appData.deployments?.tags?.[ind]?.['name'] !== "",
                                                                                message: 'Please enter a value for this tag!',
                                                                            },
                                                                            {
                                                                                validator: (_, value) => {
                                                                                    const interestingItems = new Set(["environment", "name", "provider"]);
                                                                                    let regExp = new RegExp(/^[a-z0-9]+$/i);
                                                                                    if (value && value !== "") {
                                                                                        value = value.replace(/\s/g, '');
                                                                                    } if (value === "" || !value) {
                                                                                        return Promise.resolve();
                                                                                    }
                                                                                    else if (regExp.test(value)) {
                                                                                        if (!value || value === "" || !interestingItems.has(value.toLowerCase())) {
                                                                                            return Promise.resolve();
                                                                                        }
                                                                                        else {
                                                                                            return Promise.reject(new Error("A tag name can not be 'environment', 'name' or 'provider'."));
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        return Promise.reject(new Error("A label can only have alphanumeric characters."));
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                validator: validateSpaces
                                                                            }
                                                                        ]}
                                                                    >
                                                                        <Input
                                                                            data-testid={`service-tag-value-input-${serviceIdx}`}
                                                                            name="value"
                                                                            id={ind}
                                                                            value={appData.deployments?.tags[ind] && appData.deployments?.tags[ind]['value']}
                                                                            onBlur={(e) => { handleChange(e, ind) }}
                                                                            placeholder="Value"
                                                                            style={{ ...inputStyle, margin: "0 10px" }}
                                                                        />
                                                                    </Form.Item>
                                                                </div>
                                                                {ind === 0 && appData.deployments.tags[ind]?.name && appData.deployments.tags[ind]?.value && <Link id={ind} onClick={(e) => {
                                                                    if (appData.deployments.tags.length === 1) {
                                                                        appData.deployments.tags[e.currentTarget.id] = {
                                                                            name: "",
                                                                            value: ""
                                                                        };

                                                                        setAppData({ ...appData, deployments: appData.deployments });
                                                                        setRemoveIcon(true);
                                                                        const updatedItems = form.getFieldsValue().tags.map((item, idx) =>
                                                                            ind === idx ? { name: "", value: "" } : item
                                                                        );
                                                                        console.log("My updated items: ", updatedItems);
                                                                        form.setFieldValue("tags", updatedItems);
                                                                    }
                                                                    else {
                                                                        remove(name);
                                                                        appData.deployments.tags.splice(e.currentTarget.id, 1);
                                                                        setAppData({ ...appData, deployments: appData.deployments });
                                                                        setRemoveIcon(false);
                                                                    }
                                                                }} style={{ marginLeft: "10px", transform: "translateY(-10px)" }}>
                                                                    <img src={deleteIcon} />
                                                                </Link>}
                                                                {ind !== 0 && <Link id={ind} onClick={(e) => {
                                                                    remove(name);
                                                                    appData.deployments.tags.splice(e.currentTarget.id, 1);
                                                                    setAppData({ ...appData, deployments: appData.deployments });
                                                                    const tags = appData.deployments.tags || [];
                                                                    if (tags.length > 1) {
                                                                        setRemoveIcon(false);
                                                                    }
                                                                    else {
                                                                        const firstTag = tags[0];
                                                                        if (firstTag && firstTag.name === "" && firstTag.value === "") {
                                                                            setRemoveIcon(true);
                                                                        }
                                                                        else {
                                                                            setRemoveIcon(false);
                                                                        }
                                                                    }
                                                                }} style={{ marginLeft: "10px", transform: "translateY(-10px)" }}>
                                                                    <img src={deleteIcon} />
                                                                </Link>}
                                                            </ContentHolder>
                                                        ))}
                                                        <div style={{ display: "flex", justifyContent: "flex-end", padding: "0 10px", marginBottom: "20px" }}>
                                                            <Button onClick={(e) => {
                                                                add();
                                                                appData.deployments.tags.push({
                                                                    name: "",
                                                                    value: ""
                                                                });
                                                                setAppData({ ...appData, deployments: appData.deployments });
                                                                setRemoveIcon(false);
                                                            }}
                                                                style={{
                                                                    backgroundColor: "#132f44", marginTop: "20px"
                                                                }}><p style={{ fontFamily: "Nunito Sans", fontSize: "14px", fontWeight: "600", color: "white" }}><PlusOutlined /> Add Tags </p></Button>
                                                        </div>
                                                    </Box>
                                                </>
                                            )}
                                        </Form.List>
                                    </div>
                                </div>
                            </div>
                        </div>}
                        {/* {console.log("appData.deployments :", appData?.deployments.deploymentOption)}
                        {console.log("appData.deployments :", appData?.deployments?.deploymentOption === "yaml")}
                        {console.log("yamlContent :", yamlContent)}
                        {console.log("yamlContent :", (yamlContent.Deployment === yamlData || yamlContent["Job & CronJob"] === yamlData || yamlContent.StatefulSet === yamlData))} */}
                        {appData.deployments.deploymentOption === "yaml" && <div>
                            {/* {(yamlContent.Deployment === yamlData || yamlContent["Job & CronJob"] === yamlData || yamlContent.StatefulSet === yamlData) && <div> */}
                            {<div>
                                {/* <InfoCircleFilled style={{ color: "#8896A1" }} /> */}
                                {/* <span style={{ fontSize: "12px", marginLeft: "6px", marginBottom: "10px", fontFamily: "Nunito Sans" }}>This is a sample YAML file that provides a basic structure for deployment configurations. You can use it as a starting point and modify the content to match your specific requirements.</span> */}
                                <Alert
                                    showIcon
                                    icon={<WarningFilled style={{ color: "#4C99EF", fontSize: "14px", transform: collapsedShowYamlAlert ? "" : "translateY(5px)" }} />}
                                    type={"info"}
                                    message={<span style={{color: "#4C99EF", fontSize: "14px", fontWeight: "600"}}>Atmosly Template Variables</span>}
                                    description={
                                        !collapsedShowYamlAlert && <div style={{ display: "flex", flexDirection: "column", fontSize: "14px", fontWeight: "300" }}>
                                            You can use special variables in your YAML to enable dynamic overrides during deployment.
                                            <b style={{ textDecoration: "underline", cursor: "pointer", fontWeight: "500" }} onClick={openDrawer}>Click here to see supported variables</b>
                                        </div>
                                    }
                                    // onClose={() => {
                                    // }}
                                    action={
                                        <Space direction="vertical" size={"middle"}>
                                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                                {collapsedShowYamlAlert ? <DownOutlined style={{ cursor: "pointer" }} onClick={() => {
                                                    setCollapsedShowYamlAlert(false);
                                                }} /> : <UpOutlined style={{ cursor: "pointer" }} onClick={() => {
                                                    setCollapsedShowYamlAlert(true);
                                                }} />
                                                }
                                            </div>
                                            {/* <div>
                                                {collapsedShowYamlAlert && <a style={{ border: "none", background: "transparent", color: "#faad14", textDecoration: "none", transform: "translateY(10px)" }} onClick={() => goToGuardrail()}>Go To Guardrail</a>}
                                            </div> */}
                                        </Space>
                                    }
                                    style={{
                                        marginBottom: "20px",
                                        color: "#4C99EF"
                                    }}
                                />
                            </div>}
                            {console.log("YAML form: ", form.getFieldsValue("yamlData"))}
                            <Form.Item name="yamlData" rules={[{ required: true, message: "Please fill yaml content to proceed." }]} getValueFromEvent={(e) => e} valuePropName="value">
                                {/* <Suspense> */}
                                <CodeViewGeneral /*onChange={form.getFieldValue('yamlData')}*/ data={yamlData} setData={setYamlData} height={"400px"} customPadding={"0"} readOnly={false} form={form} resizable />
                                {/* </Suspense> */}
                            </Form.Item>
                            {/* <Box style={{border: "0", padding: "0"}}>
                                <p key={idx} className="isoHelperText"></p>
                            </Box> */}
                            <div style={{ position: "relative", height: "50px" }}>
                                <Button style={{ position: "absolute", right: "0", backgroundColor: "#132f44", fontFamily: "Nunito Sans", fontSize: "14px", fontWeight: "600", color: "white", marginTop: "20px" }} onClick={async () => {
                                    try {
                                        const myDepData = updateDep ? updatedData.deploymentData : addDep ? addUpdatedData.deploymentData : cloneDep ? cloneDeploymentData : deploymentData;
                                        let myData = await validateYaml(yamlData, myDepData.clusterId, updateDep, myDepData.clusterNamespace, true, form);
                                        toggleAlert("success", "Validation Successful", "YAML file has been validated successfully.");
                                    }
                                    catch (err) {
                                        console.log("Error thrown", err);
                                        toggleAlert("error", "Validation Unsuccessful", yamlErrorList(err).join(" "));
                                    }
                                }}>Validate K8s YAML</Button>
                            </div>
                        </div>}
                    </Card>
                    {/* </Box> */}
                </div>

                {/* <Box title={
                    <div style={{ display: "flex", justifyContent: "space-between", cursor: "pointer" }} onClick={() => {
                        // setOptionsSelected(optionsSelected => ({
                        //     ...optionsSelected,
                        //     volumes: !optionsSelected.volumes
                        // }));
                        let options = {
                            // basicDetails: false,
                            // envVars: false,
                            // deployments: false,
                            ...allOptions.application,
                            volumes: allOptions.application.volumes
                        };
                        options["volumes"] = !options["volumes"];

                        setAllOptions((allOptions) => ({
                            ...allOptions,
                            application: options
                        }));
                        setApplicationKey(2);
                    }}>
                        <p> Volumes </p>
                        <img src={!allOptions.application.volumes ? downIcon : upIcon} style={{ cursor: "pointer", width: "12px", height: "16px" }} />
                    </div>
                } titleStyle={innerTitleStyle} style={{ borderRadius: "20px" }}>
                    {allOptions.application.volumes &&
                        <></>}
                </Box> */}
                {appData.deployments.deploymentOption === "visual" && <div style={{ marginBottom: "40px", cursor: "pointer" }} onClick={() => {
                    // setOptionsSelected(optionsSelected => ({
                    //     ...optionsSelected,
                    //     volumes: !optionsSelected.volumes
                    // }));
                    let options = {
                        // basicDetails: false,
                        // envVars: false,
                        // deployments: false,
                        ...allOptions,
                        advancedSettings: !allOptions.advancedSettings
                    };
                    setAllOptions({
                        ...options,
                    });
                }}>
                    <Box title={
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <p> Advanced Settings </p>
                            <img data-testid={`service-advanced-settings-icon-${serviceIdx}`} src={!allOptions.advancedSettings ? downIcon : upIcon} style={{ width: "12px", height: "16px" }} />
                        </div>
                    } titleStyle={innerTitleStyle} style={{ borderRadius: "20px" }}>

                        {allOptions.advancedSettings && <div style={{ marginTop: "20px", cursor: "default" }} onClick={(e) => {
                            e.stopPropagation();
                        }}>
                            <div style={{ display: "flex" }}>
                                <div style={{ borderRadius: "100%", backgroundColor: depColor.volumes ? "#132f44" : "lightgray", display: "flex", justifyContent: "center", alignItems: "center", padding: "0 12px", marginRight: "10px" }}><p style={{ fontFamily: "Poppins", fontSize: "22px", fontWeight: "bold", color: "white" }}>1</p></div>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}><p style={{ ...headLabelStyle }}> Volumes </p></div>
                            </div>
                            <div onClick={() => {
                                setDepColor({
                                    services: false,
                                    resources: false,
                                    taskSchedulers: false,
                                    tags: false,
                                    volumes: true
                                });
                            }}>
                                <Form.List name="volumeList">
                                    {(fields, { add, remove }) => (
                                        <>
                                            <div style={{ marginTop: "20px" }}>
                                                {fields.map(({ key, name, ...restField }, ind) => {
                                                    //  const isDisabled = appData.volumes[ind].disabled;
                                                    // {console.log("volume data:",appData.volumes[ind])}
                                                    return (<Box style={{ borderRadius: "10px", backgroundColor: "#fbfbfb" }}>
                                                        <div>
                                                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "25px" }}>
                                                                {/* <Label style={labelStyle}> Configure </Label>
                                        <Switch style={{ backgroundColor: switchState.configure === "true" && "#132f44" }} checked={appData.volumes[ind].config.configEnabled} onBlur={(checked) => {
                                            setSwitchState(switchState => ({
                                                ...switchState,
                                                configure: checked ? "true" : "false"
                                            }));
                                            // setAppData(appData => ({
                                            //     ...appData,
                                            //     [appData.volumes[ind]]: {
                                            //         ...appData.volumes,
                                            //         config: {
                                            //             ...appData.volumes[ind].config,
                                            //             configEnabled: checked
                                            //         }
                                            //     }
                                            // }));
                                            appData.volumes[ind].config.configEnabled = checked;
                                            setAppData({ ...appData });
                                            
                                        }} /> */}
                                                                <div style={{ width: "100%", display: "flex" }}>
                                                                    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                                                        <Label style={labelStyle}> Volume Type </Label>
                                                                        <div style={{ width: "100%" }}>
                                                                            <Select data-testid={`service-volume-type-select-${serviceIdx}`} style={{ width: '47%' }} id={ind} disabled={volList ? appData.volumes[ind]?.disabled : ""} placeholder="Select Volume Type" getPopupContainer={(triggerNode) => triggerNode.parentNode} value={appData.volumes[ind]?.volumeType === "" ? null : appData.volumes[ind]?.volumeType} onChange={(value, event) => { console.log("triggering: ", applicationData); handleSelectChange(value, event, ind); }}>
                                                                                {volumeTypes}
                                                                            </Select>
                                                                        </div>
                                                                    </div>
                                                                    {console.log(applicationData)}
                                                                    {ind === 0 && appData.volumes?.[ind]?.volumeType && <Link id={ind} onClick={(e) => {
                                                                        if (appData.volumes.length === 1) {
                                                                            appData.volumes[e.currentTarget.id] = {
                                                                                volumeType: "",
                                                                                config: {
                                                                                    configEnabled: false,
                                                                                    createConfig: "",
                                                                                    createMountPath: "",
                                                                                    configFileName: "",
                                                                                    configName: ""
                                                                                },
                                                                                storage: {
                                                                                    createStorage: false,
                                                                                    storageDes: {
                                                                                        name: "",
                                                                                        size: "",
                                                                                        type: "", //class
                                                                                        path: ""
                                                                                    }
                                                                                },
                                                                                secrets: {
                                                                                    secretsEnabled: false,
                                                                                    createSecrets: "",
                                                                                    createSecretsMountPath: "",
                                                                                    secretsFileName: "",
                                                                                    secretsName: ""
                                                                                }
                                                                            };

                                                                            setAppData({ ...appData, volumes: appData.volumes });
                                                                            setRemoveVolumeIcon(true);
                                                                        }
                                                                        else {
                                                                            remove(name);
                                                                            appData.volumes.splice(e.currentTarget.id, 1);
                                                                            setAppData({ ...appData, volumes: appData.volumes });
                                                                            setRemoveVolumeIcon(false);
                                                                        }
                                                                    }} style={{ marginRight: "10px" }}>
                                                                        <img src={deleteIcon} />
                                                                    </Link>}
                                                                    {ind !== 0 && <Link id={ind} onClick={(e) => {
                                                                        remove(name);
                                                                        appData.volumes.splice(e.currentTarget.id, 1);
                                                                        // appData.volumes[ind].disabled = false;
                                                                        setAppData({ ...appData, volumes: appData.volumes, });
                                                                        if (appData.volumes.length > 1) {
                                                                            setRemoveVolumeIcon(false);
                                                                        }
                                                                        else {
                                                                            if (appData.volumes[0].volumeType === "") {
                                                                                setRemoveVolumeIcon(true);
                                                                            }
                                                                            else {
                                                                                setRemoveVolumeIcon(false);
                                                                            }
                                                                        }
                                                                    }} style={{ marginRight: "10px" }}>
                                                                        <img src={deleteIcon} />
                                                                    </Link>}
                                                                </div>
                                                            </div>
                                                            {console.log("App data outer", appData)}
                                                            {appData.volumes[ind].volumeType === "Configmap" && <div aria-disabled={switchState.configure === "false" ? true : false}>
                                                                {console.log("App data inner", appData)}
                                                                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
                                                                    <div style={fieldStyles}>
                                                                        <Label style={subLabelStyle}> Name{appData.volumes[ind].volumeType && appData.volumes[ind].volumeType !== "" ? '*' : ''} </Label>
                                                                        <Form.Item
                                                                            name={[name, "configName"]}
                                                                            rules={[
                                                                                {
                                                                                    required: true,
                                                                                    message: 'Please enter a name for the selected volume type!',
                                                                                },
                                                                                {
                                                                                    validator: validateSpaces
                                                                                }
                                                                            ]}
                                                                        >
                                                                            <Input data-testid={`service-volume-name-input-${serviceIdx}`} placeholder="Enter name" style={inputStyle} disabled={appData.volumes[ind].disabled} value={appData.volumes[ind]?.config?.configName} name="configName" onBlur={(e) => {
                                                                                handleChange(e, ind);
                                                                            }} />
                                                                        </Form.Item>
                                                                    </div>
                                                                    <div style={fieldStyles}>
                                                                        <Label style={subLabelStyle}> Mount Path{appData.volumes[ind].volumeType && appData.volumes[ind].volumeType !== "" ? '*' : ''} </Label>
                                                                        <Form.Item
                                                                            name={[name, "createMountPath"]}
                                                                            rules={[
                                                                                {
                                                                                    required: true,
                                                                                    message: 'Please enter mount path for the selected volume type!',
                                                                                },
                                                                                {
                                                                                    validator: validateMountPath
                                                                                },
                                                                                {
                                                                                    validator: validateSpaces
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <Input data-testid={`service-volume-mount-path-input-${serviceIdx}`} placeholder="Enter mount path" style={inputStyle} disabled={appData.volumes[ind].disabled} value={appData.volumes[ind]?.config?.createMountPath} name="createMountPath" onBlur={(e) => {
                                                                                handleChange(e, ind);
                                                                            }} />
                                                                        </Form.Item>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <Label style={subLabelStyle}> Data{appData.volumes[ind].volumeType && appData.volumes[ind].volumeType !== "" ? '*' : ''} </Label>
                                                                    {/* <TextArea autoSize={{ minRows: 6, maxRows: 12 }} value={appData.volumes[ind].config.createConfig} placeholder="Enter Variable Here" style={{ marginBottom: "20px" }} name="createConfig" onBlur={handleChange} /> */}
                                                                    {/* <Textarea value={appData.volumes[ind].config.createConfig} placeholder="Enter Variable Here" style={{ marginBottom: "20px", height: "100px" }} name="createConfig" onBlur={handleChange} /> */}
                                                                </div>
                                                                <Form.Item
                                                                    name={[name, "createConfig"]}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: 'Please enter data for the secret!',
                                                                        },
                                                                        {
                                                                            validator: validateSpaces
                                                                        }
                                                                    ]}
                                                                >
                                                                    <TextArea
                                                                        data-testid={`service-volume-data-textarea-${serviceIdx}`}
                                                                        placeholder="Enter Data"
                                                                        autoSize={{ minRows: 6, maxRows: 12 }}
                                                                        name="createConfig"
                                                                        value={appData.volumes[ind]?.config?.createConfig}
                                                                        disabled={volList ? appData.volumes[ind]?.disabled : ""}
                                                                        onBlur={(e) => {
                                                                            handleChange(e, ind);
                                                                        }}
                                                                        style={{ marginBottom: "20px" }}
                                                                    />
                                                                </Form.Item>
                                                            </div>}
                                                            {appData.volumes[ind].volumeType === "Secrets" && <div aria-disabled={switchState.configure === "false" ? true : false}>
                                                                {console.log("App data inner", appData)}
                                                                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
                                                                    <div style={fieldStyles}>
                                                                        <Label style={subLabelStyle}> Name{appData.volumes[ind].volumeType && appData.volumes[ind].volumeType !== "" ? '*' : ''} </Label>
                                                                        <Form.Item
                                                                            name={[name, "secretsName"]}
                                                                            rules={[
                                                                                {
                                                                                    required: true,
                                                                                    message: 'Please enter a name for the selected volume!',
                                                                                },
                                                                                {
                                                                                    validator: validateSpaces
                                                                                }
                                                                            ]}
                                                                        >
                                                                            <Input data-testid={`service-secrets-name-input-${serviceIdx}`} placeholder="Enter name" style={inputStyle} disabled={volList ? appData.volumes[ind]?.disabled : ""} value={appData.volumes[ind]?.secrets?.secretsName} name="secretsName" onBlur={(e) => {
                                                                                handleChange(e, ind);
                                                                            }} />
                                                                        </Form.Item>
                                                                    </div>
                                                                    <div style={fieldStyles}>
                                                                        <Label style={subLabelStyle}> Mount Path{appData.volumes[ind].volumeType && appData.volumes[ind].volumeType !== "" ? '*' : ''} </Label>
                                                                        <Form.Item
                                                                            name={[name, "createSecretsMountPath"]}
                                                                            rules={[
                                                                                {
                                                                                    required: true,
                                                                                    message: 'Please enter a mount path!',
                                                                                },
                                                                                {
                                                                                    validator: validateMountPath
                                                                                },
                                                                                {
                                                                                    validator: validateSpaces
                                                                                }
                                                                            ]}
                                                                        >
                                                                            <Input data-testid={`service-secrets-mount-path-input-${serviceIdx}`} placeholder="Enter mount path" style={inputStyle} disabled={volList ? appData.volumes[ind]?.disabled : ""} value={appData.volumes[ind]?.secrets?.createSecretsMountPath} name="createSecretsMountPath" onBlur={(e) => {
                                                                                handleChange(e, ind);
                                                                            }} />
                                                                        </Form.Item>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <Label style={subLabelStyle}> Data{appData.volumes[ind].volumeType && appData.volumes[ind].volumeType !== "" ? '*' : ''} </Label>
                                                                    {/* <TextArea autoSize={{ minRows: 6, maxRows: 12 }} value={appData.volumes[ind].config.createConfig} placeholder="Enter Variable Here" style={{ marginBottom: "20px" }} name="createConfig" onBlur={handleChange} /> */}
                                                                    {/* <Textarea value={appData.volumes[ind].config.createConfig} placeholder="Enter Variable Here" style={{ marginBottom: "20px", height: "100px" }} name="createConfig" onBlur={handleChange} /> */}
                                                                </div>
                                                                <Form.Item
                                                                    name={[name, "createSecrets"]}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: 'Please enter data for the secret!',
                                                                        },
                                                                    ]}
                                                                >
                                                                    <TextArea
                                                                        data-testid={`service-secrets-data-textarea-${serviceIdx}`}
                                                                        placeholder="Enter Data"
                                                                        autoSize={{ minRows: 6, maxRows: 12 }}
                                                                        name="createSecrets"
                                                                        value={appData.volumes[ind]?.secrets?.createSecrets}
                                                                        disabled={volList ? appData.volumes[ind]?.disabled : ""}
                                                                        onBlur={(e) => {
                                                                            handleChange(e, ind);
                                                                        }}
                                                                        style={{ marginBottom: "20px" }}
                                                                    />
                                                                </Form.Item>
                                                            </div>}
                                                            {appData.volumes[ind].volumeType === "Storage" && <div>
                                                                {/* <div style={{ width: "20%", display: "flex", justifyContent: "space-between", marginBottom: "25px" }}>
                                        <Label style={labelStyle}> Create Storage </Label>
                                        <Switch style={{ backgroundColor: switchState.createStorage === "true" && "#132f44" }} checked={appData.volumes[ind].storage.createStorage} onBlur={(checked) => {
                                            setSwitchState(switchState => ({
                                                ...switchState,
                                                createStorage: checked ? "true" : "false"
                                            }));
                                            // setAppData(appData => ({
                                            //     ...appData,
                                            //     volumes: [{
                                            //         ...appData.volumes[ind],
                                            //         storage: {
                                            //             ...appData.volumes[ind].storage,
                                            //             createStorage: checked
                                            //         }
                                            //     }]
                                            // }));
                                            appData.volumes[ind].storage.createStorage = checked;
                                            setAppData({ ...appData });
                                        }} />
                                    </div> */}
                                                                {/* <div style={switchState.createStorage === "false" ? { ...subDivStyle, pointerEvents: "none", opacity: "0.5" } : { ...subDivStyle }} aria-disabled={switchState.createStorage === "false" ? true : false} aria-readonly="true">
                                        <Label style={subLabelStyle}> Storage </Label>
                                        <div style={{ display: "flex", marginBottom: "20px" }}>
                                            <Input placeholder="Size" style={{ ...inputStyle, marginRight: "10px" }} value={appData.volumes[ind].storage.storageDes.size} name="size" onBlur={handleChange} />
                                            <Input placeholder="Type" style={{ ...inputStyle, marginRight: "10px" }} value={appData.volumes[ind].storage.storageDes.type} name="type" onBlur={handleChange} />
                                            <Input placeholder="Path" style={{ ...inputStyle, marginRight: "10px" }} value={appData.volumes[ind].storage.storageDes.path} name="path" onBlur={handleChange} />
                                        </div>
                                    </div> */}

                                                                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
                                                                    <div style={fieldStyles}>
                                                                        <Label style={subLabelStyle}> Name{appData.volumes[ind].volumeType && appData.volumes[ind].volumeType !== "" ? '*' : ''} </Label>
                                                                        <Form.Item
                                                                            name={[name, "storageName"]}
                                                                            rules={[
                                                                                {
                                                                                    required: true,
                                                                                    message: 'Please enter a name for the selected volume!',
                                                                                },
                                                                                {
                                                                                    validator: validateSpaces
                                                                                }
                                                                            ]}
                                                                        >
                                                                            <Input data-testid={`service-storage-name-input-${serviceIdx}`} placeholder="Enter name" style={inputStyle} disabled={volList ? appData.volumes[ind]?.disabled : ""} value={appData.volumes[ind]?.storage?.storageDes?.storageName} name="storageName" onBlur={(e) => {
                                                                                handleChange(e, ind);
                                                                            }} />
                                                                        </Form.Item>
                                                                    </div>
                                                                    <div style={fieldStyles}>
                                                                        <Label style={subLabelStyle}> Class{appData.volumes[ind].volumeType && appData.volumes[ind].volumeType !== "" ? '*' : ''} </Label>
                                                                        {/* <Input placeholder="Enter Variable Here" style={inputStyle} value={appData.volumes[ind].storage.storageDes.type} name="type" onBlur={handleChange} /> */}
                                                                        <div style={{ width: "100%" }}>
                                                                            <Form.Item
                                                                                name={[name, "type"]}
                                                                                rules={[
                                                                                    {
                                                                                        required: true,
                                                                                        message: 'Please select type of storage!',
                                                                                    },
                                                                                ]}
                                                                            >
                                                                                <Select data-testid={`service-storage-class-select-${serviceIdx}`} placeholder="Select storage class" style={{ width: "100%" }} disabled={volList ? appData.volumes[ind]?.disabled : ""} getPopupContainer={(triggerNode) => triggerNode.parentNode} value={appData.volumes[ind]?.storage?.storageDes?.type === "" ? null : appData.volumes[ind].storage.storageDes.type} onChange={(event, value) => {
                                                                                    handleSelectChange(event, value, ind)
                                                                                }}>
                                                                                    {volumeClasses}
                                                                                </Select>
                                                                            </Form.Item>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
                                                                    <div style={fieldStyles}>
                                                                        <Label style={subLabelStyle}> Size{appData.volumes[ind].volumeType && appData.volumes[ind].volumeType !== "" ? '*' : ''} </Label>
                                                                        <Form.Item
                                                                            name={[name, "size"]}
                                                                            rules={[
                                                                                {
                                                                                    required: true,
                                                                                    message: 'Please enter size for the selected volume!',
                                                                                },
                                                                                {
                                                                                    validator: validateSize
                                                                                },
                                                                                {
                                                                                    validator: validateSpaces
                                                                                }
                                                                            ]}
                                                                        >
                                                                            <Input data-testid={`service-storage-size-input-${serviceIdx}`} placeholder="Enter size" style={inputStyle} disabled={volList ? appData.volumes[ind]?.disabled : ""} value={appData.volumes[ind]?.storage?.storageDes?.size} suffix="GB" name="size" onBlur={(e) => {
                                                                                handleChange(e, ind);
                                                                            }} />
                                                                        </Form.Item>
                                                                    </div>
                                                                    <div style={fieldStyles}>
                                                                        <Label style={subLabelStyle}> Mount Path{appData.volumes[ind].volumeType && appData.volumes[ind].volumeType !== "" ? '*' : ''} </Label>
                                                                        <Form.Item
                                                                            name={[name, "path"]}
                                                                            rules={[
                                                                                {
                                                                                    required: true,
                                                                                    message: 'Please enter a mount path!',
                                                                                },
                                                                                {
                                                                                    validator: validateMountPath
                                                                                },
                                                                                {
                                                                                    validator: validateSpaces
                                                                                }
                                                                            ]}
                                                                        >
                                                                            <Input data-testid={`service-storage-mount-path-input-${serviceIdx}`} placeholder="Enter mount path" style={inputStyle} disabled={volList ? appData.volumes[ind]?.disabled : ""} value={appData.volumes[ind]?.storage?.storageDes?.path} name="path" onBlur={(e) => {
                                                                                handleChange(e, ind);
                                                                            }} />
                                                                        </Form.Item>
                                                                    </div>
                                                                </div>
                                                            </div>}
                                                        </div>
                                                    </Box>);
                                                })}
                                                <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "20px" }}>
                                                    <Button onClick={(e) => {
                                                        add();
                                                        appData.volumes.push({
                                                            volumeType: "",
                                                            disabled: false,
                                                            // newCreated:true,
                                                            config: {
                                                                configEnabled: false,
                                                                createConfig: "",
                                                                createMountPath: "",
                                                                configFileName: "",
                                                                configName: ""
                                                            },
                                                            storage: {
                                                                createStorage: false,
                                                                storageDes: {
                                                                    name: "",
                                                                    size: "",
                                                                    type: "", //class
                                                                    path: ""
                                                                }
                                                            },
                                                            secrets: {
                                                                secretsEnabled: false,
                                                                createSecrets: "",
                                                                createSecretsMountPath: "",
                                                                secretsFileName: "",
                                                                secretsName: ""
                                                            }
                                                        });
                                                        setAppData({ ...appData, volumes: appData.volumes });
                                                    }}
                                                        style={{ marginRight: "10px", backgroundColor: "#132f44" }}
                                                    ><div> <p style={{ fontFamily: "Nunito Sans", fontSize: "14px", fontWeight: "600", color: "white" }}> <PlusOutlined style={{ color: "white", marginRight: "10px" }} /> Add Volumes </p> </div></Button>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </Form.List>
                            </div>
                            <div style={{ marginBottom: "20px" }}>
                                <div style={{ display: "flex", marginTop: "15px" }}>
                                    <div style={{ borderRadius: "100%", backgroundColor: depColor.taskSchedulers ? "#132f44" : "lightgray", display: "flex", justifyContent: "center", alignItems: "center", padding: "0 10px", marginRight: "10px" }}><p style={{ fontFamily: "Poppins", fontSize: "22px", fontWeight: "bold", color: "white" }}>2</p></div>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}><p style={{ ...headLabelStyle }}> Task Schedulers </p></div>
                                </div>
                                <Box onClick={() => {
                                    setDepColor({
                                        services: false,
                                        resources: false,
                                        taskSchedulers: true,
                                        tags: false
                                    });
                                }} style={{ border: "1px solid #f3f3f3", borderRadius: "10px", marginTop: "20px", padding: "20px 20px 0 20px", backgroundColor: "#fbfbfb" }}>
                                    <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
                                        {console.log("First app data: ", appData)}
                                        <div style={{ width: "20%", display: "flex", justifyContent: "space-between", marginBottom: "25px", width: "47%" }}>
                                            <Label style={headLabelStyle}> Crons </Label>
                                            <Switch data-testid={`service-crons-switch-${serviceIdx}`} style={{ backgroundColor: appData.deployments.taskSchedulers.crons && "#132f44" }} checked={appData.deployments.taskSchedulers.crons} onChange={(checked) => {
                                                setAppData(appData => ({
                                                    ...appData,

                                                    deployments: {
                                                        ...appData.deployments,
                                                        taskSchedulers: {
                                                            ...appData.deployments.taskSchedulers,
                                                            entryPointCommandCrons: "",
                                                            crons: checked
                                                        }
                                                    }
                                                }));
                                            }} />
                                        </div>
                                        <div style={{ width: "20%", display: "flex", justifyContent: "space-between", marginBottom: "25px", width: "47%" }}>
                                            <Label style={headLabelStyle}> Queues and Workers </Label>
                                            <Switch data-testid={`service-queues-workers-switch-${serviceIdx}`} style={{ backgroundColor: appData.deployments.taskSchedulers.queuesAndWorkers && "#132f44" }} checked={appData.deployments.taskSchedulers.queuesAndWorkers} onChange={(checked) => {

                                                setAppData(appData => ({
                                                    ...appData,

                                                    deployments: {
                                                        ...appData.deployments,
                                                        taskSchedulers: {
                                                            ...appData.deployments.taskSchedulers,
                                                            entryPointCommandQueues: "",
                                                            queuesAndWorkers: checked
                                                        }
                                                    }
                                                }));
                                            }} />
                                        </div>
                                    </div>
                                    <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                        <div style={!appData.deployments.taskSchedulers.crons ? { width: "47%", opacity: "0.7", pointerEvents: "none" } : { width: "47%" }}>
                                            <div>
                                                <Label style={subLabelStyle}> Entry Point Command(Enter foreground command only){appData.deployments.taskSchedulers.crons ? '*' : ''} </Label>
                                            </div>
                                            <Form.Item
                                                name="entryPointCommandCrons"
                                                rules={[
                                                    {
                                                        required: appData.deployments.taskSchedulers.crons,
                                                        message: 'Please enter entry point command!',
                                                    },
                                                ]}
                                            >
                                                <TextArea
                                                    data-testid={`service-crons-entry-point-command-textarea-${serviceIdx}`}
                                                    placeholder="Enter Command"
                                                    autoSize={{ minRows: 6, maxRows: 12 }}
                                                    name="entryPointCommandCrons"
                                                    value={appData.deployments?.taskSchedulers?.entryPointCommandCrons}
                                                    onBlur={(e) => {
                                                        handleChange(e);
                                                    }}
                                                />
                                            </Form.Item>
                                        </div>
                                        <div style={!appData.deployments.taskSchedulers.queuesAndWorkers ? { width: "47%", opacity: "0.7", pointerEvents: "none" } : { width: "47%" }}>
                                            <div>
                                                <Label style={subLabelStyle}> Entry Point Command(Enter foreground command only){appData.deployments.taskSchedulers.queuesAndWorkers ? '*' : ''} </Label>
                                            </div>
                                            <Form.Item
                                                name="entryPointCommandQueues"
                                                rules={[
                                                    {
                                                        required: appData.deployments.taskSchedulers.queuesAndWorkers,
                                                        message: 'Please enter entry point command!',
                                                    },
                                                ]}
                                            >
                                                <TextArea
                                                    data-testid={`service-queues-workers-entry-point-command-textarea-${serviceIdx}`}
                                                    placeholder="Enter Command"
                                                    autoSize={{ minRows: 6, maxRows: 12 }}
                                                    name="entryPointCommandQueues"
                                                    value={appData.deployments?.taskSchedulers?.entryPointCommandQueues}
                                                    onBlur={(e) => {
                                                        handleChange(e);
                                                    }} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </Box>
                            </div>
                        </div>}
                    </Box>
                </div>}

                {/* <Box title={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", cursor: "pointer" }} onClick={() => {
                    let options = {
                        ...allOptions.application,
                        pipelines: allOptions.application.pipelines,
                    };
                    options["pipelines"] = !options["pipelines"];

                    setAllOptions((allOptions) => ({
                        ...allOptions,
                        application: options
                    }));
                    setApplicationKey(4);
                }}>
                    <p> Pipeline </p>
                    <img src={!allOptions.application.pipelines ? downIcon : upIcon} style={{ cursor: "pointer", width: "12px", height: "12px" }} />
                </div>} titleStyle={innerTitleStyle} style={{ borderRadius: "20px", boxShadow: allOptions.application.pipelines ? "0 4px 4px 0 rgba(0, 0, 0, 0.25)" : "" }}>
                    {allOptions.application.pipelines && <div style={{ marginTop: "20px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "250px" }}>
                            <div style={fieldStyles}>
                                <Label style={labelStyle}> Agent Name </Label>
                                <Form.Item
                                    name="agentName"
                                    rules={[
                                        {
                                            required: false,
                                            message: 'Please select Agent Name!',
                                        },
                                    ]}
                                >
                                    <Select style={{ width: '100%' }} showSearch filterOption={filterBranches} placeholder="Select branch" value={appData.basicDetails.branch === "" ? null : appData.basicDetails.branch} onBlur={handleSelectChange}>
                                        {agentList}
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "250px", marginInline: "100px" }}>
                            <div style={{...fieldStyles, flexDirection: "row"}}>
                                    <span>
                                        <img src={pipelineSourceIcon} style={pipelineImgStyle} alt="source"  />
                                    </span>
                                    <span style={{position: "relative", display: "flex", alignItems: "center"}}>
                                        <hr style={hzLineStyle} />
                                        <img src={pipelinePlusIcon} style={plusImgStyle} alt="plus-icon" />
                                    </span>
                                    <span>
                                        <img src={pipelinePreBuildIcon} alt="source" style={pipelineImgStyle}  />
                                    </span>
                                    <span style={{position: "relative", display: "flex", alignItems: "center"}}>
                                        <hr style={hzLineStyle} />
                                        <img src={pipelinePlusIcon} style={plusImgStyle} alt="plus-icon" />
                                    </span>
                                    <span>
                                        <img src={pipelineBuildIcon} alt="source" style={pipelineImgStyle}  />
                                    </span>
                                    <span style={{position: "relative", display: "flex", alignItems: "center"}}>
                                        <hr style={hzLineStyle} />
                                        <img src={pipelinePlusIcon} style={plusImgStyle} alt="plus-icon" />
                                    </span>
                                    <span>
                                        <img src={pipelinePreBuildIcon} alt="source" style={pipelineImgStyle}  />
                                    </span>
                                    <span style={{position: "relative", display: "flex", alignItems: "center"}}>
                                        <hr style={hzLineStyle} />
                                        <img src={pipelinePlusIcon} style={plusImgStyle} alt="plus-icon" />
                                    </span>
                                    <span>
                                        <img src={pipelineDeployIcon} alt="source" style={pipelineImgStyle}  />
                                    </span>
                            </div>
                        </div>
                    </div>}
                    {error && error.status && <p className="isoHelperText">  {error.msg} </p>}
                </Box> */}

            </Form>
            {console.log("Current app Data", cloneApplicationData)}
            {console.log("Service enabled: ", appData.serviceEnabled, serviceSelected)}
            <div ref={buttonRef1}>
                {(!updateDep && (!cloneDep && !addDep && appData.serviceEnabled) ||
                    (cloneDep && appData.serviceEnabled) || (addDep && appData.serviceEnabled)) &&
                    /*(addDep && addUpdatedData.applicationData && addUpdatedData.applicationData[serviceSelected.name] && addUpdatedData.applicationData[serviceSelected.name].serviceEnabled)) &&*/
                    <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
                        <Button style={{ backgroundColor: "#132f44", marginTop: "20px", fontFamily: "Nunito Sans", fontSize: "14px", fontWeight: "600", color: "white" }} onClick={() => {
                            if (keySelected !== lastEnabledService) {
                                handleSave();
                            }
                            else {
                                setPrerequisite(true);
                                setIsSubmitted(true);
                                //handleSubmit();
                            }
                        }}> {(keySelected !== lastEnabledService) ? "Save and Next" : addDep ? "Deploy" : "Create Environment"}
                        </Button>
                    </div>}
            </div>
            {updateDep && <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
                <Button data-testid="service-cancel-button" name="cancel" onClick={handleCancelButton} style={{ marginTop: "20px", marginRight: "10px", border: "1px solid #132f44", color: "#12f44", fontSize: "14px", fontFamily: "Nunito Sans", fontWeight: "600", height: "44px" }}>
                    Cancel
                </Button>
                <Tooltip title={redeployTooltip}>
                    <Button data-testid={`service-redeploy-button-${serviceIdx}`} style={{ backgroundColor: redeployDisabled ? "#ccc" : "#132f44", marginTop: "20px", fontFamily: "Nunito Sans", fontSize: "14px", fontWeight: "600", color: "white", height: "44px" }} disabled={redeployDisabled} onClick={() => {
                        if (!redeployDisabled) {
                            handleSave();
                        }
                        //setPrerequisite(true);
                    }}> Re-deploy
                    </Button>
                </Tooltip>
            </div>}
        </div>
        // </Scrollbars>
    );
}, compareProps);